function throttle(func, limit) {
  let inThrottle;
  return function () {
    const args = arguments;
    const context = this;
    if (!inThrottle) {
      func.apply(context, args);
      inThrottle = true;
      setTimeout(() => inThrottle = false, limit);
    }
  }
}

var bodyScrollLockOptions = {
  reserveScrollBarGap: true,
};

// Define a global function to load a script
window.loadScript = function (url) {
  // Check if the script already exists
  var existingScript = document.querySelector(`script[src="${url}"]`);

  if (existingScript) {
    return;
  }

  // Create a new script element
  var script = document.createElement('script');
  script.src = url;
  document.body.appendChild(script);
};



var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
        cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

/**
 * DOM event delegator
 *
 * The delegator will listen
 * for events that bubble up
 * to the root node.
 *
 * @constructor
 * @param {Node|string} [root] The root node or a selector string matching the root node
 */
function Delegate(root) {
  /**
   * Maintain a map of listener
   * lists, keyed by event name.
   *
   * @type Object
   */
  this.listenerMap = [{}, {}];
  if (root) {
    this.root(root);
  }

  /** @type function() */
  this.handle = Delegate.prototype.handle.bind(this);

  // Cache of event listeners removed during an event cycle
  this._removedListeners = [];
}

/**
 * Start listening for events
 * on the provided DOM element
 *
 * @param  {Node|string} [root] The root node or a selector string matching the root node
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.root = function (root) {
  const listenerMap = this.listenerMap;
  let eventType;

  // Remove master event listeners
  if (this.rootElement) {
    for (eventType in listenerMap[1]) {
      if (listenerMap[1].hasOwnProperty(eventType)) {
        this.rootElement.removeEventListener(eventType, this.handle, true);
      }
    }
    for (eventType in listenerMap[0]) {
      if (listenerMap[0].hasOwnProperty(eventType)) {
        this.rootElement.removeEventListener(eventType, this.handle, false);
      }
    }
  }

  // If no root or root is not
  // a dom node, then remove internal
  // root reference and exit here
  if (!root || !root.addEventListener) {
    if (this.rootElement) {
      delete this.rootElement;
    }
    return this;
  }

  /**
   * The root node at which
   * listeners are attached.
   *
   * @type Node
   */
  this.rootElement = root;

  // Set up master event listeners
  for (eventType in listenerMap[1]) {
    if (listenerMap[1].hasOwnProperty(eventType)) {
      // Add the 'passive' option for scroll events
      const isScrollEvent = ["wheel", "mousewheel"].indexOf(eventType) !== -1;
      this.rootElement.addEventListener(eventType, this.handle, { capture: true, passive: isScrollEvent });
    }
  }
  for (eventType in listenerMap[0]) {
    if (listenerMap[0].hasOwnProperty(eventType)) {
      // Add the 'passive' option for scroll events
      const isScrollEvent = ["wheel", "mousewheel"].indexOf(eventType) !== -1;
      this.rootElement.addEventListener(eventType, this.handle, { capture: false, passive: isScrollEvent });
    }
  }

  return this;
};

/**
 * @param {string} eventType
 * @returns boolean
 */
Delegate.prototype.captureForType = function (eventType) {
  return (
      ["blur", "error", "focus", "load", "resize", "scroll"].indexOf(
          eventType
      ) !== -1
  );
};

/**
 * Attach a handler to one
 * event for all elements
 * that match the selector,
 * now or in the future
 *
 * The handler function receives
 * three arguments: the DOM event
 * object, the node that matched
 * the selector while the event
 * was bubbling and a reference
 * to itself. Within the handler,
 * 'this' is equal to the second
 * argument.
 *
 * The node that actually received
 * the event can be accessed via
 * 'event.target'.
 *
 * @param {string} eventType Listen for these events
 * @param {string|undefined} selector Only handle events on elements matching this selector, if undefined match root element
 * @param {function()} handler Handler function - event data passed here will be in event.data
 * @param {boolean} [useCapture] see 'useCapture' in <https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener>
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.on = function (eventType, selector, handler, useCapture) {
  let root;
  let listenerMap;
  let matcher;
  let matcherParam;

  if (!eventType) {
    throw new TypeError("Invalid event type: " + eventType);
  }

  // handler can be passed as
  // the second or third argument
  if (typeof selector === "function") {
    useCapture = handler;
    handler = selector;
    selector = null;
  }

  // Fallback to sensible defaults
  // if useCapture not set
  if (useCapture === undefined) {
    useCapture = this.captureForType(eventType);
  }

  if (typeof handler !== "function") {
    throw new TypeError("Handler must be a type of Function");
  }

  root = this.rootElement;
  listenerMap = this.listenerMap[useCapture ? 1 : 0];
  const isScrollEvent = ["wheel", "mousewheel", "touchstart", "touchmove"].indexOf(eventType) !== -1;

  // Add master handler for type if not created yet
  if (!listenerMap[eventType]) {
    if (root) {
      root.addEventListener(eventType, this.handle, { capture: useCapture, passive: isScrollEvent });
    }
    listenerMap[eventType] = [];
  }

  if (!selector) {
    matcherParam = null;

    // COMPLEX - matchesRoot needs to have access to
    // this.rootElement, so bind the function to this.
    matcher = matchesRoot.bind(this);

    // Compile a matcher for the given selector
  } else if (/^[a-z]+$/i.test(selector)) {
    matcherParam = selector;
    matcher = matchesTag;
  } else if (/^#[a-z0-9\-_]+$/i.test(selector)) {
    matcherParam = selector.slice(1);
    matcher = matchesId;
  } else {
    matcherParam = selector;
    matcher = Element.prototype.matches;
  }

  // Add to the list of listeners
  listenerMap[eventType].push({
    selector: selector,
    handler: handler,
    matcher: matcher,
    matcherParam: matcherParam,
  });

  return this;
};

/**
 * Remove an event handler
 * for elements that match
 * the selector, forever
 *
 * @param {string} [eventType] Remove handlers for events matching this type, considering the other parameters
 * @param {string} [selector] If this parameter is omitted, only handlers which match the other two will be removed
 * @param {function()} [handler] If this parameter is omitted, only handlers which match the previous two will be removed
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.off = function (eventType, selector, handler, useCapture) {
  let i;
  let listener;
  let listenerMap;
  let listenerList;
  let singleEventType;

  // Handler can be passed as
  // the second or third argument
  if (typeof selector === "function") {
    useCapture = handler;
    handler = selector;
    selector = null;
  }

  // If useCapture not set, remove
  // all event listeners
  if (useCapture === undefined) {
    this.off(eventType, selector, handler, true);
    this.off(eventType, selector, handler, false);
    return this;
  }

  listenerMap = this.listenerMap[useCapture ? 1 : 0];
  if (!eventType) {
    for (singleEventType in listenerMap) {
      if (listenerMap.hasOwnProperty(singleEventType)) {
        this.off(singleEventType, selector, handler);
      }
    }

    return this;
  }

  listenerList = listenerMap[eventType];
  if (!listenerList || !listenerList.length) {
    return this;
  }

  // Remove only parameter matches
  // if specified
  for (i = listenerList.length - 1; i >= 0; i--) {
    listener = listenerList[i];

    if (
        (!selector || selector === listener.selector) &&
        (!handler || handler === listener.handler)
    ) {
      this._removedListeners.push(listener);
      listenerList.splice(i, 1);
    }
  }

  // All listeners removed
  if (!listenerList.length) {
    delete listenerMap[eventType];

    // Remove the main handler
    if (this.rootElement) {
      this.rootElement.removeEventListener(eventType, this.handle, useCapture);
    }
  }

  return this;
};

/**
 * Handle an arbitrary event.
 *
 * @param {Event} event
 */
Delegate.prototype.handle = function (event) {
  let i;
  let l;
  const type = event.type;
  let root;
  let phase;
  let listener;
  let returned;
  let listenerList = [];
  let target;
  const eventIgnore = "ftLabsDelegateIgnore";

  if (event[eventIgnore] === true) {
    return;
  }

  target = event.target;

  // Hardcode value of Node.TEXT_NODE
  // as not defined in IE8
  if (target.nodeType === 3) {
    target = target.parentNode;
  }

  // Handle SVG <use> elements in IE
  if (target.correspondingUseElement) {
    target = target.correspondingUseElement;
  }

  root = this.rootElement;

  phase = event.eventPhase || (event.target !== event.currentTarget ? 3 : 2);

  // eslint-disable-next-line default-case
  switch (phase) {
    case 1: //Event.CAPTURING_PHASE:
      listenerList = this.listenerMap[1][type];
      break;
    case 2: //Event.AT_TARGET:
      if (this.listenerMap[0] && this.listenerMap[0][type]) {
        listenerList = listenerList.concat(this.listenerMap[0][type]);
      }
      if (this.listenerMap[1] && this.listenerMap[1][type]) {
        listenerList = listenerList.concat(this.listenerMap[1][type]);
      }
      break;
    case 3: //Event.BUBBLING_PHASE:
      listenerList = this.listenerMap[0][type];
      break;
  }

  let toFire = [];

  // Need to continuously check
  // that the specific list is
  // still populated in case one
  // of the callbacks actually
  // causes the list to be destroyed.
  l = listenerList.length;
  while (target && l) {
    for (i = 0; i < l; i++) {
      listener = listenerList[i];

      // Bail from this loop if
      // the length changed and
      // no more listeners are
      // defined between i and l.
      if (!listener) {
        break;
      }

      if (
          target.tagName &&
          ["button", "input", "select", "textarea"].indexOf(
              target.tagName.toLowerCase()
          ) > -1 &&
          target.hasAttribute("disabled")
      ) {
        // Remove things that have previously fired
        toFire = [];
      }
          // Check for match and fire
          // the event if there's one
          //
          // TODO:MCG:20120117: Need a way
          // to check if event#stopImmediatePropagation
      // was called. If so, break both loops.
      else if (listener.matcher.call(target, listener.matcherParam, target)) {
        toFire.push([event, target, listener]);
      }
    }

    // TODO:MCG:20120117: Need a way to
    // check if event#stopPropagation
    // was called. If so, break looping
    // through the DOM. Stop if the
    // delegation root has been reached
    if (target === root) {
      break;
    }

    l = listenerList.length;

    // Fall back to parentNode since SVG children have no parentElement in IE
    target = target.parentElement || target.parentNode;

    // Do not traverse up to document root when using parentNode, though
    if (target instanceof HTMLDocument) {
      break;
    }
  }

  let ret;

  for (i = 0; i < toFire.length; i++) {
    // Has it been removed during while the event function was fired
    if (this._removedListeners.indexOf(toFire[i][2]) > -1) {
      continue;
    }
    returned = this.fire.apply(this, toFire[i]);

    // Stop propagation to subsequent
    // callbacks if the callback returned
    // false
    if (returned === false) {
      toFire[i][0][eventIgnore] = true;
      toFire[i][0].preventDefault();
      ret = false;
      break;
    }
  }

  return ret;
};

/**
 * Fire a listener on a target.
 *
 * @param {Event} event
 * @param {Node} target
 * @param {Object} listener
 * @returns {boolean}
 */
Delegate.prototype.fire = function (event, target, listener) {
  return listener.handler.call(target, event, target);
};

/**
 * Check whether an element
 * matches a tag selector.
 *
 * Tags are NOT case-sensitive,
 * except in XML (and XML-based
 * languages such as XHTML).
 *
 * @param {string} tagName The tag name to test against
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesTag(tagName, element) {
  return tagName.toLowerCase() === element.tagName.toLowerCase();
}

/**
 * Check whether an element
 * matches the root.
 *
 * @param {?String} selector In this case this is always passed through as null and not used
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesRoot(selector, element) {
  if (this.rootElement === window) {
    return (
        // Match the outer document (dispatched from document)
        element === document ||
        // The <html> element (dispatched from document.body or document.documentElement)
        element === document.documentElement ||
        // Or the window itself (dispatched from window)
        element === window
    );
  }
  return this.rootElement === element;
}

/**
 * Check whether the ID of
 * the element in 'this'
 * matches the given ID.
 *
 * IDs are case-sensitive.
 *
 * @param {string} id The ID to test against
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesId(id, element) {
  return id === element.id;
}

/**
 * Short hand for off()
 * and root(), ie both
 * with no parameters
 *
 * @return void
 */
Delegate.prototype.destroy = function () {
  this.off();
  this.root();
};

class GlobalScrollListener {
  constructor() {
    this.callbacks = new Map();
    this.listenerIdCounter = 0;
    this.isListening = false;
    this.boundRunCallbacks = this.runCallbacks.bind(this);
  }

  addScrollListener(classInstance, func) {
    const id = ++this.listenerIdCounter;
    const keyBase = `${classInstance.constructor.name}_${func.name}_${id}`;
    const key = keyBase.replace(/ /g, '_'); // Replace spaces with underscores
    const boundFunction = func.bind(classInstance);

    this.callbacks.set(key, boundFunction);

    if (!this.isListening) {
      window.addEventListener("scroll", this.boundRunCallbacks, { passive: true });
      this.isListening = true;
    }

    return {
      removeScrollListener: () => this.removeScrollListenerFunction(key)
    };
  }

  removeScrollListenerFunction(key) {
    if (this.callbacks.has(key)) {
      this.callbacks.delete(key);
    }

    if (this.callbacks.size === 0 && this.isListening) {
      window.removeEventListener("scroll", this.boundRunCallbacks);
      this.isListening = false;
    }
  }

  runCallbacks() {
    this.callbacks.forEach(callback => callback());
  }
}

const scrollListener = new GlobalScrollListener();


class Responsive {
  constructor(enableGeneralBreakpointChange, trackWindowHeight) {
    this.settings();

    this.trackWindowHeight = trackWindowHeight;
    this.generalBreakpointChange = enableGeneralBreakpointChange;
    this.currentBreakpoint = this.getCurrentBreakpoint();
    this.breakpointListeners = new Map(); // Stores listeners with their status
    this.resizeCallbacks = new Map();
    this.listenerIdCounter = 0;

    this.setWindowHeight();
    this.initResizeListener();
  }

  initResizeListener() {
    this.boundHandleResize = this.handleResize.bind(this);
    window.addEventListener("resize", this.boundHandleResize);
  }

  settings() {
    this.matchBreakpoints = {
      phone: "(max-width: 640px)",
      tablet: "(min-width: 641px) and (max-width: 1024px)",
      tablet_and_up: "(min-width: 768px)",
      pocket: "(max-width: 1024px)",
      lap_and_up: "(min-width: 1025px)",
      desktop: "(min-width: 1280px)",
      desktop_wide: "(min-width: 1440px)",
    };

    this.currentBreakpoints = {
      phone: "(max-width: 640px)",
      pocket: "(max-width: 1024px)",
      tablet: "(min-width: 641px) and (max-width: 1024px)",
      desktop: "(min-width: 1025px)",
    };
  }

  handleResize() {
    const newBreakpoint = this.getCurrentBreakpoint();

    if (this.generalBreakpointChange) {
      // Check for general breakpoint change
      if (this.currentBreakpoint !== newBreakpoint) {
        document.dispatchEvent(
            new CustomEvent("breakpoint:changed", {
              detail: {
                previousBreakpoint: this.currentBreakpoint,
                currentBreakpoint: newBreakpoint,
              },
            })
        );
      }
    }

    // Additional check for specific breakpoint
    this.breakpointListeners.forEach((value, key) => {
      const isCurrentlyInBreakpoint = this.matchesBreakpoint(key);
      if (value !== isCurrentlyInBreakpoint) {
        this.breakpointListeners.set(key, isCurrentlyInBreakpoint);
        document.body.dispatchEvent(
            new CustomEvent(`breakpoint:${key}`, {
              detail: {
                matches: isCurrentlyInBreakpoint,
              },
            })
        );
      }
    });

    this.currentBreakpoint = newBreakpoint;

    this.setWindowHeight();

    // Run additional registered resize callbacks
    this.runCallbacks();
  }

  setWindowHeight() {
    if (this.trackWindowHeight) {
      document.documentElement.style.setProperty(
          "--window-height",
          `${window.innerHeight}px`
      );
    }
  }

  matchesBreakpoint(breakpoint) {
    const query = this.matchBreakpoints[breakpoint];
    return window.matchMedia(`screen and ${query}`).matches;
  }

  getCurrentBreakpoint() {
    for (const [key, query] of Object.entries(this.currentBreakpoints)) {
      if (window.matchMedia(`screen and ${query}`).matches) {
        return key;
      }
    }
  }

  addBreakpointListener(breakpoint) {
    if (!this.matchBreakpoints[breakpoint]) {
      console.error("Breakpoint does not exist:", breakpoint);
      return;
    }

    if (this.breakpointListeners.has(breakpoint)) {
      console.warn("Listener already exists for breakpoint:", breakpoint);
      return;
    }

    const isInBreakpoint = this.matchesBreakpoint(breakpoint);
    this.breakpointListeners.set(breakpoint, isInBreakpoint);
  }

  addResizeListener(classInstance, func) {
    const id = ++this.listenerIdCounter;
    const keyBase = `${classInstance.constructor.name}_${func.name}_${id}`;
    const key = keyBase.replace(/ /g, "_"); // Replace spaces with underscores
    const boundFunction = func.bind(classInstance);

    this.resizeCallbacks.set(key, boundFunction);

    return {
      removeResizeListener: () => this.removeResizeListenerFunction(key),
    };
  }

  removeResizeListenerFunction(key) {
    if (this.resizeCallbacks.has(key)) {
      this.resizeCallbacks.delete(key);
    }
  }

  runCallbacks() {
    this.resizeCallbacks.forEach((callback) => callback());
  }
}

const responsive = new Responsive(false, true);

class Popup {
  constructor(element) {
    this.element = element;
    this.delegateElement = new Delegate(this.element);
    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.bindEvents();
  }
  bindEvents() {
    this.delegateElement.on(
        "click",
        '[data-action="open-modal"]',
        this.openModal.bind(this)
    );
    this.delegateElement.on(
        "click",
        '[data-action="close-modal"]',
        this.closeModal.bind(this)
    );

    document.addEventListener("keydown", (event) => {
      if (event.key == "Escape" || event.keyCode == 27) {
        this.closeModal();
      }
    });

    document.addEventListener(
        "posted_successfully",
        this.openModalSpecial.bind(this)
    );

    this.onClickOutsideListener = this.closeModal.bind(this);
  }

  openModal(e) {
    e.preventDefault();
    e.stopPropagation();
    this.pageOverlayElement.classList.add("is-visible");
    this.activeModal = document.getElementById(
        event.target.closest("[aria-controls]").getAttribute("aria-controls")
    );

    if (e.target.getAttribute('aria-expanded') === 'false') {
      e.target.setAttribute('aria-expanded', 'true');
    }
    this.activeModal.setAttribute("aria-hidden", "false");
    this.activeModal.style.display = "block";
    this.pageOverlayElement.addEventListener(
        "click",
        this.onClickOutsideListener
    );
    var focus = this.element.querySelector("[data-scrollable]");

    setTimeout(() => {
      trapFocus(this.activeModal);
    }, 100);
    bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
  }
  openModalSpecial() {
    event.preventDefault();
    event.stopPropagation();
    this.pageOverlayElement.classList.add("is-visible");
    this.activeModal = document.getElementById(event.detail.id);
    this.activeModal.setAttribute("aria-hidden", "false");
    var focus = this.element.querySelector("[data-scrollable]");
    this.pageOverlayElement.addEventListener(
        "click",
        this.onClickOutsideListener
    );
    bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
    trapFocus(this.activeModal);
  }
  closeModal() {
    this.activeModal = document.body.querySelector(
        '.Popup[aria-hidden="false"]'
    );

    if (!this.activeModal) return;

    this.pageOverlayElement.classList.remove("is-visible");
    this.pageOverlayElement.removeEventListener(
        "click",
        this.onClickOutsideListener
    );
    this.activeModal.setAttribute("aria-hidden", "true");

    bodyScrollLock.clearAllBodyScrollLocks();
    this.activeModal.removeAttribute("style");
  }
}

class RevolutionImageZoom {
  constructor(element, slideshow) {
    this.element = element;
    this.slideshow = slideshow;
    this.delegateElement = new Delegate(this.element);
    this.delegateRoot = new Delegate(document.body);
    this.responsive = new Responsive();
    this.breakpoint = this.responsive.getCurrentBreakpoint();
    loadScript(window.theme.pswpScript);
    this.syncHeight();
    this.bindEvents();

  }

  syncHeight() {
    document.documentElement.style.setProperty(
        "--window-inner-height",
        `${window.innerHeight}px`
    );
  }

  bindEvents() {
    responsive.addResizeListener(this, this.syncHeight.bind(this));
    this.delegateElement.on(
        "click",
        '[data-action="open-product-zoom"]',
        this.initPhotoSwipe.bind(this)
    );
    this.delegateElement.on(
        "click",
        ".ProductSliderCell--Zoom",
        this.initPhotoSwipeFromImageClick.bind(this)
    );
    this.delegateRoot.on(
        "pswpTap",
        ".pswp__button--close",
        this.photoswiperClose.bind(this)
    );
  }
  photoswiperClose() {
    this.photoSwipeInstance.close;
    if (/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) {
      document.documentElement.classList.remove("pswp-open-in-ios");
    }
  }

  initPhotoSwipe() {
    var images = [],
        index = 0;
    if (this.slideshow) {
      this.slideshow.swiperElement.slides.forEach(function (item) {
        if (item.classList.contains("ProductSliderCell--Zoom")) {
          if (item.querySelector("img")) {
            images.push(item.querySelector("img"));
          }
        }
      });
      var index_currentSlide = this.slideshow.swiperElement.realIndex;
      this.slideshow.swiperElement.slides[index_currentSlide].querySelector('.ProductSlider--Element').getAttribute(
          'data-image-position'
      )
    } else {
      images.push(document.querySelector(".ProductSlider--Image"));
    }



    this.createPhotoSwipeInstance(
        this.createPhotoSwipeItemsFromImages(images),
        parseInt(index)
    );
  }

  initPhotoSwipeFromImageClick(event, target) {
    // Create an array of images from the siblings of the target element.
    const images = [];
    const siblings = Array.from(target.parentElement.children);

    siblings.forEach((item) => {
      if (item.classList.contains('ProductSliderCell--Zoom') && item.querySelector('img')) {
        images.push(item.querySelector('img'));
      }
    });

    // Get the image position from the target element's data attribute.
    const imagePosition = parseInt(target.querySelector('.ProductSlider--Element').getAttribute('data-image-position'));

    // Create the PhotoSwipe instance using the images and image position.
    this.createPhotoSwipeInstance(this.createPhotoSwipeItemsFromImages(images), imagePosition);
  }

  createPhotoSwipeItemsFromImages(images) {
    const maxAllowedWidth = 962;
    const targetHeight = window.innerHeight;

    return images.map(function (image) {
      const originalWidth = parseInt(image.getAttribute("data-max-width"));
      const originalHeight = parseInt(image.getAttribute("data-max-height"));

      // Step 1: Scale image to fill full height of screen
      let scaleFactor = originalHeight / targetHeight;
      let requestedHeight = targetHeight;
      let requestedWidth = Math.floor(originalWidth / scaleFactor);

      // Step 2: If the width is too big, scale down to fit width
      if (requestedWidth > maxAllowedWidth) {
        requestedWidth = maxAllowedWidth;
      }

      return {
        msrc: image.currentSrc || image.src,
        w: requestedWidth,
        h: requestedHeight,
        initialZoomLevel: 0.62,
        src: image.dataset.originalSrc,
      };
    });
  }





  createPhotoSwipeInstance(items, selectedImageIndex) {
    var _this = this;
    var photoswipeContainer = document.querySelector(".pswp");
    this.photoSwipeInstance = new PhotoSwipe(
        photoswipeContainer,
        false,
        items,
        {
          index: selectedImageIndex,
          showHideOpacity: true,
          showAnimationDuration: 500,
          loop: false,
          history: false,
          closeOnVerticalDrag: true,
          allowPanToNext: false,
          pinchToClose: false,
          errorMsg: '<p class="pswp__error-msg"></p>',
          scaleMode: "orig",
          getDoubleTapZoom: function getDoubleTapZoom(isMouseClick, item) {
            if (isMouseClick) {
              return 1.35;
            } else {
              return item.initialZoomLevel < 0.7 ? 1 : 1.33;
            }
          },
          getThumbBoundsFn: function getThumbBoundsFn(index) {
            var allThumbnail = _this.element.querySelectorAll(
                    ".mainSwiper .ProductSliderCell--Zoom img"
                ),
                thumbnail = allThumbnail[index],
                pageYScroll =
                    window.pageYOffset || document.documentElement.scrollTop,
                rect = thumbnail.getBoundingClientRect();
            return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
          },
        }
    );

    this.photoSwipeInstance.listen(
        "beforeChange",
        this.onslideChanged.bind(this)
    );
    this.photoSwipeInstance.listen(
        "destroy",
        this.destroyPhotoSwipe.bind(this)
    );
    this.photoSwipeInstance.listen("doubleTap", this.onDoubleTap.bind(this));
    this.photoSwipeInstance.listen(
        "initialZoomIn",
        this.onInitialZoomIn.bind(this)
    );
    this.photoSwipeInstance.listen(
        "initialZoomOut",
        this.onInitialZoomOut.bind(this)
    );

    this.delegateRoot.on(
        "pswpTap",
        ".pswp__scroll-wrap",
        this.onSingleTap.bind(this)
    );
    this.delegateRoot.on(
        "pswpTap",
        ".pswp__button--close",
        this.photoSwipeInstance.close
    );
    this.delegateRoot.on(
        "pswpTap",
        ".pswp__button--prev",
        this.photoSwipeInstance.prev
    );
    this.delegateRoot.on(
        "pswpTap",
        ".pswp__button--next",
        this.photoSwipeInstance.next
    );
    this.photoSwipeInstance.listen('close', this.photoswiperClose.bind(this));
    if (/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) {
      document.documentElement.classList.add("pswp-open-in-ios");
    }
    this.photoSwipeInstance.init();
  }

  onslideChanged() {
    if (this.photoSwipeInstance.getCurrentIndex() === 0) {
      this.photoSwipeInstance.scrollWrap
          .querySelector(".pswp__button--prev")
          .setAttribute("disabled", "disabled");
    } else {
      this.photoSwipeInstance.scrollWrap
          .querySelector(".pswp__button--prev")
          .removeAttribute("disabled");
    }

    if (
        this.photoSwipeInstance.getCurrentIndex() + 1 ===
        this.photoSwipeInstance.options.getNumItemsFn()
    ) {
      this.photoSwipeInstance.scrollWrap
          .querySelector(".pswp__button--next")
          .setAttribute("disabled", "disabled");
    } else {
      this.photoSwipeInstance.scrollWrap
          .querySelector(".pswp__button--next")
          .removeAttribute("disabled");
    }
  }

  onSingleTap(event) {
    if (!event.detail || event.detail.pointerType === "mouse") {
      if (event.target.classList.contains("pswp__img")) {
        this.photoSwipeInstance.toggleDesktopZoom(event.detail.releasePoint);
      }
    } else {
      if (event.target.classList.contains("pswp__button")) {
        return;
      }

      event.target
          .closest(".pswp")
          .querySelector(".pswp__ui")
          .classList.toggle("pswp__ui--hidden");
    }
  }

  onDoubleTap(point) {
    var initialZoomLevel = this.photoSwipeInstance.currItem.initialZoomLevel;

    if (this.photoSwipeInstance.getZoomLevel() !== initialZoomLevel) {
      this.photoSwipeInstance.zoomTo(initialZoomLevel, point, 333);
    } else {
      this.photoSwipeInstance.zoomTo(
          initialZoomLevel < 0.7 ? 1 : 1.33,
          point,
          333
      );
    }
  }

  onInitialZoomIn() {
    document.querySelector(".pswp__ui").classList.remove("pswp__ui--hidden");
  }
  onInitialZoomOut() {
    document.querySelector(".pswp__ui").classList.add("pswp__ui--hidden");
  }
  destroyPhotoSwipe() {
    this.delegateRoot.off("pswpTap");
    this.photoSwipeInstance = null;
  }
}
class RevolutionSelectbox {
  constructor(element, popover, additionalOverlay) {
    this.element = element;
    this.popover = popover;
    this.changeOverlay = additionalOverlay;
    this.domDelegate = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    this.dropdown = this.element.querySelector(".RevolutionSelectbox");
    this.isOpen = false;

    this.mainDropdown = this.element.querySelector(
        ".RevolutionSelectbox--Content"
    );
    this.languageSelector = this.element.classList.contains(
        "RevolutionSelectbox--Selectors"
    );

    this.mainDropdownContent = this.element.querySelector(
        ".RevolutionSelectbox--InnerContent"
    );
    this.mainButton = this.element.querySelector(
        ".RevolutionSelectbox--Button"
    );

    this.headerTransparent = document.body
        .querySelector("#header");

    if (this.headerTransparent) {
      this.headerTransparent.classList.contains("Header--Transparent")
          ? true
          : false;
    }


    this.connectedSelect = this.element.getAttribute("data-select");
    this.selectbox = this.element.querySelector(
        "[name=" + this.connectedSelect + "]"
    );

    if (this.selectbox == null) {
      this.selectbox = this.element.querySelector(
          "[name2=" + this.connectedSelect + "]"
      );
    }
    if (this.popover == true) {
      this.mainDropdown.classList.remove("RevolutionSelectbox--animation");
      this.mainDropdown.classList.add("PopoverContent");
      if (this.changeOverlay) {
        this.pageOverlayElement = document.querySelector(
            ".localizationOverlay"
        );
      } else {
        this.pageOverlayElement = document.querySelector(".pageOverlay");
      }
    }
    this.bindEvents();
    if (!this.element.classList.contains("dropdownSelector")) {
      this.initSelectbox();
    } else {
      this.element.style.display = "block";
    }
  }

  bindEvents() {
    this.closeListener = this.closeDropdown.bind(this);
    this.onClickOutsideListener = this.onClickOutside.bind(this);

    this.domDelegate.on(
        "click",
        "[data-action=toggle-selectbox]",
        this.toggleDropdown.bind(this)
    );

    this.domDelegate.on(
        "click",
        "[data-action=selectbox-change]",
        this.selectboxChange.bind(this)
    );



    if (this.element.classList.contains('rs-country__selectbox')) {
      this.delegateBody.on("close:language", this.onClickOutsideListener);
    }
    this.delegateBody.on("drawer:close-other", this.closeListener);
    this.delegateBody.on("menu:open", this.closeListener);
    this.domDelegate.on("click", "body", this.onClickOutsideListener);


    this.domDelegate.on(
        "click",
        "[data-action=selectbox-submit]",
        this.selectboxSubmit.bind(this)
    );
    this.domDelegate.on(
        "keypress",
        "[data-action=selectbox-submit]",
        this.selectboxSubmit.bind(this)
    );
  }

  findAndScrollToMatch(contentElement, searchQuery) {
    const items = Array.from(contentElement.querySelectorAll(".RevolutionSelectbox--Item"));

    const matchedItem = items.find(item => {
      const itemText = item.textContent.toLowerCase().trim();
      return itemText.startsWith(searchQuery.trim());
    });

    if (matchedItem) {
      matchedItem.focus();
    }
  }

  initSearchWithinDropdown(contentElement) {
    let searchQuery = "";

    this.keydownListener = (event) => {
      if (!this.resetQuery) {
        this.resetQuery = setTimeout(() => {
          searchQuery = "";
          this.resetQuery = null;
        }, 1000);
      }

      searchQuery += event.key.toLowerCase();
      if (searchQuery.length > 0) {
        this.findAndScrollToMatch(contentElement, searchQuery);
      }
    };

    window.addEventListener("keydown", this.keydownListener);
  }

  selectboxChange(event) {

    const value = event.target.getAttribute("data-value");
    const selectboxID = event.target.getAttribute("data-selectboxid");
    const selEl = this.element.querySelector("#" + selectboxID);

    const newFlag = event.target.querySelector(".revolution-selectbox__flag");
    const newTitle = event.target.querySelector(".revolution-selectbox__title")

    if (event.target.getAttribute("data-selectboxid") === 'country-selector__country-code') {
      if (this.mainButton.querySelector(".RevolutionSelectbox--Title")) {
        this.mainButton.querySelector(".RevolutionSelectbox--Title").innerHTML = newTitle?.innerHTML;
      }

      if (this.mainButton.querySelector('.revolution-selectbox__flag')) {
        this.mainButton.querySelector('.revolution-selectbox__flag').innerHTML = newFlag?.innerHTML;
      }
    } else {
      this.mainButton.querySelector(".RevolutionSelectbox--Title").innerHTML = event.target.innerHTML;
    }

    if (this.element.classList.contains("dropdownSelector")) {
      const selectedItem = this.element.querySelector('.RevolutionSelectbox--Item[selected="selected"]');
      if (selectedItem) {
        selectedItem.removeAttribute("selected");
      }
      event.target.setAttribute("selected", "selected");
    }

    if (selEl.nodeName == "SELECT") {

      selEl.value = value;
      selEl.dispatchEvent(new Event("change"));
    } else {
      selEl.value = value;
    }

    if (event.target.dataset.selectboxid == 'country-selector__country-code') {
      this.element.dispatchEvent(
          new CustomEvent("change:countrySelector", {
            bubbles: true,
            detail: {
              currency: event.target.dataset.currency,
              country: event.target.value,
              languages: event.target.dataset.languages
            },
          })
      );

    }


    this.closeDropdown(this.element);
  }

  onClickOutside(event) {
    const withinBoundaries = event.composedPath().includes(this.element);
    if (
        !withinBoundaries ||
        event.target.classList.contains("FiltersDesktopWrapper")
    ) {
      this.closeDropdown(this.element);
    }
  }



  selectboxSubmit(event) {
    if (event.key !== "Enter" && event.key !== undefined) {
      return;
    }

    const value = event.target.closest("[data-value]")?.getAttribute("data-value");
    const dataName = event.target.closest("[data-name]")?.getAttribute("data-name");

    if (!value || !dataName) return;

    this.selectbox.value = value;

    this.closeDropdown(this.element);

    const title = this.element.querySelector(".RevolutionSelectbox--Title");
    if (title) title.innerHTML = dataName;

    const form = this.selectbox.closest("form");
    if (form && typeof form.submit === "function") {
      form.submit();
    } else {
      console.warn("No form to submit or `submit` is not a function", form);
    }
  }




  initSelectbox() {
    if (!this.mainDropdown) return;
    const selectedItem = this.mainDropdown.querySelector('[selected="selected"]'),

        titleElement = this.element.querySelector(".RevolutionSelectbox--Title");
    if (selectedItem && this.connectedSelect != 'country_code') {
      titleElement.innerHTML = selectedItem.getAttribute("data-name");
    }

    trapFocus(this.element);
    this.element.style.display = "block";
  }

  toggleDropdown(event, target) {
    event.preventDefault();

    if (this.isOpen) {
      this.closeDropdown(target);

    } else {
      this.openDropdown(target);
    }
  }

  openDropdown(target) {

    const closestSelectbox = target.closest('.rs-country__selectbox');
    if (closestSelectbox) {
      closestSelectbox.setAttribute('aria-expanded', 'true')
    }
    // Dispatch "close:search" and "menu:close" events on the element.
    this.element.dispatchEvent(
        new CustomEvent("close:search", { bubbles: true })
    );




    if (this.changeOverlay) {
      var focus = this.element.querySelector("[data-scrollable]");
      bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
    }

    // Find all siblings with class ".RevolutionSelectbox".
    const siblings = Array.from(
        target.parentElement.parentElement.children
    ).filter((item) => item.classList.contains("RevolutionSelectbox"));



    // Hide the dropdown content for all siblings.
    siblings.forEach((item) => {
      item
          .querySelector(".RevolutionSelectbox--Button")
          .setAttribute("aria-expanded", false);
      item
          .querySelector(".RevolutionSelectbox--Content")
          .setAttribute("aria-hidden", true);
      item.querySelector(".RevolutionSelectbox--Content").style.display =
          "none";
    });



    // If the dropdown is a popover, show the page overlay and disable body scrolling.
    if (this.popover) {
      this.pageOverlayElement.classList.add("is-visible");
      const headerOverlay = document.querySelector(".header-overlay");
      if (headerOverlay) {
        headerOverlay.classList.add("is-visible");
      }
      this.pageOverlayElement.addEventListener(
          "click",
          this.onClickOutsideListener
      );

      trapFocus(this.mainDropdown);
    }

    if (this.element.closest(".focusable.country-selector")) {
      const focus = this.element.querySelector("[data-scrollable]");
      bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
    }

    // Show the dropdown content for the target element and set its state to "expanded".
    const contentElement = target.parentElement.querySelector(
        ".RevolutionSelectbox--Content"
    );
    contentElement.style.display = "block";
    contentElement.style.visibility = 'hidden';


    requestAnimationFrame(() => {
      contentElement.style.height = '';
      const height = contentElement.offsetHeight;
      contentElement.style.width = '';
      const width = contentElement.offsetWidth;
      contentElement.style.height = '0';
      contentElement.style.visibility = 'visible';

      requestAnimationFrame(() => {
        contentElement.style.height = `${height}px`;
        contentElement.style.width = `${width - 16}px`;
      });
    });


    requestAnimationFrame(() => {
      target.setAttribute("aria-expanded", "true");
    });

    if (this.popover) {
      requestAnimationFrame(() => {
        contentElement.setAttribute("aria-hidden", "false");
      });
    } else {
      contentElement.setAttribute("aria-hidden", "false");
    }


    this.isOpen = true;
    window.addEventListener("click", this.onClickOutsideListener);
    this.initSearchWithinDropdown(contentElement);
  }

  closeDropdown(target) {

    if (this.isOpen == false) { return; }
    if (this.changeOverlay) {
      var focus = this.element.querySelector("[data-scrollable]");

      bodyScrollLock.enableBodyScroll(focus, bodyScrollLockOptions);
    }
    const closestSelectbox = target.closest('.rs-country__selectbox');
    if (closestSelectbox) {
      closestSelectbox.setAttribute('aria-expanded', 'false')
    }

    var closestDropdown = target.closest(".RevolutionSelectbox");
    if (closestDropdown === null) {
      var closestDropdown = target.querySelector(
          "[aria-expanded='true']"
      ).parentElement;
    }
    closestDropdown
        .querySelector(".RevolutionSelectbox--Button")
        ?.setAttribute("aria-expanded", false);
    closestDropdown
        .querySelector(".RevolutionSelectbox--Content")
        .setAttribute("aria-hidden", true);
    closestDropdown.querySelector(
        ".RevolutionSelectbox--Content"
    ).style.height = "0px";
    setTimeout(() => {
      closestDropdown.querySelector(
          ".RevolutionSelectbox--Content"
      ).style.display = "none";
    }, 301);

    if (this.keydownListener) {
      window.removeEventListener("keydown", this.keydownListener);
      this.keydownListener = null;
    }


    if (this.popover == true) {
      this.pageOverlayElement.classList.remove("is-visible");
      const headerOverlay = document.querySelector(".header-overlay");
      if (headerOverlay) {
        headerOverlay.classList.remove("is-visible");
      }
      this.pageOverlayElement.removeEventListener(
          "click",
          this.onClickOutsideListener
      );
    }
    if (this.myCursor) {

      this.myCursor.destroy();
    }

    if (this.element.closest("#modal-country") && responsive.matchesBreakpoint('pocket')) {
      const focus = this.element.querySelector("[data-scrollable]");

      bodyScrollLock.enableBodyScroll(focus);
    }

    this.isOpen = false;
    removeTrapFocus(this.mainDropdownContent);
    window.removeEventListener("click", this.onClickOutsideListener);
  }
}

class Form {
  constructor() { }

  serialize(form) {
    function stringKey(key, value) {
      var beginBracket = key.lastIndexOf("[");

      if (beginBracket === -1) {
        var _hash = {};
        _hash[key] = value;
        return _hash;
      }

      var newKey = key.substr(0, beginBracket);
      var newValue = {};

      newValue[key.substring(beginBracket + 1, key.length - 1)] = value;

      return stringKey(newKey, newValue);
    }

    var hash = {};

    for (var i = 0, len = form.elements.length; i < len; i++) {
      var formElement = form.elements[i];

      if (formElement.name === "" || formElement.disabled) {
        continue;
      }

      if (
          formElement.name &&
          !formElement.disabled &&
          (formElement.checked ||
              /select|textarea/i.test(formElement.nodeName) ||
              /hidden|text|search|tel|url|email|password|datetime|date|month|week|time|datetime-local|number|range|color/i.test(
                  formElement.type
              ))
      ) {
        var stringKeys = stringKey(formElement.name, formElement.value);
        hash = this.extend(hash, stringKeys);
      }
    }

    return hash;
  }
  extend() {
    var extended = {},
        i = 0,
        _this = this;

    // Merge the object into the extended object
    var merge = function merge(obj) {
      for (var prop in obj) {
        if (obj.hasOwnProperty(prop)) {
          // If property is an object, merge properties
          if (Object.prototype.toString.call(obj[prop]) === "[object Object]") {
            extended[prop] = _this.extend(extended[prop], obj[prop]);
          } else {
            extended[prop] = obj[prop];
          }
        }
      }
    };

    // Loop through each object and conduct a merge
    for (; i < arguments.length; i++) {
      merge(arguments[i]);
    }

    return extended;
  }
}

class AddToCart {
  constructor(element) {
    this.element = element;
    this.delegateElement = new Delegate(this.element);
    this.pageLoader = document.body.querySelector(".pageLoader");
    this.bindEvents();
  }
  bindEvents() {
    this.delegateElement.on(
        "click",
        "[data-action=add-to-cart]",
        this.addToCart.bind(this)
    );

  }

  addToCart() {
    var _this = this;
    event.preventDefault();

    var addToCartButton = event.target;
    if (addToCartButton.classList.contains('product-card__atc-button')) {
      if (addToCartButton.getAttribute('data-check') === 'false') {
        let errorText = addToCartButton.parentElement.querySelector(".option-selector__error-text");
        errorText.setAttribute("aria-hidden", "false");
        setTimeout(() => {
          errorText.setAttribute("aria-hidden", "true");
        }, 2000);
        return;
      }
    }

    this.pageLoader.style.width = 100 + "%";
    addToCartButton.setAttribute("disabled", "disabled");
    var formElement = event.target.closest("form");
    formElement.querySelector('[name="id"]')?.removeAttribute("disabled");
    var formHelper = new Form();
    const serialized = formHelper.serialize(formElement);
    fetch(window.routes.localeRootUrl + "/cart/add.js", {
      body: JSON.stringify(serialized),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    }).then(function (response) {
      if (response.ok) {
        if (window.theme.cartMode === 'page') {
          location.href = window.routes.cart_page_url;
        }
        if (window.location.href.indexOf("cart") != -1) {
          location.reload();
          return;
        }

        //Close popup/drawer before adding to cart
        const activePopup = document.body.querySelector('#product-card-popup[aria-expanded="true"]');
        if (activePopup) {
          const productCardLink = activePopup.closest('.product-card__link');
          if (productCardLink) productCardLink.style.overflow = 'hidden';
          activePopup.setAttribute("aria-expanded", "false");
        }

        addToCartButton.removeAttribute("disabled");
        _this.element.dispatchEvent(
            new CustomEvent("product:added", {
              bubbles: true,
              detail: {
                variant: serialized.id,
                quantity: serialized.quantity,
              },
            })
        );
      } else {
        response.json().then(function (content) {
          if (_this.element.querySelector(".ProductForm--Error")) {
            _this.element
                .querySelector(".ProductForm--Error")
                .classList.add("visible");
            setTimeout(function () {
              _this.element
                  .querySelector(".ProductForm--Error")
                  .classList.remove("visible");
            }, 2500);
            _this.pageLoader.style.left = "unset";
            _this.pageLoader.style.right = 0 + "px";
            _this.pageLoader.style.width = 0 + "%";
            setTimeout(() => {
              _this.pageLoader.style.left = 0 + "px";
              _this.pageLoader.style.right = "unset";
            }, 550);
            
            addToCartButton.removeAttribute("disabled");
          } else {
            var errorMessageElement = document.createElement("span");
            errorMessageElement.className = "u-p4 accent";
            errorMessageElement.innerHTML = content["description"];
            addToCartButton.removeAttribute("disabled");
            addToCartButton.insertAdjacentElement(
                "afterend",
                errorMessageElement
            );
            setTimeout(function () {
              errorMessageElement.remove();
            }, 2500);
            _this.pageLoader.style.left = "unset";
            _this.pageLoader.style.right = 0 + "px";
            _this.pageLoader.style.width = 0 + "%";
            setTimeout(() => {
              _this.pageLoader.style.left = 0 + "px";
              _this.pageLoader.style.right = "unset";
            }, 550);
          }
        });
      }
    }).catch((error) => {
      console.log(error);
      addToCartButton.removeAttribute("disabled");
    });
  }
}

/*GLOBAL FUNCTIONS */

function handleFirstTab(e) {
  if (e.keyCode === 9) {
    document.body.classList.add("user-is-tabbing");

    window.removeEventListener("keydown", handleFirstTab);
    window.addEventListener("mousedown", handleMouseDownOnce);
  }
}

function handleMouseDownOnce() {
  document.body.classList.remove("user-is-tabbing");

  window.removeEventListener("mousedown", handleMouseDownOnce);
  window.addEventListener("keydown", handleFirstTab);
}

window.addEventListener("keydown", handleFirstTab);

function getFocusableElements(container) {
  return Array.from(
      container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe, .focusable"
      )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
        event.target !== container &&
        event.target !== last &&
        event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
        (event.target === container || event.target === first) &&
        event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);
  if (first) {
    first.focus();
  } else {
    elementToFocus.focus();
  }
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

class Dropdown {
  constructor() {
    this.domDelegate = new Delegate(document.body);
    this.breakpoint = responsive.getCurrentBreakpoint();
    this.bindEvents();
    this.allDropdowns = document.querySelectorAll(".Dropdown");
    this.lock = false;
    this.bindEvents();
  }

  bindEvents() {
    // Bind event for general dropdown toggle
    this.domDelegate.on(
        "click",
        "[data-action=toggle-dropdown]",
        this.toggleDropdown.bind(this)
    );

    let selector;

    switch (this.breakpoint) {
      case 'lap_and_up':
        // For lap_and_up breakpoint, bind event for desktop dropdown toggle
        selector = "[data-action=toggle-desktop-dropdown]";
        break;
      case 'pocket':
        // For pocket breakpoint, bind event for mobile dropdown toggle
        selector = "[data-action=toggle-mobile-dropdown]";
        break;
      default:
        // If no specific breakpoint, set selector as false to skip binding
        selector = false;
        break;
    }

    if (selector) {
      // Bind event for specific breakpoint dropdown toggle
      this.domDelegate.on(
          "click",
          selector,
          this.toggleDropdown.bind(this)
      );
    }
  }

  openDropdown(elem, target) {
    if (this.lock) return;
    this.lock = true;
    // Open the dropdown by setting appropriate attributes and performing animation
    const DropdownButton = elem.querySelector(".Dropdown--Button");
    const DropdownContent = elem.querySelector(".Dropdown--Content");

    this.allDropdowns.forEach((dropdown) => {
      if (
          dropdown !== target?.closest(".Dropdown") &&
          dropdown.querySelector("[aria-expanded='true']") &&
          !dropdown.classList.contains("do-not-close")
      ) {
        this.closeDropdown(dropdown, true);
      }
    });

    const transitionEndHandler = (event) => {
      if (event.propertyName === "height") {
        this.lock = false;

        DropdownContent.removeEventListener(
            "transitionend",
            transitionEndHandler
        );
      }
    };

    DropdownContent.addEventListener("transitionend", transitionEndHandler);

    DropdownButton.setAttribute("aria-expanded", "true");
    new RevolutionAnimation(DropdownContent, "true").slideDown();
  }

  closeAllDropdowns(namespace) {
    namespace.querySelectorAll(".Dropdown").forEach((dropdown) => {
      if (
          dropdown.querySelector("[aria-expanded='true']") &&
          !dropdown.classList.contains("do-not-close")
      ) {
        this.closeDropdown(dropdown);
      }
    });
  }

  closeDropdown(elem, ignore) {
    if (this.lock && !ignore) return;
    this.lock = true;
    // Close the dropdown by setting appropriate attributes and performing animation
    const DropdownButton = elem.querySelector(".Dropdown--Button");
    const DropdownContent = elem.querySelector(".Dropdown--Content");
    const transitionEndHandler = (event) => {
      if (event.propertyName === "height") {
        if (DropdownContent.getAttribute("aria-hidden") == "false") {
          DropdownContent.setAttribute("aria-hidden", "true");
        }

        this.lock = false;

        DropdownContent.removeEventListener(
            "transitionend",
            transitionEndHandler
        );
      }
    };

    DropdownContent.addEventListener("transitionend", transitionEndHandler);

    new RevolutionAnimation(DropdownContent, "true").slideUp();
    DropdownButton.setAttribute("aria-expanded", false);

  }

  toggleDropdown(event, target) {
    event.preventDefault();
    const mainDropdown = target.closest(".Dropdown");
    const isOpen = target.getAttribute("aria-expanded") === "true";

    if (!this.lock) {
      if (isOpen) {
        // If dropdown is open, close it
        this.closeDropdown(mainDropdown, target);
      } else {
        // If dropdown is closed, open it
        this.openDropdown(mainDropdown, target);
      }
    }
  }
}


new Dropdown();


class RevolutionSwiper {
  constructor(element, additionalSwiper) {
    var options =
        arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.element = element;
    this.thumb = additionalSwiper;
    this.initialConfig = JSON.parse(
        element.getAttribute("data-swiper-settings")
    );

    if (additionalSwiper) {
      this.initialConfigThumbs = JSON.parse(
          additionalSwiper.getAttribute("data-swiper-thumb-settings")
      );
    }
    this.options = options;
    this.build();
  }

  selectCell(index) {
    this.swiperElement.slideTo(index);
  }

  resize() {
    this.swiperElement.resize();
  }

  build() {
    var _this = this,
        configThumb = this.initialConfigThumbs;
    if (configThumb != null) {
      this.thumbSwiper = new Swiper(this.thumb, configThumb);
      this.initialConfig.thumbs["swiper"] = this.thumbSwiper;
    }

    this.swiperElement = new Swiper(this.element, this.initialConfig);
    this.selectedIndex = this.swiperElement.activeIndex;

    this.swiperElement.on("reachEnd", () => {
      this.element.classList.add('swiper-atEnd');
    });

    this.swiperElement.on("fromEdge", () => {
      this.element.classList.remove('swiper-atEnd');

    });


    this.swiperElement.on("slideChange", function () {

      _this.element.dispatchEvent(
          new CustomEvent("swiper:slide-changed", {
            bubbles: true,
            detail: {
              currentIndex: _this.swiperElement.activeIndex,
              element: _this.swiperElement.el[0],
            },
          })
      );
    });


  }
}

class Drawer {
  constructor(element) {
    var options =
        arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.element = element;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.breakpoint = new Responsive().getCurrentBreakpoint();

    if (navigator.platform === "iPhone")
      document.documentElement.style.setProperty(
          "--viewport-height",
          `${window.innerHeight}px`
      );
    this.onOpen = options["onOpen"] || function () { };
    this.onClose = options["onClose"] || function () { };
    this.isOpen = false;

    this.bindEvents();
  }

  bindEvents() {
    this.delegateBody.on(
        "click",
        '[data-action="open-drawer"][data-toggle-id="' + this.element.id + '"]',
        this.openDrawer.bind(this)
    );
    this.delegateBody.on(
        "click",
        '[data-action="close-drawer"][data-toggle-id="' + this.element.id + '"]',
        this.closeDrawer.bind(this)
    );
    this.delegateBody.on(
        "click",
        '[data-action="toggle-drawer"][data-toggle-id="' + this.element.id + '"]',
        this.toggleDrawer.bind(this)
    );

    this._openListener = this.openDrawer.bind(this);
    this._closeListener = this.closeDrawer.bind(this);
    this.calculateMaxHeightListener = this.maxHeight.bind(this);
    responsive.addResizeListener(this, this.calculateMaxHeightListener);

    this.delegateBody.on(
        "keydown",
        this.onEsc.bind(this)
    );
  }

  onEsc(e) {
    if (e.key === 'Escape') {
      this.closeDrawer(e);
    }
  }

  maxHeight() {
    if (!this.element.getAttribute("id") == "cart-drawer") {
      this.element.style.height = window.innerHeight + "px";
    }
  }

  toggleDrawer() {
    event.preventDefault();
    this.isOpen ? this.closeDrawer() : this.openDrawer();
    const header_btn = document.querySelector('[data-toggle-id="Drawer"]');
    if (header_btn) {
      this.isOpen ? header_btn.setAttribute('aria-expanded', true) : header_btn.setAttribute('aria-expanded', false);
    }
  }

  openDrawer() {
    const searchElement = document.querySelector('.search');
    if (searchElement) {
      searchElement.dispatchEvent(
          new CustomEvent("close:search", { bubbles: true })
      );
    }

    const id = this.element.getAttribute("id");

    if (id === "cart-drawer") {
      this.element.dispatchEvent(
          new CustomEvent("cart-drawer:open", { bubbles: true })
      );
      const mobile_menu = document.querySelector('.mobile-menu[aria-expanded="true"]')
      if (mobile_menu) {
        mobile_menu.setAttribute('aria-expanded', false);
      }

      this.element.style.display = "flex";
    }
    if (this.isOpen) {
      return;
    }

    if (id === "product-card-popup") {
      this.element.dispatchEvent(
          new CustomEvent("product-card-drawer:open", {
            bubbles: true,
            detail: {
              product: event.target.dataset.productId,
            },
          })
      );
    }

    this.maxHeight();
    if (id === "Drawer") {
      document.querySelector(".Drawer--Close").style.display = "block";
      this.element.dispatchEvent(
          new CustomEvent("sidebar-drawer:open", {
            bubbles: true,
          })
      );
    }

    if (id === "cart-drawer") {
      requestAnimationFrame(() => {
        this.element.setAttribute("aria-expanded", "true");
      })
    } else {
      this.element.setAttribute("aria-expanded", "true");
    }


    if (!this.element.classList.contains('mobile-menu')) {
      this.pageOverlayElement.classList.add("is-visible");
    }
    this.pageOverlayElement.addEventListener("click", this._closeListener);
    var focus = this.element.querySelectorAll("[data-scrollable]");
    focus.forEach(element => {
      bodyScrollLock.disableBodyScroll(element, bodyScrollLockOptions);
    })
    document.body.classList.add("scrollLock");
    this.isOpen = true;
    setTimeout(() => {
      trapFocus(this.element);
    }, 50);
    this.onOpen();
    return false;
  }

  closeDrawer(event) {
    if (!this.isOpen) {
      return;
    }
    if (event) {
      event.preventDefault();
    }

    const id = this.element.getAttribute("id");

    document.body.classList.remove("scrollLock");

    bodyScrollLock.clearAllBodyScrollLocks();
    this.element.setAttribute("aria-expanded", "false");

    if (this.breakpoint === 'phone' || this.breakpoint === 'pocket') {
      document.querySelector(".header-hamburger-btn").setAttribute("aria-expanded", false);
    }

    this.pageOverlayElement.classList.remove("is-visible");
    this.pageOverlayElement.click();
    this.pageOverlayElement.removeEventListener("click", this._closeListener);
    removeTrapFocus(this.element);
    this.isOpen = false;
    this.onClose();

    if (id === "cart-drawer") {
      setTimeout(() => {
        this.element.style.display = "none";
      }, 300);
    }
  }

}

class dynamicVariables {
  constructor() {
    document.documentElement.style.setProperty(
        "--viewport_width",
        `${document.documentElement.clientWidth}px`
    );

    document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`
    );

    responsive.addResizeListener(this, this.sync.bind(this));
  }

  sync() {
    this.syncWidth();
    this.syncHeight();
  }

  syncWidth() {
    document.documentElement.style.setProperty(
        "--viewport_width",
        `${document.documentElement.clientWidth}px`
    );

  }

  syncHeight() {
    document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`
    );
  }
}

const dynamicVars = new dynamicVariables();

class RevolutionAnimation {
  constructor(element, directAnimation) {
    this.element = element;
    if (!directAnimation) {
      this.intersectionObserver = [];
      this.integer = 0;
      var contentToAnimate = document.querySelectorAll("[data-animation]");
      contentToAnimate.forEach((item, i) => {
        this.animateElement(item, i);
        this.integer = this.integer + 1;
      });

      // Listen for changes to the DOM and animate any new elements
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType !== Node.ELEMENT_NODE) return;

            const itemsToAnimate = [];

            // 1) If the node itself is a [data-animation] target
            if (node.matches('[data-animation]')) {
              itemsToAnimate.push(node);
            }

            // 2) Any descendants that are [data-animation]
            node.querySelectorAll('[data-animation]').forEach(el => {
              itemsToAnimate.push(el);
            });

            // 3) If the node itself has .animatedContent, animate its closest [data-animation] ancestor
            if (node.matches('.animatedContent')) {
              const parentAni = node.closest('[data-animation]');
              if (parentAni) itemsToAnimate.push(parentAni);
            }

            // 4) And any descendant .animatedContent → animate their closest [data-animation]
            node.querySelectorAll('.animatedContent').forEach(el => {
              const parentAni = el.closest('[data-animation]');
              if (parentAni) itemsToAnimate.push(parentAni);
            });

            // Dedupe and kick off the animations
            [...new Set(itemsToAnimate)].forEach(item => {
              this.animateElement(item, this.integer++);
            });
          });
        });
      });

      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  slideUp() {
    this.element.style.height = this.element.scrollHeight + "px";
    this.element.offsetHeight;
    this.element.style.height = 0;
  }

  slideDown() {
    if (this.element.style.height === "auto") {
      return;
    }
    this.element.style.pointerEvents = "none";
    var _this = this;
    this.element.style.height = this.element.scrollHeight + "px";
    this.element.setAttribute("aria-hidden", false);
    var transitionEnded = function transitionEnded(event) {
      _this.element.style.pointerEvents = "all";
      if (event.propertyName === "height") {
        _this.element.style.height = "auto";
        _this.element.removeEventListener("transitionend", transitionEnded);
      }
    };

    this.element.addEventListener("transitionend", transitionEnded);
  }

  // A function to animate a list of elements by scaling them out
  elementScaleOut(elements) {
    // Get the animation duration and delay from the theme settings
    const animationDuration = window.theme.animationDuration * 2;
    const animationDelay = window.theme.animationBetweenElements;

    // Loop through each element in the list
    elements.forEach((element, index) => {
      // Check if the element has already been loaded
      if (element.hasAttribute("data-loaded")) {
        // If so, skip this element
        return;
      }

      // Mark the element as loaded to prevent duplicate animations
      element.setAttribute("data-loaded", true);

      // Define the animation keyframes
      const keyframes = [
        { transform: "scale(104%)", opacity: "0" },
        { transform: "scale(100%)", opacity: "1" },
      ];

      // Define the animation options
      const animationOptions = {
        duration: animationDuration,
        fill: "forwards",
      };

      // Schedule the animation with a delay based on the element's position in the list
      setTimeout(() => {
        element.animate(keyframes, animationOptions);
      }, animationDelay * index);
    });
  }



  elementScaleIn(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "scale(96%)", opacity: "0" },
          { transform: "scale(100%)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration * 2,
          fill: "forwards",
        });
      }, window.theme.animationBetweenElements * i);
      item.setAttribute("data-loaded", true);
    });
  }

  elementFadeIn(toReveal) {

    toReveal.forEach((item, i) => {
      // Check if element already has an active animation
      if (item.getAttribute("data-loaded")) {
        return;
      }

      setTimeout(() => {
        var elementMove = [
          { opacity: "0" },
          { opacity: "1" },
        ];

        item.animate(elementMove, {
          duration: window.theme.animationDuration * 2,
          easing: "ease",
          fill: "forwards",
        });


      }, window.theme.animationBetweenElements * i);

      if (!item.hasAttribute("always-animate")) {
        item.setAttribute("data-loaded", true);
      }
    });
  }


  elementFromTop(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateY(-30px)", opacity: "0" },
          { transform: "translateY(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
      }, window.theme.animationBetweenElements * i);
      item.setAttribute("data-loaded", true);
    });
  }

  elementFromBottom(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateY(30px)", opacity: "0" },
          { transform: "translateY(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
      }, window.theme.animationBetweenElements * i);
      item.setAttribute("data-loaded", true);
    });
  }

  elementFromRight(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateX(30px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
        item.setAttribute("data-loaded", true);
      }, window.theme.animationBetweenElements * i);
    });
  }
  elementFromLeft(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateX(-30px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
        item.setAttribute("data-loaded", true);
      }, window.theme.animationBetweenElements * i);
    });
  }
  elementFromRightBig(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateX(120px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
        item.setAttribute("data-loaded", true);
      }, window.theme.animationBetweenElements * i);
    });
  }
  elementFromLeftBig(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateX(-120px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
      }, window.theme.animationBetweenElements * i);
      item.setAttribute("data-loaded", true);
    });
  }

  animateElement(animatedItem, index) {

    const options = {
      integer: index,
      type: animatedItem.dataset.animation,
    };

    if (this.intersectionObserver[index]) {
      this.intersectionObserver[index].disconnect();
    }

    this.intersectionObserver[index] = new IntersectionObserver(
        (results) => {
          const integer = options.integer;
          const elements = [];

          // Iterate over the IntersectionObserverEntry objects in the results array.
          results.forEach((result) => {

            // Check if the target element is intersecting the root element or if its intersection ratio is greater than 0.
            if (result.isIntersecting || result.intersectionRatio > 0) {
              // Add the target element to the elements array.
              elements.push(result.target);
              // Unobserve the target element.
              this.intersectionObserver[integer].unobserve(result.target);
            }
          });

          // If there are no elements to reveal, return.
          if (elements.length === 0) {
            return;
          }

          // An object that maps each animation type to the corresponding animation function.
          const animations = {
            elementFromTop: 'elementFromTop',
            elementFromBottom: 'elementFromBottom',
            elementFromRight: 'elementFromRight',
            elementFromLeft: 'elementFromLeft',
            elementFromLeftBig: 'elementFromLeftBig',
            elementFromRightBig: 'elementFromRightBig',
            elementScaleIn: 'elementScaleIn',
            elementScaleOut: 'elementScaleOut',
            elementFadeIn: "elementFadeIn"
          };

          // Get the animation function corresponding to the type from the animations object.
          const animation = animations[options.type];
          // If the animation function exists, call it with the elements array.
          if (animation) {
            this[animation](elements);
          }
        },
        { threshold: 0.25 }
    );

    if (animatedItem.classList.contains('animatedContent')) {
      this.intersectionObserver[index].observe(animatedItem);
    }

    animatedItem.querySelectorAll('.animatedContent').forEach((item) => {
      this.intersectionObserver[index].observe(item);
    });
  }
}

if (window.theme.enableAnimations) {
  document.addEventListener("DOMContentLoaded", function () {
    new RevolutionAnimation();
  });
}


class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.input = this.querySelector("input");
    this.changeEvent = new Event("quantity:changed", { bubbles: true });
    this.options = JSON.parse(this.element.getAttribute("data-settings"));

    this.querySelectorAll("button").forEach((button) =>
        button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);

    if (this.options['noVariants'] == "true") {
      this.toggleAddButton();
    }
  }

  toggleAddButton() {
    let quantity = "";
    const addButton = document.querySelector(".ProductPage--ATC"),
        addButtonInner = addButton.querySelector(".SelfAlign"),
        quantityEl = document.querySelector('.QuantitySelector__ProductQuantity');
    if (quantityEl) {
      quantity = quantityEl.value();
    }
    if (window.variantInfo.show_icon) {
      var buySvg =
          '<svg class="Svg Svg--shopping_cart mr-m" width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M25.31 5.19547C25.1687 5.02127 24.9568 4.91946 24.7325 4.91797H9.11751L9.60501 6.41797H23.75L21.7475 15.418H10.4975L7.07001 4.56547C6.99476 4.33174 6.80986 4.14965 6.57501 4.07797L3.50001 3.13297C3.24278 3.05393 2.96292 3.11812 2.76584 3.30137C2.56877 3.48461 2.48443 3.75907 2.54459 4.02137C2.60476 4.28366 2.80028 4.49393 3.05751 4.57297L5.75001 5.39797L9.19251 16.273L7.96251 17.278L7.86501 17.3755C7.2374 18.0987 7.21221 19.1659 7.80501 19.918C8.21952 20.4221 8.84817 20.7002 9.50001 20.668H22.0175C22.4317 20.668 22.7675 20.3322 22.7675 19.918C22.7675 19.5038 22.4317 19.168 22.0175 19.168H9.38001C9.20436 19.162 9.0446 19.0646 8.95873 18.9113C8.87286 18.7579 8.87334 18.5709 8.96001 18.418L10.7675 16.918H22.3475C22.705 16.9267 23.0189 16.6818 23.0975 16.333L25.475 5.83297C25.5212 5.6064 25.4603 5.37117 25.31 5.19547ZM20.75 25.168C21.682 25.168 22.4375 24.4125 22.4375 23.4805C22.4375 22.5485 21.682 21.793 20.75 21.793C19.818 21.793 19.0625 22.5485 19.0625 23.4805C19.0625 24.4125 19.818 25.168 20.75 25.168ZM12.185 23.4805C12.185 24.4125 11.4295 25.168 10.4975 25.168C9.56553 25.168 8.81001 24.4125 8.81001 23.4805C8.81001 22.5485 9.56553 21.793 10.4975 21.793C11.4295 21.793 12.185 22.5485 12.185 23.4805Z" fill="#121212"></path></svg>';
    } else {
      var buySvg = "";
    }

    if (!addButton) return;
    if (!quantity) { quantity = 1; }


    addButton.removeAttribute("disabled");
    addButton.classList.remove("product-card__sold-out");
    if (window.variantInfo.show_price) {
      var priceElement =
          "<span class='u-p3 ml-s'>" +
          Shopify.formatMoney(
              this.options['price'] * quantity,
              window.theme.moneyFormat
          );
      +"</span>";
    } else {
      var priceElement = "";
    }

    addButtonInner.innerHTML =
        buySvg + window.variantStrings.addToCart + priceElement;

  }

}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = (form) => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
      ? target.addEventListener(eventName, callback, false)
      : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
    country_domid,
    province_domid,
    options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
      options["hideElement"] || province_domid
  );

  Shopify.addListener(
      this.countryEl,
      "change",
      Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class ProductForm extends HTMLElement {
  constructor() {
    super();
    new AddToCart(this);
  }
}

customElements.define("product-form", ProductForm);

class Countdown extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    const counterWrapper = this.element.querySelector('.component-countDownWrapper');

    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    let counterString = this.options['countdownString'];
    counterString = counterString.replace('{countdown}', '<span class="u-pb6 component-countDown">00:00:00</span>');
    counterWrapper.innerHTML = counterString;

    const dateNow = new Date();
    const todaysDay = dateNow.getDay();

    const countdownDay = this.options.countdownDays;


    this.dayDifference = countdownDay - todaysDay;

    if (this.dayDifference < 0) {
      // If the countdown day is earlier in the week, add 7 to the difference
      this.dayDifference += 7;
    }

    this.counter = this.element.querySelector(".component-countDown");
    setInterval(this.countDown.bind(this), 1000);
  }

  countDown() {
    const dateNow = new Date();
    const currentHours = dateNow.getHours();
    const currentMinutes = dateNow.getMinutes();
    let countDate = new Date(`March 3, 2099 ${this.options.countdownTime}`);

    if (this.options['countdownType'] == 'to_date') {
      countDate = new Date(this.options.countdownDate);
    }



    const difference = countDate - dateNow;

    const seconds = 1000;
    const minutes = seconds * 60;
    const hours = minutes * 60;
    const days = hours * 24;


    let textDays = Math.floor(difference / (1000 * 60 * 60 * 24));
    let textHours = Math.floor((difference % days) / hours);
    let textMinutes = Math.floor((difference % hours) / minutes);
    let textSeconds = Math.floor((difference % minutes) / seconds);


    const [targetHours, targetMinutes] = this.options.countdownTime.split(':').map(Number);
    if (targetHours < currentHours || (targetHours === currentHours && targetMinutes <= currentMinutes) && this.options['countdownType'] == 'reccuring') {
      textDays = this.dayDifference - 1;
    } else if (this.options['countdownType'] == 'reccuring') {
      textDays = this.dayDifference;
    }


    const displayHours = textHours;
    const formatHours = displayHours < 10 ? `0${displayHours}` : displayHours;
    const formatMinutes = textMinutes < 10 ? `0${textMinutes}` : textMinutes;
    const formatSeconds = textSeconds < 10 ? `0${textSeconds}` : textSeconds;

    if (textDays > 0) {
      this.counter.innerText = `${textDays}d ${formatHours}:${formatMinutes}:${formatSeconds}`;
    } else {
      this.counter.innerText = `${formatHours}:${formatMinutes}:${formatSeconds}`;
    }
  }
}

customElements.define("countdown-element", Countdown);

var stateWasEmpty = true;
class cartDrawer extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.element = this;
    this.delegateElement = new Delegate(this.element);

    this.focusElement = false;
    this.drawer = new Drawer(this.element, {
      onClose: () => {
        this.isOpen = false;
        this.recommendationsOpen = false;
        this.alreadyEntered = false;
        this.onClose();
      },
      onOpen: () => {
        this.isOpen = true;

        if (this.alreadyEntered == false) {
          this.onOpen();
        }
        this.alreadyEntered = true;
      },
    });
    this.loader = this.element.querySelector(".itemLoader");

    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    this.pageLoader = document.body.querySelector(".pageLoader");
    this.breakpoint = responsive.getCurrentBreakpoint();
    this.cartIds = false;
    this.isOpen = false;
    this.recommendationsOpen = false;
    this.recommendationLoading = false;
    this.breakpoint = responsive.getCurrentBreakpoint();

    this.alreadyEntered = false;
    new AddToCart(this.element);
    this.loadRecommendations();


    this.bindEvents();

    this._enforceAddonPolicyOnInit();
    this._bindCheckoutCleanups();
  }

  bindEvents() {
    if (window.theme.listener == "false") {
      this.onProductAddedListener = this.onProductAdded.bind(this);


      document.addEventListener("product:added", this.onProductAddedListener);
      this.delegateElement.on(
          "click",
          '[data-action="update-item-quantity"], [data-action="remove-item"]',
          this.updateItemQuantity.bind(this)
      );
      this.delegateElement.on(
          "change",
          '[data-action="update-change-quantity"]',
          this.updateItemQuantity.bind(this)
      );
      this.delegateElement.on(
          "quantity:changed",
          ".cart-item__quantity",
          this.updateItemQuantity.bind(this)
      );
      this.delegateElement.on(
          "keydown",
          ".cart-item__quantity",
          this.onCartQuantityKeydown.bind(this)
      );
      this.delegateElement.on(
          'click',
          '[data-action="remove-addon"], .additional-service-button',
          this.removeAddon.bind(this)
      );
      this.delegateElement.on(
          'click',
          '[data-action="add-addon"], .additional-service-button',
          this.addAddon.bind(this)
      );


      window.theme.listener = "true";
    }
  }

  onCartQuantityKeydown(event, target) {
    // Block Enter from submitting the cart-drawer form (which navigates to /checkout).
    // Blur the input so the browser commits the value and fires a native `change`
    // exactly once -> handled by the existing delegated `updateItemQuantity` listener.
    if (event.key !== "Enter") return;
    if (!target || !target.classList || !target.classList.contains("cart-item__quantity")) return;

    event.preventDefault();
    event.stopPropagation();
    target.blur();
  }


  /* ---------------------------
 * Add-on policy helpers
 * --------------------------- */
  _addonPolicy() {
    const enabled  = !!(this.options && this.options.addonEnabled);
    const addonPid = Number(this.options && this.options.addonProductId) || 0;
    return { enabled, addonPid };
  }

  async _fetchCart() {
    const r = await fetch('/cart.js', { credentials: 'same-origin' });
    if (!r.ok) throw new Error('Cart fetch failed');
    return r.json();
  }

  async _removeLine(lineKey) {
    // If you add a general line-update method later, prefer that here
    const url = (window.routes?.cart_change_url || '/cart/change') + '.js';
    const r = await fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ id: lineKey, quantity: 0 })
    });
    if (!r.ok) throw new Error('Line removal failed');
    return r.json();
  }

  /* ---------------------------------------------
   * Run once: if add-on feature is OFF, purge it
   * --------------------------------------------- */
  async _enforceAddonPolicyOnInit() {
    const { enabled, addonPid } = this._addonPolicy();
    if (enabled || !addonPid) return;

    try {
      const cart = await this._fetchCart();
      const addOnLines = (cart.items || []).filter(i => i.product_id === addonPid);
      if (!addOnLines.length) return;

      // Remove each add-on line (reuse your existing remove functions if you prefer)
      await Promise.all(addOnLines.map(li => this._removeLine(li.key)));

      // One render at the end to sync UI
      if (typeof this.renderCart === 'function') {
        await this.renderCart(false, false);
      }
    } catch (e) {
      console.warn('[cartDrawer] policy init failed', e);
    }
  }

  /* ---------------------------------------------------
   * Guard checkout: clean add-on if feature is OFF
   * --------------------------------------------------- */
  _bindCheckoutCleanups() {
    const root = this.element || document;

    const selector = [
      '[name="checkout"]',
      'form[action$="/checkout"] [type="submit"]',
      'a[href$="/checkout"]'
    ].join(',');

    const bind = (ctx) => {
      ctx.querySelectorAll(selector).forEach(btn => {
        if (btn.dataset.addonCleanBound) return;
        btn.dataset.addonCleanBound = '1';
        btn.addEventListener('click', (e) => this._onCheckoutClick(e, btn), { capture: true });
      });
    };

    bind(root);

    // Also re-bind for dynamically inserted buttons
    if (!this._checkoutMo) {
      this._checkoutMo = new MutationObserver(() => bind(root));
      this._checkoutMo.observe(document.documentElement, { childList: true, subtree: true });
    }
  }

  async _onCheckoutClick(event, btn) {
    const { enabled, addonPid } = this._addonPolicy();
    if (enabled || !addonPid) return; // nothing to do

    // Intercept click, clean add-ons, then proceed
    event.preventDefault();
    event.stopPropagation();

    try {
      const cart = await this._fetchCart();
      const addOnLines = (cart.items || []).filter(i => i.product_id === addonPid);

      if (addOnLines.length) {
        await Promise.all(addOnLines.map(li => this._removeLine(li.key)));
        // Give Shopify a tick to recalc
        await new Promise(r => setTimeout(r, 120));
        // Optional: call your cascade cleaner if you want its extra logic
        if (typeof this.removeAddon === 'function') {
          await this.removeAddon(await this._fetchCart());
        }
        // Optionally refresh drawer UI if it’s open
        if (typeof this.renderCart === 'function') {
          await this.renderCart(false, false);
        }
      }
    } catch (e) {
      console.warn('[cartDrawer] checkout cleanup failed', e);
      // continue anyway—don’t block checkout
    }

    const form = btn && btn.closest('form');
    if (form) form.submit();
    else window.location.assign('/checkout');
  }


  async addAddon(event, target) {
    event.preventDefault();


    this.loader.classList.add('is-visible');
    const btn = target.closest('.additional-service-button') || target;
    if (!btn || btn.disabled) return;

    const variantId = parseInt(btn.dataset.variantId, 10);
    const quantity  = parseInt(btn.dataset.quantity || '1', 10);
    const groupId   = btn.dataset.groupId || '';

    if (!variantId || quantity < 1) return;

    // UI lock
    btn.disabled = true;
    btn.classList.add('is-loading');

    try {
      // Add the add-on via AJAX
      const res = await fetch(`${window.routes.localeRootUrl}/cart/add.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          items: [{
            id: variantId,
            quantity: quantity,
            properties: {
              _group_id: groupId,
              _addon: 'Quick order'
            }
          }]
        })
      });

      if (!res.ok) throw new Error('Add-on add failed');

      // Tell the drawer “something was added” so it re-renders itself
      document.dispatchEvent(
          new CustomEvent('product:added', { detail: { variant: variantId } })
      );

      // (Optional) go straight to checkout if flagged on the button
      if (btn.hasAttribute('data-go-checkout')) {
        // Give the drawer a moment to update, then redirect
        setTimeout(() => {
          window.location.href = `${window.routes.localeRootUrl}/checkout`;
        }, 100);
      }

      // Visual tick ✅ (swap the icon)
      const iconWrap = btn.querySelector('.icon-checkmark-wrapper');
      if (iconWrap) {
        iconWrap.classList.remove('empty');
        iconWrap.classList.add('checked');
        iconWrap.innerHTML = `{% render 'icon_pack' with 'box-check' %}`;
      }

    } catch (err) {
      console.error(err);
      alert("Couldn't add this item. Please try again.");
    } finally {
      btn.classList.remove('is-loading');
      btn.disabled = false;

      this.loader.classList.remove('is-visible');
    }
  }

  // One function to remove a clicked add-on OR clean up the "only add-on left" case.
  async removeAddon(eventOrCartData, target = null) {
    // Detect call mode
    const isEventCall = eventOrCartData && typeof eventOrCartData.preventDefault === 'function';
    const cartDataArg = !isEventCall ? eventOrCartData : null;

    if (isEventCall) eventOrCartData.preventDefault();

    // UI: show loader
    this.loader?.classList.add('is-visible');

    try {
      let data = cartDataArg || null;

      // A) Clicked a remove-addon button → remove that line
      if (target) {
        const btn = target.closest('[data-action="remove-addon"]');
        if (!btn || btn.disabled) return;

        btn.disabled = true;
        btn.classList.add('is-loading');

        const lineKey = btn.dataset.lineKey || '';
        const r = await fetch(`${window.routes.localeRootUrl}/cart/change.js`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ id: lineKey, quantity: 0 }),
        });
        if (!r.ok) throw new Error('Remove failed');
        data = await r.json(); // updated cart
      }

      // B) If we weren't passed cart JSON yet, fetch it now
      if (!data) {
        data = await fetch(`${window.routes.localeRootUrl}/cart.js`, {
          credentials: 'same-origin',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
        }).then(r => r.json());
      }

      // C) If the cart has exactly one line and it's an add-on → remove it too
      const items = Array.isArray(data?.items) ? data.items : [];
      if (items.length === 1) {
        const only = items[0];

        // Identify add-on either by _group_id property or by known add-on product ids present in DOM
        const isAddonByProp = !!(only.properties && only.properties._group_id);
        const addonButtons = Array.from(document.querySelectorAll('[data-action="remove-addon"][data-product-id]'));
        const addonIds = new Set(addonButtons.map(b => Number(b.dataset.productId)));
        const isAddonByProductId = addonIds.has(Number(only.product_id));

        if (isAddonByProp || isAddonByProductId) {
          // Remove directly via API (avoid re-entrant click loops)
          await fetch(`${window.routes.localeRootUrl}/cart/change.js`, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ id: only.key, quantity: 0 }),
          });
        }
      }

      // D) One render at the end
      await this.renderCart(false, false);
    } catch (e) {
      console.error(e);
      alert("Couldn't remove this add-on. Please try again.");
    } finally {
      this.loader?.classList.remove('is-visible');
    }
  }



  onOpen() {
    const content = this.element.querySelector(".cart-drawer__content");
    const fromTop = content.getBoundingClientRect().top;
    document.documentElement.style.setProperty(
        "--cart-drawer__header-height",
        fromTop + "px"
    );

    if (this.element.querySelector(".cart-drawer__footer")) {
      document.documentElement.style.setProperty(
          "--cart-drawer__footer-height",
          this.element.querySelector(".cart-drawer__footer").offsetHeight + "px"
      );
    }

    if (this.options["showRecommendations"] && this.alreadyEntered == false) {
      this.loadRecommendations();
    }

  }

  onClose() {
    if (this.breakpoint == 'desktop' && this.recommendationContainer) {
      this.recommendationContainer.setAttribute("aria-expanded", "false");
      this.recommendationContainer = null;
    }
  }

  handleTransitionEnd(target) {
    target.setAttribute("aria-hidden", "true");
    target.style.display = "none";
    this.recommendationContainer.removeEventListener(
        "transitionend",
        this.transitionEndHandler
    );
  }

  // Call this after any /cart/change.js (pass the JSON you already have)



  async updateItemQuantity(event, target) {
    event.preventDefault();

    const cartItem   = target.closest(".cart-item");
    const itemLoader = cartItem.querySelector(".itemLoader");
    itemLoader.classList.add("is-visible");

    let quantity;
    if (target.tagName === "INPUT") {
      quantity = Math.max(parseInt(target.value, 10) || 0, 0);
    } else {
      quantity = parseInt(target.getAttribute("data-quantity"), 10);
    }

    const changedLineKey = target.getAttribute("data-line-id") || ""; // full key (with colons)
    const parentKeyNoColons = cartItem?.dataset.id || "";             // parent key (no colons)
    const changedKeyNoColons = changedLineKey.replace(/:/g, "");
    const isParentLine = parentKeyNoColons && (changedKeyNoColons === parentKeyNoColons);
    const isRemove = quantity === 0;

    const payload = { id: changedLineKey, quantity };

    // Only pre-remove the DOM node when removing the *parent* line.
    if (isRemove && isParentLine) {
      cartItem.classList.add("removing");
      const id = cartItem.dataset.id;
      if (this.cartIds) {
        this.cartIds = this.cartIds.filter((item) => item !== id);
      }

      const nextItem = cartItem.nextElementSibling;
      const height = cartItem.offsetHeight;
      document.documentElement.style.setProperty("--repositioning_value", `${height}px`);
      setTimeout(() => {
        cartItem.remove();
        if (!nextItem) return;
        nextItem.classList.add("repo--top");
        setTimeout(() => nextItem.classList.remove("repo--top"), 350);
      }, 350);
    }

    try {
      const response = await fetch(`${window.routes.localeRootUrl}/cart/change.js`, {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify(payload),
      });
      if (!response.ok) throw new Error("Network response was not ok");

      const data = await response.json();

      // If we removed something…
      if (isRemove) {
        if (isParentLine) {
          // Parent removed → cascade remove add-ons that share _group_id (the parent’s key without colons)
          await this.removeAddon(data);
          return;
        }
      }

      // Normal quantity change paths
      if (data.item_count == 0) {
        this.loader.classList.add("is-visible");
        this.renderCart(false, false);
        return;
      }

      if (data.item_count > 0 && quantity > 0) {
        // If parent quantity changed, we can do a partial update; otherwise full render
        if (isParentLine) {
          this.renderCart(target.getAttribute("data-id"), true);
        } else {
          this.renderCart(false, false);
        }
      }
    } catch (error) {
      console.error("Failed to update item quantity:", error);
      this.renderCart(target.getAttribute("data-id"), true);
    }
  }


  onProductAdded() {
    let details = false;
    if (event.detail) {
      details = event.detail;
    }

    if (window.theme.cartCount == 0 && this.isOpen == true) {
      this.loader.classList.add("is-visible");
    }


    this.renderCart(false, false, true, details).then(() => {
      if (this.element.hasAttribute('data-open-drawer')) {
        if (this.isOpen == false) {

          this.isOpen = true;
          this.onOpen();
          this.alreadyEntered = true;
          this.drawer.openDrawer();

        }
      }
    });
  }

  renderCart(lineNumber, quantityChange, productAdd, productAddEvent, updateCount) {
    this.pageLoader.style.width = 90 + "%";
    var _this = this;
    return fetch(
        window.routes.localeRootUrl + "/?section_id=main-cart_drawer",
        {
          credentials: "same-origin",
          method: "GET",
        }
    ).then(function (content) {
      content.text().then(function (html) {
        _this.replaceContent(
            html,
            lineNumber,
            quantityChange,
            productAdd,
            productAddEvent,
            updateCount
        );

      });
    });
  }

  replaceContent(
      html,
      lineNumber,
      quantityChange,
      productAdd,
      productAddEvent,
      updateCount
  ) {


    // Prepare the page loader animation
    this.pageLoader.style.width = "100%";
    setTimeout(() => {
      this.pageLoader.style.left = "unset";
      this.pageLoader.style.right = "0px";
      this.pageLoader.style.width = "0%";

      setTimeout(() => {
        this.pageLoader.style.left = "0px";
        this.pageLoader.style.right = "unset";
      }, 550);

    }, 100)


    // Create a temporary element to parse the new HTML content
    const tempElement = document.createElement("div");
    tempElement.innerHTML = html;

    // Extract options and update cart count
    const newOptions = JSON.parse(
        tempElement.querySelector("#cart-drawer").getAttribute("data-settings")
    );
    this.options = newOptions;

    if (tempElement.querySelector("[data-ids]")) {
      this.cartIds = tempElement
          .querySelector("[data-ids]")
          .dataset.ids.split(",")
          .filter((item) => item !== "");
      if (updateCount) {
        this.cartIds = this.cartIds.filter((item) => item !== this.removeId);
        this.removeid = null;
        this.loadRecommendations();
      }
    }


    const itemCount = newOptions.itemCount;
    window.theme.cartCount = parseInt(itemCount);
    document.querySelector(".cart-count").innerText = itemCount;

    if (updateCount) {
      this.updateCartFooter(tempElement);
      return;
    }
    if (lineNumber && tempElement.querySelector(`#${lineNumber}`)) {
      this.updateCartItem(lineNumber, tempElement);
    } else if (productAdd && stateWasEmpty == false && lineNumber) {
      this.addContent(tempElement, productAddEvent);
    } else {
      this.replaceCartContent(tempElement);
    }

    this.updateCartFooter(tempElement);

    this.element.dispatchEvent(
        new CustomEvent("cart:render", { bubbles: true })
    );



    if (itemCount == 0) {
      stateWasEmpty = true;
    } else {
      stateWasEmpty = false;
    }

    // Additional actions after a brief delay

    setTimeout(() => {
      if (
          this.options.showRecommendations &&
          !quantityChange &&
          this.isOpen == true
      ) {
        this.loadRecommendations();
      }

      if (this.element.hasAttribute('data-open-drawer')) {
        bodyScrollLock.clearAllBodyScrollLocks();
        this.focusElement = this.element.querySelector("[data-scrollable]");
        bodyScrollLock.disableBodyScroll(this.focusElement, bodyScrollLockOptions);
      }

    }, 200);
  }

  updateCartItem(lineNumber, tempElement) {
    const cartItemParent = this.element.querySelector(`#${lineNumber}`);
    const newCartItemInfo = tempElement.querySelector(
        `#${lineNumber} .cart-item__info `
    );
    const oldCartItemInfo = cartItemParent.querySelector(`#${lineNumber} .cart-item__info`);


    if (!cartItemParent) {
      this.element
          .querySelector(".itemLoader")
          .classList.remove("is-visible");
    } else {
      cartItemParent
          .querySelector(".itemLoader")
          .classList.remove("is-visible");
    }

    if (newCartItemInfo) {
      cartItemParent.querySelector('.cart-item__inner').replaceChild(
          newCartItemInfo,
          oldCartItemInfo
      );
    } else if (cartItemParent) {
      this.removeCartItem(cartItemParent);
    }
  }

  addContent(tempElement, productAddEvent) {
    if (this.isOpen) {
      this.element.querySelector(".cart-drawer__wrapper").scrollTop = 0;
    }
    const itemToAdd = tempElement.querySelector(
        `#cart-item__${productAddEvent.variant}`
    );
    const cartWrapper = this.element.querySelector(".cart-drawer__items");
    const firstItem = cartWrapper.firstElementChild;
    if (cartWrapper.querySelector(`#cart-item__${productAddEvent.variant}`)) {
      this.updateCartItem(`cart-item__${productAddEvent.variant}`, tempElement);
    } else {
      const height = this.calculateDetachedElement(itemToAdd);
      document.documentElement.style.setProperty(
          "--repositioning_value",
          `${height}px`
      );
      firstItem.classList.add("repo--bottom");
      this.loader.classList.remove("is-visible");
      setTimeout(() => {
        cartWrapper.prepend(itemToAdd);
        itemToAdd.classList.add("repo--adding");
        firstItem.classList.remove("repo--bottom");

        setTimeout(() => {
          itemToAdd.classList.remove("repo--adding");
        }, 350);
      }, 350);
    }
  }

  calculateDetachedElement(element) {
    // 1. Create a detached container
    const detachedContainer = document.createElement("div");
    detachedContainer.style.position = "absolute";
    detachedContainer.style.visibility = "hidden";
    detachedContainer.style.height = "auto";
    detachedContainer.style.width = "auto";
    detachedContainer.style.top = "-9999px"; // Off-screen positioning

    // 2. Append the new item to the detached container
    detachedContainer.appendChild(element);

    // 3. Append the detached container to the body (but off-screen)
    this.element.appendChild(detachedContainer);

    // 4. Get the offset height of the new item
    const newItemHeight = element.offsetHeight + 16;

    // 5. Remove the detached container from the DOM
    this.element.removeChild(detachedContainer);

    // Now you have the height of the new item without it ever being visible
    return newItemHeight;
  }

  updateCartFooter(tempElement) {
    const itemCount = this.options.itemCount;
    if (itemCount > 0) {

      const footerParent = document.querySelector(".cart-drawer__footer");

      const newFooterTotals = tempElement.querySelector(
          ".cart-drawer__checkout"
      );
      const oldFooterTotals = document.querySelector(".cart-drawer__checkout");

      if (!footerParent || !newFooterTotals) return;
      if (oldFooterTotals) {

        footerParent.replaceChild(
            newFooterTotals,
            oldFooterTotals
        );
      } else {
        footerParent.prepend(newFooterTotals);
      }

      const newShippingBar = tempElement.querySelector(
          ".cart-drawer__shipping-progress-bar"
      );
      if (newShippingBar) {
        const currentShippingBar = document.querySelector(
            ".cart-drawer__shipping-progress-bar"
        );
        if (currentShippingBar) {
          let percent = newShippingBar.dataset.percent;
          if (percent > 100) {
            percent = 100;
          }
          currentShippingBar.dataset.percent = percent;
          currentShippingBar.style.width = `${percent}%`;
          if (percent == 100) {
            currentShippingBar.classList.add("done");
            currentShippingBar.classList.remove("active");
          } else {
            currentShippingBar.classList.remove("done");
            currentShippingBar.classList.add("active");
          }
          this.element.querySelector(".cart-drawer__shipping-text").innerHTML =
              tempElement.querySelector(".cart-drawer__shipping-text").innerHTML;
        } else {
          const headerParent = this.element.querySelector(
              ".cart-drawer__header"
          );
          headerParent.appendChild(
              tempElement.querySelector(".cart-drawer__shipping")
          );
        }
      }

    } else {
      this.clearCartFooter(tempElement);
      stateWasEmpty = true;
    }

    if (this.element.querySelector(".cart-drawer__footer")) {
      document.documentElement.style.setProperty(
          "--cart-drawer__footer-height",
          this.element.querySelector(".cart-drawer__footer").offsetHeight + "px"
      );

    }

  }

  clearCartFooter(tempElement) {

    if (!tempElement.querySelector(".cart-drawer__wrapper")) return;
    if (document.querySelector(".cart-drawer__footer")) {
      document
          .querySelector(".cart-drawer__footer")
          .classList.add("removing");
    }

    const wrapperParent = this.element.querySelector(".cart-drawer__wrapper");
    if (wrapperParent) {
      wrapperParent.innerHTML = tempElement.querySelector(
          ".cart-drawer__wrapper"
      ).innerHTML;
    }
  }

  replaceCartContent(tempElement) {

    const cartWrapperParent = this.element.querySelector(
        ".cart-drawer__wrapper"
    ).parentNode;
    const currentScrollPosition = this.element.querySelector(
        ".cart-drawer__wrapper"
    ).scrollTop;

    cartWrapperParent.replaceChild(
        tempElement.querySelector(".cart-drawer__wrapper"),
        this.element.querySelector(".cart-drawer__wrapper")
    );
    setTimeout(() => {
      this.loader.classList.remove("is-visible");
    }, 200);
    this.element.querySelector(".cart-drawer__wrapper").scrollTop =
        currentScrollPosition;

    setTimeout(() => {
      const content = this.element.querySelector(".cart-drawer__content");
      const fromTop = content.getBoundingClientRect().top;
      document.documentElement.style.setProperty(
          "--cart-drawer__header-height",
          fromTop + "px"
      );
      if (cartWrapperParent.querySelector(".cart-drawer__footer")) {
        document.documentElement.style.setProperty(
            "--cart-drawer__footer-height",
            cartWrapperParent.querySelector(".cart-drawer__footer").offsetHeight + "px"
        );
      }
    }, 100);
    this.loadRecommendations()
  }

  loadRecommendations() {
    this.recommendationLoading = true;
    let recommendationsContainer = this.element.querySelector(
        ".cart-drawer__recommendations"
    );
    if (!recommendationsContainer) return;
    const productId = this.options["productId"];

    const baseUrl = window.routes.localeRootUrl;
    let url;

    // Determine the URL based on whether a product ID is present
    if (!productId) {
      url = "?section_id=helper-recommendations";
    } else {
      let limit = this.element.getAttribute("product-limit");
      url = `${baseUrl}/recommendations/products?section_id=helper-recommendations&product_id=${productId}&l${limit}&intent=${this.options["intent"]}`;
    }

    if (!recommendationsContainer) return;
    recommendationsContainer.classList.remove("transition--done");
    if (this.recommendationsOpen == true) {
      recommendationsContainer.classList.add("transition");
    }

    return fetch(url)
        .then((response) => response.text())
        .then((content) => {
          this.recommendationLoading = false;
          const container = document.createElement("div");
          container.innerHTML = content;

          let recommendationsHTML = container.querySelector(
              ".cart-drawer__upsell"
          )?.innerHTML;

          if (recommendationsHTML) {
            recommendationsContainer.innerHTML = recommendationsHTML;
            new AddToCart(this.element);
            if (window.theme.enableAnimations) {

              //    new RevolutionAnimation(recommendationsContainer);

            }

          }
        })
        .catch((error) => {
          console.error("Failed to load recommendations:", error);
        });
  }

  handleTransitionRec(target, container) {
    if (event.propertyName !== "transform") return;
    target.setAttribute("aria-hidden", "true");
    target.style.display = "none";
    container.classList.remove("transition");
    this.recommendationsOpen = false;
    this.el.removeEventListener("transitionend", this.transitionRecEnd);
  }

}
customElements.define("cart-drawer", cartDrawer);

class MainCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.bindEvents();
  }

  bindEvents() {
    this.delegateElement.on(
        "keydown",
        ".cart-item__quantity",
        this.onCartQuantityKeydown.bind(this)
    );
  }

  async onCartQuantityKeydown(event, target) {
    if (event.key !== "Enter") return;
    if (!target || !target.classList || !target.classList.contains("cart-item__quantity")) return;

    event.preventDefault();
    event.stopPropagation();

    const isCartPage = window.location.pathname.endsWith("/cart");

    // Non-cart pages: just block submit. Native `change` will fire on Enter and the
    // existing cart-drawer handler picks it up — no need to dispatch manually.
    if (!isCartPage) return;

    // Cart page in this theme has a form action="/checkout", so we update via ajax then reload.
    const changedLineKey = target.getAttribute("data-line-id") || "";
    const quantity = Math.max(parseInt(target.value, 10) || 0, 0);
    if (!changedLineKey) return;

    try {
      await fetch(`${window.routes.localeRootUrl}/cart/change.js`, {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({ id: changedLineKey, quantity }),
      });
    } finally {
      window.location.reload();
    }
  }
}
customElements.define("main-cart", MainCart);

class CardPopUpContent extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this);
    this.domDelegate = new Delegate(document.body);
    new AddToCart(this);
    new Drawer(this);
    this.bindEvents();
  }

  bindEvents() {
    this.domDelegate.on(
        "product-card-drawer:open",
        this.replaceContent.bind(this)
    );

    this.delegateElement.on("selectbox:change", this.updateVariant.bind(this));

  }

  replaceContent(e) {
    e.preventDefault();

    const productId = e.detail.product;
    const contentToInsert = document.body.querySelector(
        `.product-popup__inner-content[data-product-id="${productId}"]:not(.copy)`
    );

    if (!contentToInsert) return;

    const freshClone = contentToInsert.cloneNode(true);
    freshClone.classList.add("copy");

    const contentToReplace = this.element.querySelector(".product-card__popup-scrollable-content");
    contentToReplace.innerHTML = "";
    contentToReplace.appendChild(freshClone);
    contentToReplace.classList.add("mobile__popup-scrollable-content");

    const variantSelectboxes = this.element.querySelectorAll('.product-card__variant-options .option-selector');

    variantSelectboxes.forEach(selector => {
      new RevolutionSelectboxV2(selector, true, true, '.option-selector__wrapper', 'variants');
    });

    setTimeout(() => {
      const cardHeight = this.getBoundingClientRect().height;
      document.documentElement.style.setProperty("--drawer-height", `${cardHeight}px`);
    }, 100);
  }

  updateVariant() {
    this.checkSelected();
  }

  checkSelected() {

    const options = this.element.querySelectorAll('.option-selector__selected-option:not(.pack-selector .option-selector__selected-option)');
    const allChecked = Array.from(options).every(option =>
        option.classList.contains('selected')
    );
    if (allChecked) {
      this.updateMasterId();
    }
  }

  updateMasterId() {
    // 1) Collect selected options (desktop vs mobile)
    const isDesktop = responsive.matchesBreakpoint('lap_and_up');
    const options = (this.isDefault && isDesktop)
        ? this.updateOptionsDesktop()
        : this.updateOptions();

    // 2) Load variant JSON (scoped to this element)
    const variantJsonEl = this.element.querySelector('[type="application/json"]');
    if (variantJsonEl) {
      try {
        this.variantData = JSON.parse(variantJsonEl.textContent);
      } catch (e) {
        this.variantData = [];
      }
    }

    // 3) Find the variant that matches current selections
    let matched = this.variantData?.find(v =>
        options.every(o => v.options.includes(o))
    ) || null;

    // 4) Resolve current popup scope
    const currentPopup = this.isDefault
        ? (this.element.querySelector('.product-popup__content') || this.element)
        : (this.element.querySelector('.product-card__cart-wrapper-link') || this.element);

    // 5) Grab important nodes in the popup
    const idInput = currentPopup.querySelector('.product-card__form input[name="id"]'); // <-- keep this selector exact
    const atcBtn  = currentPopup.querySelector('.product-card__atc-button');
    const errText = currentPopup.querySelector('.option-selector__error-text');
    const qtyInput = currentPopup.querySelector('.quantity-product-card');

    // Helper to show/hide error and enable/disable ATC consistently
    const setState = (variant) => {
      if (variant) {
        if (idInput) idInput.value = variant.id;
        if (atcBtn) {
          if (variant.available) {
            atcBtn.removeAttribute('disabled');
            atcBtn.setAttribute('data-check', 'true');
          } else {
            atcBtn.setAttribute('disabled', 'true');
            atcBtn.setAttribute('data-check', 'false');
          }
        }
        if (errText) errText.setAttribute('aria-hidden', 'true');
      } else {
        if (idInput) idInput.value = '';
        if (atcBtn) {
          atcBtn.setAttribute('disabled', 'true');
          atcBtn.setAttribute('data-check', 'false');
        }
        if (errText) errText.setAttribute('aria-hidden', 'false');
      }
    };

    // 6) If we have a match, handle multipack => 1-pack + quantity
    if (matched) {
      // if option2 looks like "3-pack[...]"/"8-pack [..]" etc → set quantity to leading number
      if (matched.option2 && /pack/i.test(matched.option2)) {
        const leadingQty = parseInt((matched.option2.match(/^(\d+)/) || [ , '1' ])[1], 10);
        if (qtyInput && !Number.isNaN(leadingQty)) qtyInput.value = leadingQty;

        const matchedValue = ["pack", "packung", "pakke"];
        // Swap to the 1-pack sibling for the same option1
        const onePack = this.variantData.find(v => {
          if (v.option1 !== matched.option1) return false;

          // Extract number (works with "1 pack", "1-packung", "1pakke", etc)
          const qty = parseInt(v.option2.match(/\d+/)?.[0] ?? 0, 10);
          if (qty !== 1) return false;

          const lower = v.option2.toLowerCase();

          return matchedValue.some(label => lower.includes(label));
        });

        if (onePack) matched = onePack;
      }

      // 7) Write ID + toggle ATC
      setState(matched);
    } else {
      // 8) No variant yet (not all options selected / invalid combo)
      setState(null);
    }

    // 9) Keep reference
    this.currentVariant = matched;
  }

  updateOptions() {
    return Array.from(this.element.querySelectorAll('.product-card__variant-options .option-selector__selected-option:not(.pack-selector .option-selector__selected-option)')).map(option => option.textContent.trim());
  }

}

customElements.define("mobile-product-card", CardPopUpContent);

class FeaturedCollectionSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.domDelegate = new Delegate(this.element);
    this.carouselElement = this.element.querySelector(".featured-collection__swiper");
    this.carousel = new RevolutionSwiper(this.carouselElement);

    this.bindEvents();
  }

  bindEvents() {
    this.isPageLoaded =
        document.readyState === "complete" ||
        document.readyState === "loaded" ||
        document.readyState === "interactive";
    if (!this.isPageLoaded) {
      window.addEventListener("load", this.onPageLoaded.bind(this));
    } else {
      this.onPageLoaded();
    }
  }

  onPageLoaded() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      if (!this.carousel) {
        this.carousel = new RevolutionSwiper(this.carouselElement);
      }
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "-100px 0px 200px 0px",
    }).observe(this);
  }
}
customElements.define("featured-collection", FeaturedCollectionSection);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateBody = new Delegate(document.body);
    const swiperElem = this.element.querySelector(".product-recommendations__swiper");

    if(swiperElem){
      new RevolutionSwiper(swiperElem);
    }


  }

  connectedCallback() {
    this.delegateBody.on('recommendations:reload', this.reloadRecommendations.bind(this));
    this.loadRecommendations(this.dataset.url);

  }

  reloadRecommendations(e) {
    const productId = e.detail;
    const url = this.dataset.urlTemplate.replace("PRODUCT_ID", productId);
    this.loadRecommendations(url);
  }

  async loadRecommendations(url) {
    try {
      const response = await fetch(url);
      const text = await response.text();

      const html = new DOMParser().parseFromString(text, "text/html")

      const newSwiper = html.querySelector(".product-recommendations__swiper");
      const oldSwiper = this.element.querySelector(".product-recommendations__swiper");
      if (newSwiper) {
        oldSwiper.parentElement.replaceChild(newSwiper, oldSwiper);
         // new RevolutionAnimation(this.element);
        new RevolutionSwiper(newSwiper);

        new AddToCart(this.element)
      }
    } catch (e) {
      console.error(e);
    }
  }
}
customElements.define("product-recommendations", ProductRecommendations);

class CollectionShowcase extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.options = JSON.parse(this.element.getAttribute("data-section-settings"));
    this.responsive = new Responsive();

    this.carouselElement = this.element.querySelector(".collection-showcase__wrapper");

    if (this.carouselElement) {
      if ((responsive.matchesBreakpoint("pocket") && this.options.slideshowMobile) ||
          (responsive.matchesBreakpoint("lap_and_up") && this.options.slideshowDesktop)) {
        this.carousel = new RevolutionSwiper(this.carouselElement);
      }
    }
  }
}

customElements.define("collection-showcase", CollectionShowcase);


class SliderTextSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.carouselElement = this.element.querySelector(".swiper");
    this.carousel = new RevolutionSwiper(this.carouselElement);


  }
}
customElements.define("slider-text", SliderTextSection);

class SmallCollectionShowcase extends HTMLElement {
  constructor() {
    super();
    this.element = this;
  }

  connectedCallback() {
    this.delegateElement = new Delegate(this.element);
    this.carouselElement = this.element.querySelector(".swiper");
    this.wrapper = this.element.querySelector(".small-collection-showcase__wrapper"); // NEW
    this.scrollbar = this.element.querySelector(".swiper-scrollbar");                 // NEW

    this.carousel = new RevolutionSwiper(this.carouselElement);

    // Initial title clamp based on scrollbar margin
    this.applyTitleClamp(); // NEW

    // Re-apply on window resize (remember handler for cleanup)
    this._onResize = () => this.applyTitleClamp(); // NEW
    window.addEventListener('resize', this._onResize, { passive: true }); // NEW

    // Also re-apply when Swiper resizes / hits breakpoints
    if (this.carouselElement?.swiper) { // NEW
      this.carouselElement.swiper.on('resize', this._onResize);
      this.carouselElement.swiper.on('breakpoint', this._onResize);
      // After init tick (in case styles land after init)
      setTimeout(this._onResize, 0);
    }

    if (!this.carouselElement.swiper.params.autoplay?.enabled) return;

    this.sectionSettings = JSON.parse(
      this.element.getAttribute("data-section-settings") || "{}"
    );
    this.originalSpeed =
      this.sectionSettings.transitionSpeed ||
      this.carouselElement.swiper.params.speed;

    this.carouselElement.swiper.params.speed = this.originalSpeed;

    setTimeout(() => {
      const swiper = this.carouselElement.swiper;
      this.increment = swiper.translate - swiper.getTranslate();
      if (!this.increment) {
        this.increment = swiper.width / (swiper.params.slidesPerView || 1);
      }
    }, 100);

    const animatedWrapper = this.element.querySelector(".swiper-wrapper-animation");
    if (animatedWrapper) {
      animatedWrapper.style.transitionDuration = `${this.originalSpeed}ms`;
      if (document.readyState === "loading") {
        window.addEventListener("DOMContentLoaded", () => this.bindEvents(), {
          once: true,
        });
      } else {
        this.bindEvents();
      }
    }
  }

  // Clean up listeners when element is removed
  disconnectedCallback() { // NEW
    if (this._onResize) {
      window.removeEventListener('resize', this._onResize);
      this.carouselElement?.swiper?.off('resize', this._onResize);
      this.carouselElement?.swiper?.off('breakpoint', this._onResize);
    }
  }

  // Compute margin-top of scrollbar and toggle classes
  applyTitleClamp() { // NEW
    if (!this.wrapper || !this.scrollbar) return;
    const mt = parseFloat(getComputedStyle(this.scrollbar).marginTop) || 0;

    // clear previous state
    this.wrapper.classList.remove('two-lines', 'three-lines');

    // apply exactly one state
    if (mt > 18) {
      this.wrapper.classList.add('three-lines');
    } else if (mt >= 14) {
      this.wrapper.classList.add('two-lines');
    }
  }

  bindEvents() {
    this.onMouseEnterBinder = this.onMouseEnter.bind(this);
    this.onMouseLeaveBinder = this.onMouseLeave.bind(this);
    this.listenerBinder = this.transitionDone.bind(this);
    this.transitionStart = this.onUserInteraction.bind(this);
    this.touchEnd = this.onTouchEnd.bind(this);

    this.delegateElement.on('mouseenter', '.small-collection-showcase__wrapper', this.onMouseEnterBinder, true)
    this.delegateElement.on('mouseleave', '.small-collection-showcase__wrapper', this.onMouseLeaveBinder, true)
    this.carouselElement.swiper.on('touchStart', this.onUserInteraction.bind(this));
    this.carouselElement.swiper.on('touchEnd', this.onTouchEnd.bind(this));
  }

  transitionDone() {
    this.carouselElement.swiper.params.speed = this.originalSpeed;
    this.element.querySelector('.swiper-wrapper').classList.add('swiper-wrapper-animation');
    if (this.carouselElement.swiper.wrapperEl.classList.contains('mouse-entered')) {
      this.carouselElement.swiper.autoplay.pause();
    } else {
      this.carouselElement.swiper.autoplay.resume();
    }
    this.carouselElement.swiper.off('transitionEnd', this.listenerBinder);
  }

  onTouchEnd() {
    this.carouselElement.swiper.on('transitionEnd', this.listenerBinder);
    this.carouselElement.swiper.params.speed = 300;
  }

  onUserInteraction() {
    this.carouselElement.querySelector('.swiper-wrapper').classList.remove('quote__wrapper-animation-disable');
    this.carouselElement.swiper.wrapperEl.style.transitionDuration = '0ms';
    this.carouselElement.swiper.params.speed = 0;
    this.element.querySelector('.swiper-wrapper').classList.remove('swiper-wrapper-animation');
  }

  onMouseEnter(e) {
    if (!e.target.classList.contains('small-collection-showcase__wrapper')) return;
    this.duration = (Math.abs(this.carouselElement.swiper.translate) - Math.abs(this.carouselElement.swiper.getTranslate())) / Math.abs(this.increment) * this.originalSpeed;
    this.real = this.carouselElement.swiper.getTranslate();
    this.carouselElement.querySelector('.swiper-wrapper').style.transform = `translate3d(${this.real}px, 0, 0)`;
    this.carouselElement.querySelector('.swiper-wrapper').classList.add('quote__wrapper-animation-disable');
    this.carouselElement.swiper.wrapperEl.classList.add('mouse-entered');
    this.carouselElement.swiper.autoplay.pause();
  }

  onMouseLeave(e) {
    if (!e.target.classList.contains('small-collection-showcase__wrapper')) return;
    this.carouselElement.querySelector('.swiper-wrapper').classList.remove('quote__wrapper-animation-disable');
    this.carouselElement.swiper.wrapperEl.classList.remove('mouse-entered');
    this.carouselElement.swiper.speed = this.duration;
    this.carouselElement.swiper.wrapperEl.style.transitionDuration = `${this.duration}ms`;
    this.carouselElement.swiper.update();
    this.carouselElement.swiper.autoplay.resume();
  }
}


customElements.define("small-collection-showcase", SmallCollectionShowcase);

class Banner extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.delegateBody = new Delegate(document.body);
    this.delegateElement = new Delegate(this.element);
    this.createObserver();
  }

  createObserver() {
    this.observer = new IntersectionObserver(this.handleIntersect.bind(this), {
      threshold: 0.5,
    });

    const target = this.element;
    this.observer.observe(target);
  }

  handleIntersect(entries) {
    var _this = this;
    entries.forEach((entry) => {
      if (entry.intersectionRatio === 1 || entry.isIntersecting == true) {
        _this.changeImageQuality(true);
        _this.observer.unobserve(_this);
      }
    });
  }

  changeImageQuality(singleItem) {
    // Get the current breakpoint.
    const breakpoint = responsive.getCurrentBreakpoint();

    let imageContainers;
    // Determine which element(s) to search for based on the singleItem parameter.
    if (singleItem) {
      imageContainers = Array.from(this.element.querySelectorAll(".image__element")).slice(0, 2);
    } else {
      const currentIndex = this.carousel.swiperElement.activeIndex;
      const cellElement = this.carousel.swiperElement.slides[currentIndex];

      imageContainers = Array.from(cellElement.querySelectorAll(".image__element")).slice(0, 2);
    }

    // If no image containers are found, return.
    if (imageContainers.length === 0) return;

    // Determine which image to reveal based on the current breakpoint.
    let imageToReveal;
    if (breakpoint === "pocket" || breakpoint === "phone" || breakpoint === "tablet") {
      imageToReveal = imageContainers[0];
    } else {
      if (imageContainers.length == 2) {
        imageToReveal = imageContainers[1];
      } else {
        imageToReveal = imageContainers[0];
      }
    }

    // If the image to reveal is not found or has already been loaded, return.
    if (!imageToReveal || imageToReveal.dataset.loadedImage === "true") return;

    if (imageToReveal.dataset.src) {
      // Replace the image URL with a higher quality version.
      const replaceUrl = imageToReveal.dataset.src.replace("{width}x", "width=2600");
      imageToReveal.src = replaceUrl;
      imageToReveal.dataset.loadedImage = "true";
    }
  }
}

customElements.define("banner-hero", Banner);

class Header extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.prevOffset = window.scrollY;
    this.announcementBar = document.querySelector(".announcement-bar");

  }

  connectedCallback() {
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.options = JSON.parse(this.getAttribute("data-settings"));
    this.scrollableElement = this.element.querySelector("[data-scrollable]");
    this.headerTransparent = false;
    const selectBoxes = this.element.querySelectorAll(".RevolutionSelectbox");
    if (selectBoxes.length > 0) {
      selectBoxes.forEach((item, i) => {
        new RevolutionSelectbox(item);
      });
    }

    document.documentElement.style.setProperty(
        "--header-height-fixed",
        document.querySelector("#header").offsetHeight + "px"
    );

    this.updateVisibleHeight();
    window.onload = () => setTimeout(() => this.updateVisibleHeight(), 500);
    this.bindEvents();
    this.adjustListItems();
  }

  // Add a disconnectedCallback for cleanup
  disconnectedCallback() {
    window.removeEventListener("scroll", this.throttledToggle);
    window.removeEventListener("resize", this.updateVisibleHeight.bind(this));
    window.removeEventListener("resize", this.adjustListItemsListener);
    this.delegateBody.off("menu:close", this.closeMenu.bind(this), true);
  }


  bindEvents() {
    const _this = this;
    document.addEventListener("shopify:section:load", function () {
      _this.adjustListItems();
    });
    this.adjustListItemsListener = this.adjustListItems.bind(this);
    window.addEventListener("resize", this.adjustListItemsListener);

    // Use the throttled function for the scroll listener
    window.addEventListener("scroll", this.throttledToggle);

    this.delegateBody.on("menu:close", this.closeMenu.bind(this), true);
    this.delegateElement.on("mouseenter", "[aria-hasMenu='true']", this.openMenu.bind(this), true);
    this.delegateElement.on("focusin", "[aria-hasMenu='true']", this.openMenu.bind(this), true);
    this.delegateElement.on("mouseleave", "[aria-submenu]", this.closeMenu.bind(this), true);
    this.delegateElement.on("mouseenter", "[aria-singlemenu]", this.closeMenu.bind(this), true);
    this.delegateElement.on("focusin", "[aria-singleMenu], .header__link--main", this.closeMenu.bind(this), true);

    window.addEventListener("resize", this.updateVisibleHeight.bind(this));
  }



  adjustListItems() {
    const ul = document.querySelector('.header-menu-items');
    const listItems = ul.querySelectorAll('.header__link--main');

    if (listItems.length === 0) return;

    let screenWidth = window.innerWidth;
    let headerWidth = this.element.querySelector('.header--Wrapper').offsetWidth;
    let listWidth = ul.offsetWidth;
    let padding = 48;
    const totalItems = listItems.length;
    let itemWidth = Math.floor((screenWidth - (headerWidth - listWidth) - padding) / totalItems);

    if (itemWidth > 141) {
      itemWidth = 141;
    }

    listItems.forEach(a => {
      a.style.minWidth = `${itemWidth}px`;
    });
  }
  updateVisibleHeight() {
    setTimeout(() => {
      const rect = this.element.getBoundingClientRect();
      const windowHeight = window.innerHeight;

      let visibleHeight =
          Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0);

      visibleHeight = Math.max(visibleHeight, 0);
      document.documentElement.style.setProperty(
          "--header-dynamic-height",
          `${visibleHeight}px`
      );

      document.documentElement.style.setProperty(
          "--header-height-fixed",
          document.querySelector("#header").offsetHeight + "px"
      );

      const mobileMenuHeight = document.querySelector(".mobile-menu").offsetHeight

      document.documentElement.style.setProperty(
          "--mobile-menu-dynamic-height",
          `${mobileMenuHeight}px`
      )

    }, 550);

  }
  updateMenuPosition() {
    document.documentElement.style.setProperty(
        "--submenu-position",
        `${document.querySelector("#header").offsetHeight}px`
    );
  }
  openMenu(event, target) {
    this.element.dispatchEvent(new CustomEvent("menu:open", {
      bubbles: true
    }));
    if (event.type === "mouseenter" && target !== event.target) {
      return;
    }
    this.updateMenuPosition(target);
    if (this.element.classList.contains("Header--Transparent")) {
      this.element.classList.remove("Header--Transparent");
      this.headerTransparent = true;
    }
    target.setAttribute("aria-expanded", "true");
    const siblings = Array.from(target.parentElement.children).filter(
        (child) =>
            child !== target && child.getAttribute("aria-expanded") === "true"
    );
    siblings.forEach((item) => item.setAttribute("aria-expanded", "false"));
    bodyScrollLock.disableBodyScroll(
        this.scrollableElement,
        bodyScrollLockOptions
    );
  }
  closeMenu(event, target) {
    if (event.type === "mouseleave" && target !== event.target) {
      return;
    }
    const allOpen = this.element.querySelectorAll('[aria-expanded="true"]');
    allOpen.forEach(function (item) {
      item.setAttribute("aria-expanded", "false");
    });
    bodyScrollLock.clearAllBodyScrollLocks();
  }
}

customElements.define("header-component", Header);
class MainMenuDropdown extends HTMLElement {
  constructor() {
    super();
    this.element = this;
  }

  connectedCallback() {
    this.delegateElement = new Delegate(this.element);
    const selectBoxes = this.element.querySelectorAll(".RevolutionSelectbox");
    if (selectBoxes.length > 0) {
      selectBoxes.forEach((item, i) => {
        new RevolutionSelectbox(item);
      });
    }
    this.sidebarMenu = new Drawer(this.element, {
      onClose: () => {
        const submenus = this.element.querySelectorAll('.mobile-menu__grid');
        submenus.forEach(menu => {
          menu.setAttribute('aria-hidden', 'true');
          menu.setAttribute('aria-expanded', 'false');
          menu.classList.remove('slide-left')
        })
        this.element.querySelector('.mobile-menu__grid--level-one').setAttribute('aria-hidden', 'false');
        this.element.querySelector('.mobile-menu__grid--level-one').setAttribute('aria-expanded', 'true');
        bodyScrollLock.clearAllBodyScrollLocks();
        this.element.querySelector('#quickSearch')?.dispatchEvent(
            new CustomEvent("close:search", { bubbles: true })
        );
      }
    })
    this.bindEvents();
  }

  bindEvents() {
    document.addEventListener("sidebar-drawer:open", this.onDrawerListener);

    this.delegateElement.on("click", "[data-action='open-submenu'], [data-action='close-submenu']", this.toggleSubmenu.bind(this));
  }

  toggleSubmenu(event, target) {
    event.preventDefault();

    const id = target.getAttribute('aria-controls');
    const submenuToShow = this.element.querySelector(`#${id}`);
    const submenuToHide = this.element.querySelector('.mobile-menu__grid[aria-expanded="true"]');

    const hideLevel = submenuToHide.dataset.menu_level;
    const showLevel = submenuToShow.dataset.menu_level;
    const level_diff = hideLevel - showLevel;

    if (level_diff < 0) {
      submenuToHide.classList.add('slide-left');
    }

    if (level_diff > 0) {
      submenuToHide.classList.remove('slide-left');
    }

    submenuToHide?.setAttribute('aria-expanded', 'false');
    bodyScrollLock.enableBodyScroll(submenuToHide);
    submenuToHide?.addEventListener('transitionend', () => {
      submenuToHide.setAttribute('aria-hidden', 'true');
      submenuToHide.classList.remove('is-disabled');
    }, { once: true });

    submenuToShow?.setAttribute('aria-hidden', 'false');
    submenuToShow?.setAttribute('aria-expanded', 'true');
    submenuToShow?.addEventListener('transitionend', () => {
      submenuToShow.classList.remove('is-disabled');
    }, { once: true });

    requestAnimationFrame(() => {
      bodyScrollLock.disableBodyScroll(submenuToShow);
    });


    submenuToShow.classList.contains('mobile-menu__grid--level-one') ? removeTrapFocus() : trapFocus(submenuToShow);
  }
}
customElements.define("main-menu-dropdown", MainMenuDropdown);


class Transition {
  constructor() {
    this.pageOverlay = document.querySelector(".pageTransition");

    if (!this.isPageLoaded) {

      document.addEventListener(
          "DOMContentLoaded",
          this.onPageLoaded.bind(this)
      );
    } else {
      this.onPageLoaded();
    }
  }

  onPageLoaded() {
    this.isPageLoaded = true;
    if (this.pageOverlay && window.theme.showPageTransition) {
      this.pageOverlay.animate([{ opacity: 1 }, { opacity: 0 }], {
        duration: 100,
        fill: "forwards",
        easing: "ease-in-out",
        iterations: 1,
      });
    }
  }

  onPageUnload(event, target) {
    if (
        event.defaultPrevented ||
        event.ctrlKey ||
        event.metaKey ||
        !window.theme.showPageTransition ||
        !this.pageOverlay
    ) {
      return;
    }

    event.preventDefault(); // Prevent the click to happen

    if (this.pageOverlay) {
      var timeline = new TimelineLite({
        onComplete: function onComplete() {
          window.location.href = target.href;
        },
      });

      timeline.fromTo(
          this.pageOverlay,
          0.25,
          { autoAlpha: 0, ease: Linear.easeNone },
          { autoAlpha: 1, ease: Linear.easeNone }
      );
    }
  }
}
new Transition();


class VideoComponent extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.options = JSON.parse(
        this.element.getAttribute("data-section-settings")
    );
    this.trueObserver = false;
    this.delegateElement = new Delegate(this.element);

    if (this.options["using_fade"] == "fade" && new Responsive().matchesBreakpoint("pocket")) {
      if (
          this.element.dataset.position == 0 ||
          this.element
              .closest(".swiper-slide")
              .classList.contains("swiper-slide-active") ||
          this.element
              .closest(".swiper-slide")
              .classList.contains("swiper-slide-duplicate-active")
      ) {
        this.checkLoaded();
        this.bindEvents();
      } else {
        this.bindEvents();
      }
    } else {
      this.checkLoaded();
    }
  }

  bindEvents() {
    window.removeEventListener(
        "swiper:slide-changed",
        this.onSlideChangeListener
    );
    this.onSlideChangeListener = this.onSlideChange.bind(this);
    window.addEventListener("swiper:slide-changed", this.onSlideChangeListener);
  }

  checkLoaded() {
    var _this = this;
    if (typeof videojs !== "undefined") {
      this.videoPlayerInitialization();
    } else {
      loadScript(window.theme.videoScript);
      setTimeout(function () {
        _this.checkLoaded();
      }, 100);
    }
  }

  onSlideChange(event) {
    this.elementPosition = parseInt(this.element.getAttribute("data-position"));
    if (event.detail.currentIndex == this.elementPosition) {
      if (!this.element.getAttribute("loaded")) {
        var node = document.createElement("div");
        node.appendChild(
            this.element
                .querySelector("template")
                .content.firstElementChild.cloneNode(true)
        );
        this.element.appendChild(node.firstElementChild).focus();
        this.element.setAttribute("loaded", true);
        if (!this.videoPlayer) {
          this.checkLoaded();
        } else {
          if (this.options["viewport"]) {
            this.videoPlayer.play();
            this.createObserver();
          }
        }
      } else {
        if (!this.videoPlayer) {
          this.checkLoaded();
        } else {
          if (this.options["viewport"]) {
            this.videoPlayer.play();
            this.createObserver();
          }
        }
      }
    } else if (
        this.videoPlayer &&
        this.videoPlayer.el_.classList.contains("vjs-playing")
    ) {
      this.videoPlayer.pause();
    }
  }

  videoPlayerInitialization() {
    if (!this.element.getAttribute("loaded")) {
      const node = document.createElement("div");
      node.appendChild(
          this.element
              .querySelector("template")
              .content.firstElementChild.cloneNode(true)
      );
      this.element.appendChild(node.firstElementChild).focus();
      this.element.setAttribute("loaded", true);
    }

    const isMobile = responsive.matchesBreakpoint("pocket");

    let aspect_ratio = "";
    let src = "";
    let host = "html5";

    if (isMobile) {
      aspect_ratio = this.options["aspect_mob"] || "9:16";

      if (this.options["videoType"] == "video_inside_media") {
        const sources = this.options["videod"]["sources"];
        let topQuality = null;
        sources.forEach((obj) => {
          if (obj.format === "mp4") {
            if (!topQuality) topQuality = obj;
            if (topQuality.height < obj.height) topQuality = obj;
          }
        });
        const aspectRatioHeight = Math.floor(
            100 / this.options["videod"]["aspect_ratio"]
        );
        if (!this.options["video_ratio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        }
        src = topQuality["url"] + "#t=0.001";
      } else if (this.options["videoType"] == "video_inside_media_external") {
        const aspectRatioHeight = Math.floor(
            100 / this.options["videom"]["aspect_ratio"]
        );
        if (!this.options["video_ratio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        }
        host = this.options["videom"]["host"];
        if (host == "youtube") {
          src =
              "https://www.youtube.com/watch?v=" +
              this.options["videom"]["external_id"];
        } else {
          src = this.options["videom"]["external_id"];
        }
      } else {
        if (this.options["videom"].includes("youtube")) {
          host = "youtube";
        } else if (this.options["videom"].includes("vimeo")) {
          host = "vimeo";
        }
        src = this.options["videom"];
      }
    } else {
      aspect_ratio = this.options["aspect_desk"] || "16:9";

      if (this.options["videoType"] == "video_inside_media") {
        const sources = this.options["videod"]["sources"];
        let topQuality = null;
        sources.forEach((obj) => {
          if (obj.format === "mp4") {
            if (!topQuality) topQuality = obj;
            if (topQuality.height < obj.height) topQuality = obj;
          }
        });
        src = topQuality["url"] + "#t=0.001";
        const aspectRatioHeight = Math.floor(
            100 / this.options["videod"]["aspect_ratio"]
        );

        if (!this.options["video_ratio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        }
      } else if (this.options["videoType"] == "video_inside_media_external") {
        host = this.options["videod"]["host"];
        const aspectRatioHeight = Math.floor(
            100 / this.options["videod"]["aspect_ratio"]
        );
        if (!this.options["video_ratio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        }
        if (host == "youtube") {
          src =
              "https://www.youtube.com/watch?v=" +
              this.options["videod"]["external_id"];
        } else {
          src = this.options["videod"]["external_id"];
        }
      } else {
        if (this.options["videod"].includes("youtube")) {
          host = "youtube";
        } else if (this.options["videod"].includes("vimeo")) {
          host = "vimeo";
        }
        src = this.options["videod"];
      }
    }
    if (!src) {
      src = "https://www.youtube.com/watch?v=_9VUPq3SxOc";
      host = "youtube";
    }
    const type =
        host === "youtube"
            ? "video/youtube"
            : host === "vimeo"
                ? "video/vimeo"
                : "video/mp4";


    aspect_ratio = aspect_ratio.replace("/", ":");
    const payload = {
      aspectRatio: aspect_ratio,
      autoplay: false,
      muted: this.options["muted"],
      loop: this.options["loop"],
      controls: false,
      poster: false,
      preload: "metadata",
      playsinline: true,
      responsive: true,
      techOrder: [host],
      disablePictureInPicture: true,


      sources: [
        {
          type: type,
          src: src,
        },
      ],
    };

    const videoplayerID = this.element.querySelector("video");
    this.videoPlayer = videojs(videoplayerID, payload);

    const _this = this;
    this.videoPlayer.on("ready", function () {
      _this.element.querySelector(".videoHolder").style.display = "block";

      if (_this.trueObserver == false && _this.options["viewport"]) {
        _this.createObserver();
      }

      _this.bindCustomControls();
    });

    if (this.options["muted"] && host == "vimeo") {
      this.videoPlayer.on("play", function () {
        _this.videoPlayer.muted("true");
      });
    }

    if (this.options["controls"]) {
      if (host == "html5") {
        this.videoPlayer.on("touchstart", function () {
          if (event.target.closest(".vjs-control-bar")) {
            return;
          }

          if (_this.videoPlayer.paused()) {
            _this.videoPlayer.play();
          } else {
            _this.videoPlayer.pause();
          }
        });
      }

      this.videoPlayer.on("click", function () {
        if (event.target.closest(".vjs-control-bar")) {
          return;
        }

        if (_this.videoPlayer.paused()) {
          _this.videoPlayer.play();
        } else {
          _this.videoPlayer.pause();
        }
      });
    }
  }

  bindCustomControls() {
    this.stateElements = this.element.querySelectorAll("[data-action='toggle-state']");
    this.soundElements = this.element.querySelectorAll("[data-action='toggle-sound']");

    if (!this.stateElements.length || !this.soundElements.length) return;

    this.delegateElement.on("click", "[data-action='toggle-state']", () => {
      this.videoPlayer.paused() ? this.videoPlayer.play() : this.videoPlayer.pause();
    });

    this.delegateElement.on("click", "[data-action='toggle-sound']", () => {
      this.videoPlayer.muted() ? this.videoPlayer.muted(false) : this.videoPlayer.muted(true);
    });

    this.videoPlayer.on("play", () => {
      this.stateElements.forEach(el => el.setAttribute("aria-label", "playing"));
    });

    this.videoPlayer.on("pause", () => {
      this.stateElements.forEach(el => el.setAttribute("aria-label", "paused"));
    });

    this.videoPlayer.on("volumechange", () => {
      this.soundElements.forEach(el => el.setAttribute("aria-label", this.videoPlayer.muted() ? "muted" : "unmuted"));
    });
  }


  createObserver() {
    const observer = new IntersectionObserver(this.handleIntersect.bind(this), {
      threshold: 0.2,
      rootMargin: "200px 0px 200px 0px",
    });

    observer.observe(this.element);
    this.trueObserver = true;
  }

  handleIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.intersectionRatio === 1 || entry.isIntersecting == true) {
        if (!this.videoPlayer) {
          this.checkLoaded();
          return;
        }

        if (this.options["viewport"] && this.videoPlayer) {
          this.videoPlayer.muted("true");

          const checkIfPlaying = () => {
            if (!this.videoPlayer.el_.classList.contains("vjs-playing")) {
              this.videoPlayer.play();
              setTimeout(checkIfPlaying, 100);
            }
          };

          checkIfPlaying();
        }
      } else if (
          entry.intersectionRatio === 0 ||
          entry.isIntersecting == false
      ) {
        if (
            this.videoPlayer &&
            this.videoPlayer.el_.classList.contains("vjs-playing")
        ) {
          this.videoPlayer.pause();
        }
      }
    });
  }
}
customElements.define("video-component", VideoComponent);

class CanvasImage {
  constructor(imgElement, canvas) {
    this.img = imgElement;
    this.canvas = canvas;

    this.x = FooterComponent.randomNum(0, canvas.width - imgElement.naturalWidth);
    this.y = FooterComponent.randomNum(0, canvas.height - imgElement.naturalHeight);

    this.velocity_x = FooterComponent.randomSign() * FooterComponent.randomNum(1.25, 3.75);
    this.velocity_y = (Math.random() < 0.7 ? -1 : 1) * FooterComponent.randomNum(0.25, 3.75);

    this.gravity = 0.9;
    this.friction = 0.85;

    this.create_time = Date.now();
    this.fading = false;
    this.opacity = 1;
  }
}

class FooterComponent extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.canvas = null;
    this.ctx = null;
    this.images = [];
    this.DEBUG = false;
    this.FPS = 60;
    this.MAGIC_NUM = 4;
    this.LIFETIME = 1000 * 30;

    this.mouse = {
      x: 0,
      y: 0
    };
    this.pushStrength = 0.25;

    this.drawInterval = null;
    this.boundDrawCanvas = null;
    this.intersectionObserver = null;
    this.resizeListenerHandle = null;
  }

  connectedCallback() {
    window.addEventListener("load", () => {
      document.documentElement.style.setProperty(
          '--footer-height',
          this.element.offsetHeight + "px"
      );
    });

    this.resizeListenerHandle = responsive.addResizeListener(this, () => {
      document.documentElement.style.setProperty(
          '--footer-height',
          this.element.offsetHeight + "px"
      );
    });

    this.delegateElement = new Delegate(this.element);
    this.popupInstance = new Popup(this.element);

    this.initCanvas();
  }

  disconnectedCallback() {
    if (this.drawInterval) {
      clearInterval(this.drawInterval);
    }
    if (this.boundDrawCanvas) {
      window.removeEventListener('resize', this.boundDrawCanvas);
    }
    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect();
    }
    if (this.resizeListenerHandle && this.resizeListenerHandle.removeResizeListener) {
      this.resizeListenerHandle.removeResizeListener();
    }
  }

  initCanvas() {
    this.canvas = this.querySelector('.footer__canvas');
    if (!this.canvas) return;

    this.ctx = this.canvas.getContext('2d');

    const imgElements = this.querySelectorAll('.canvas__image');
    imgElements.forEach(img => {
      this.images.push(new CanvasImage(img, this.canvas));
    });

    this.canvas.addEventListener('mousemove', e => {
      const rect = this.canvas.getBoundingClientRect();
      this.mouse.x = e.clientX - rect.left;
      this.mouse.y = e.clientY - rect.top;
    });

    this.boundDrawCanvas = this.drawCanvas.bind(this);
    window.addEventListener('resize', this.boundDrawCanvas);
    this.drawInterval = setInterval(this.boundDrawCanvas, 1000 / this.FPS);

    this.intersectionObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.resetImages();
        }
      });
    }, {
      threshold: 0.1
    });

    this.intersectionObserver.observe(this.canvas);
  }

  drawCanvas() {
    this.clearCanvas();
    this.setCanvasSize();
    for (let img of this.images) {
      this.applyMouseRepulsion(img);
      this.drawImage(img);
      this.moveImage(img);
    }
  }

  clearCanvas() {
    this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
  }

  setCanvasSize() {
    const rect = this.element.getBoundingClientRect();
    this.canvas.width = rect.width;
    this.canvas.height = rect.height;
  }

  drawImage(image) {
    this.ctx.globalAlpha = image.opacity;
    this.ctx.drawImage(
        image.img,
        image.x,
        image.y,
        image.img.naturalWidth,
        image.img.naturalHeight
    );

    if (this.DEBUG) this.drawImageText(image);
  }

  drawImageText(image) {
    let x = Math.round(image.x);
    let y = Math.round(image.y);
    let vx = Math.round(image.velocity_x * 100) / 100;
    let vy = Math.round(image.velocity_y * 100) / 100;

    let text = `x: ${x}, y: ${y}, vx: ${vx}, vy: ${vy}`;

    this.ctx.font = '15px Arial';
    this.ctx.fillText(text, image.x + image.img.width + 5, image.y);

    this.ctx.beginPath();
    this.ctx.moveTo(image.x - image.img.width, image.y + image.img.height);
    this.ctx.lineTo(image.x + image.img.width, image.y + image.img.height);
    this.ctx.stroke();
  }

  applyMouseRepulsion(image) {
    if (
        this.mouse.x >= image.x &&
        this.mouse.x <= image.x + image.img.naturalWidth &&
        this.mouse.y >= image.y &&
        this.mouse.y <= image.y + image.img.naturalHeight
    ) {
      const cx = image.x + image.img.naturalWidth / 2;
      const cy = image.y + image.img.naturalHeight / 2;
      const dx = cx - this.mouse.x;
      const dy = cy - this.mouse.y;
      const dist = Math.hypot(dx, dy) || 1;

      const force = this.pushStrength;
      image.velocity_x += (dx / dist) * force;
      image.velocity_y += (dy / dist) * force;
    }
  }

  moveImage(image) {
    if (image.y + image.img.height >= this.canvas.height) {
      if (image.velocity_y > 0) {
        image.velocity_y = (~image.velocity_y + 1);
      }
      image.velocity_y *= image.gravity;
      image.velocity_x *= image.friction;
    }
    image.y += image.velocity_y;
    if (image.y + image.img.height < this.canvas.height - this.MAGIC_NUM) {
      image.velocity_y += 0.1;
    }

    if (image.x + image.img.width >= this.canvas.width || image.x <= 0) {
      image.velocity_x = ~image.velocity_x + 1;
      image.velocity_x *= image.friction;
    }
    image.x += image.velocity_x;

    if (image.fading) return;

    if (
        Math.floor(image.velocity_x) === 0 &&
        Math.floor(image.velocity_y) === 0 &&
        image.y + image.img.height > this.canvas.height - this.MAGIC_NUM
    ) {
      this.fadeImage(image);
    } else if (Date.now() - image.create_time > this.LIFETIME) {
      this.fadeImage(image);
    }
  }

  fadeImage(image) {
    image.fading = true;
    image.opacity -= 0.01;
    if (image.opacity <= 0) {
      this.deleteImage(image);
    }
  }

  deleteImage(image) {
    const index = this.images.indexOf(image);
    if (index !== -1) {
      this.images.splice(index, 1);
    }
    this.drawCanvas();
  }

  resetImages() {
    this.images.forEach(image => {
      image.x = FooterComponent.randomNum(0, this.canvas.width - image.img.naturalWidth);
      image.y = FooterComponent.randomNum(0, this.canvas.height / 3);
      image.velocity_x = FooterComponent.randomSign() * FooterComponent.randomNum(0.25, 3.75);
      image.velocity_y = FooterComponent.randomSign() * FooterComponent.randomNum(0.25, 3.75);
      image.opacity = 1;
      image.fading = false;
      image.create_time = Date.now();
    });

    this.drawCanvas();
  }

  static randomNum(min, max) {
    return Math.random() * (max - min) + min;
  }

  static randomSign() {
    return Math.random() < 0.5 ? -1 : 1;
  }
}

customElements.define("footer-component", FooterComponent);


class ProductElement extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    this.responsive = new Responsive();
    this.breakpoint = this.responsive.getCurrentBreakpoint();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.setupDelegates();
    this.setupElements();
    this.initializeOptions();

    this.setupComponents();
    this.bindEvents();
  }

  initializeOptions() {
    this.options = JSON.parse(
        this.element.getAttribute("data-section-settings")
    );
  }

  setupElements() {
    this.carouselElement = this.element.querySelector(".mainSwiper");
    this.carouselElementThumbs = this.element.querySelector(".ProductSlider--Thumbnails");
    this.dropdownCarousel = this.element.querySelector(".dropdown-tabs__wrapper.swiper");
    this.stickyAtcButton = document.querySelector(".product-module__product-atc--sticky");
    this.dropdownPDP = this.element.querySelector(".dropdown-pdp");
  }

  setupDelegates() {
    this.domDelegate = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
  }

  setupComponents() {
    // Complementary products wrapper
    this.complementaryEl = this.element.querySelector(
        ".product-info__complementary"
    );
    if (this.complementaryEl) {
      this.handleComplementaryProducts();
    }

    // Main swipers
    if (this.options['slides_number'] > 1) {
      if (this.options['show_thumbnails']) {
        this.carousel = new RevolutionSwiper(
            this.carouselElement,
            this.carouselElementThumbs
        );

      } else {
        this.carousel = new RevolutionSwiper(
            this.carouselElement
        );
      }
    }

    // Sticky ATC
    if (this.options["sticky_atc"]) {
      // Sticky Add to Cart elements
      this.stickyAtcWrapper = this.element.querySelector(
          ".pdp-sticky-product-atc"
      );
      document.body.classList.add('has-sticky');

    } else {
      document.body.classList.remove('has-sticky');
    }
    this.mainAtc = this.element.querySelector(".product-info__actions");


    this.changeImageQuality();

    new AddToCart(this.element);

    //Photo swipe zoom
    if (this.options["enable_zoom"]) {
      new RevolutionImageZoom(this.element, this.carousel);
    }

    // Initialize selectboxes
    this.initSelectboxes();

    if (this.options['variant_image_id'] && this.options['show_variant_image_on_load']) {
      this.updateImage();
    }

    // Initializes and setup info tab dropdown
    if (this.dropdownPDP) {
      if (this.breakpoint === 'pocket' || this.breakpoint === 'phone') {
        this.dropdownCarousel.classList.add("text__fade");
        new RevolutionSwiper(this.dropdownCarousel);

      } else {
        this.dropdownCarousel.classList.remove("text__fade");
      }
      this.setUpTabsContent();
    }
  }

  bindEvents() {

    if (this.stickyAtcWrapper) {
      scrollListener.addScrollListener(this, this.showStickyAtc.bind(this));
    }
    // Sticky Add to Cart functionality
    if (this.options["sticky_atc"] && this.stickyAtcWrapper) {
      this.delegateBody.on("product:added", this.hideStickyTimeout.bind(this));
      this.delegateBody.on("product:error", this.hideStickyTimeout.bind(this));
      window.addEventListener(
          "DOMContentLoaded",
          this.showStickyAtc.bind(this)
      );
    }

    this.domDelegate.on("variant:changed", this.updateImage.bind(this));

    this.domDelegate.on(
        "click",
        "[data-action='toggle-tab']",
        debounce(this.switchTab.bind(this), 200)
    );

    this.domDelegate.on(
        "click",
        "[data-action=select-options]",
        this.selectOptionsAlert.bind(this)
    );
    this.delegateBody.on('click', '[data-action="click-atc"]', this.clickAtc.bind(this));
    this.delegateBody.on("click", '[data-action="go-to-select-options"', this.goToSelectOptions.bind(this));
  }

  clickAtc(event) {
    event.preventDefault();
    document.querySelector('.product-info__actions .product__atc-button').click();
  }
  updateImage(event) {

    let imageID = this.options["variant_image_id"];
    if (event) {
      imageID = event.detail.new_image;
    }
    const selector = "#Image--" + imageID;
    const imageEl = this.element.querySelector(selector);

    const slideElement = imageEl.closest('.swiper-slide');
    const realIndex = Array.from(slideElement.parentNode.children).indexOf(slideElement);

    if (imageEl) {
      this.carousel.selectCell(realIndex);
    }

  }

  changeImageQuality() {
    const imageToReveal =
        this.element.querySelector(".ProductSlider--ImageFirst");

    if (imageToReveal) {
      const replaceUrl =
          imageToReveal.getAttribute("data-src")?.replace("{width}x", "2600x");
      imageToReveal.src = replaceUrl;
    }
  }


  selectOptionsAlert(event) {
    event.preventDefault();
    const errAlert = this.element.querySelector('.pdp-select-options-alert');
    if (!errAlert) return;

    errAlert.classList.add('visible');
    setTimeout(() => {
      errAlert.classList.remove('visible');

    }, 1000);
  }


  goToSelectOptions(e) {
    e.preventDefault();
    const stickyAtcSelectOptionsButton = this.element.querySelector('.product-module__product-atc--sticky[data-id="sticky-select-options"]');

    if (e.target.dataset.id !== stickyAtcSelectOptionsButton.dataset.id) return;

    const variantSelectors = this.element.querySelector(".VariantSelectors");
    const headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height-fixed')) || 0;

    let offset = headerHeight + 100;

    if (variantSelectors) {
      const targetPosition = variantSelectors.getBoundingClientRect().top + window.scrollY - offset;

      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });
    } else {
      console.warn("VariantSelectors element not found.");
    }
  }


  // Set up tab content dynamically
  setUpTabsContent() {
    const allContents = this.element.querySelectorAll(".product-tab-content");
    const firstTab = this.element.querySelector(".product-info__dropdown-button");
    const firstTabId = firstTab.getAttribute("data-tab-id");

    // Hide all contents initially
    allContents.forEach(content => {
      content.style.display = "none";
      content.style.opacity = "0";
    });

    // Mark first tab as active
    firstTab.classList.add("active");

    // Find and show the first tab's content with fade-in effect
    const firstContent = [...allContents].find(content => content.getAttribute("data-id") === firstTabId);

    if (firstContent) {
      firstContent.style.display = "flex";

      requestAnimationFrame(() => {
        firstContent.classList.add("active");
        firstContent.style.opacity = "1";
      });
    }
  }

  // Handle tab switching
  switchTab(event) {
    const tabButton = event.target;
    const tabId = tabButton.getAttribute("data-tab-id");

    const dropdownTabWrapper = this.element.querySelector(".dropdown-tabs__wrapper");
    const dropDownContentWrapper = this.element.querySelector(".dropdown-contents__wrapper");

    const activeContent = dropDownContentWrapper.querySelector(".product-tab-content.active");
    const newContent = dropDownContentWrapper.querySelector(`[data-id="${tabId}"]`);

    // Prevent switching to already active content
    if (activeContent === newContent) return;

    // Remove active class from current active tab button
    dropdownTabWrapper.querySelectorAll("button.active").forEach(button => button.classList.remove("active"));

    // Add active class to the clicked tab button
    tabButton.classList.add("active");

    if (activeContent) {
      // Fade out current content
      activeContent.style.opacity = "0";

      // Wait for transition to finish before hiding
      activeContent.addEventListener("transitionend", function handleTransition(event) {
        if (event.propertyName === "opacity") {
          activeContent.style.display = "none";
          activeContent.classList.remove("active");
          activeContent.removeEventListener("transitionend", handleTransition);

          // Show new content WITHOUT changing opacity immediately
          newContent.style.display = "flex";
          newContent.style.opacity = "0";

          // Wait for the next animation frame to ensure display change registers
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              newContent.classList.add("active");
              newContent.style.opacity = "1";
            });
          });
        }
      });
    } else {
      // Directly show new content on first load
      newContent.style.display = "flex";
      newContent.style.opacity = "0";

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          newContent.classList.add("active");
          newContent.style.opacity = "1";
        });
      });
    }
  }

  // Hide the sticky Add to Cart button with a timeout
  hideStickyTimeout() {
    this.stickyAtcWrapper.setAttribute("aria-hidden", "true");
    this.hideSticky = true;
    setTimeout(() => {
      this.hideSticky = false;
      this.showStickyAtc();
    }, 3000);
  }

  // Show the sticky Add to Cart button based on scroll position
  showStickyAtc() {
    if (this.hideSticky || !this.stickyAtcWrapper) return;

    const options = {
      root: null,
      threshold: 0,
    };

    // Get footer height and check if it's visible
    const footer = document.querySelector("footer");
    const footerHeight = footer.offsetHeight;

    const checkFooterVisibility = () => {
      return window.innerHeight + window.scrollY >= document.body.offsetHeight - footerHeight;
    };

    // Observer for the main ATC button
    const atcObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.mainAtcVisible = true;
          this.stickyAtcWrapper.setAttribute("aria-hidden", "true");
          document.body.classList.remove("has-sticky");
        } else {
          this.mainAtcVisible = false;
          if (!this.footerVisible) {
            this.stickyAtcWrapper.setAttribute("aria-hidden", "false");
            document.body.classList.add("has-sticky");
          }
        }
      });
    }, options);

    // Observer for the footer to track visibility
    const footerObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        this.footerVisible = entry.isIntersecting;

        if (this.footerVisible) {
          this.stickyAtcWrapper.setAttribute("aria-hidden", "true");
          document.body.classList.remove("has-sticky");
        } else if (!this.mainAtcVisible) {
          this.stickyAtcWrapper.setAttribute("aria-hidden", "false");
          document.body.classList.add("has-sticky");
        }
      });
    }, options);

    // Initial check in case the page loads with the footer already visible
    this.footerVisible = checkFooterVisibility();

    if (this.footerVisible) {
      this.stickyAtcWrapper.setAttribute("aria-hidden", "true");
      document.body.classList.remove("has-sticky");
    } else {
      atcObserver.observe(this.mainAtc);
      footerObserver.observe(footer);
    }
  }


  // Handle fetching and displaying complementary products
  async handleComplementaryProducts() {

    try {

      this.block_options = JSON.parse(
          this.complementaryEl.getAttribute("data-block-settings") || "{}"

      );

      const optionToUse = this.block_options.select_type;

      this.complementaryElWrapper = this.element.querySelector(
          ".product-info__complementary"
      );

      if (optionToUse === "product_list") {
        // Handle local product list
        this.carouselComplementary = this.element.querySelector("#complementarySwiperElement");

        if (this.carouselComplementary && ['phone', 'pocket'].includes(this.breakpoint)) {
          this.NewCarousel = new RevolutionSwiper(this.carouselComplementary);
        }

        if (this.complementaryElWrapper) {
          this.complementaryElWrapper.style.display = "block";
        }

        this.initSelectboxes();
        return;
      }

      // Handle dynamic fetch
      const productId = this.options["product_id"];
      if (!productId) {
        console.warn("Missing product ID.");
        return;
      }

      const url = `${window.routes.recommended_products_url}?section_id=complementary_products_pdp&product_id=${productId}&limit=10&intent=${optionToUse}`;

      const response = await fetch(url);
      if (!response.ok) throw new Error(`Failed to fetch: ${response.status}`);

      const html = await response.text();
      const content = new DOMParser().parseFromString(html, "text/html");

      const contentToInsert = content.querySelector(".complementaryProducts--section");
      const elementToReplace = this.element.querySelector(".product-info__complementary-swiper");

      if (contentToInsert && elementToReplace) {
        elementToReplace.replaceWith(contentToInsert);
      }

      this.carouselComplementary = this.element.querySelector("#complementarySwiperElement");
      if (this.carouselComplementary && ['phone', 'pocket'].includes(this.breakpoint)) {
        this.NewCarousel = new RevolutionSwiper(this.carouselComplementary);
      }

      this.childEl = this.element.querySelector(".product-info--complementary-image");

      if (this.complementaryElWrapper && this.childEl) {
        this.complementaryElWrapper.style.display = "block";
      }


      this.initSelectboxes();
    } catch (error) {
      console.error("Error in handleComplementaryProducts:", error);

    }
  }

  initSelectboxes() {
    const selectBoxes = this.element.querySelectorAll(".RevolutionSelectbox");
    selectBoxes.forEach((item) => {
      new RevolutionSelectbox(item);
    });
  }
}
customElements.define("product-component", ProductElement);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.type = this.element.getAttribute("data-type");
    this.productOptions = this.element.getAttribute("data-product-options");
    this.productID = this.element.getAttribute("data-product-id");
    this.stickyATC = document.querySelector(".pdp-sticky-product-atc");
    this.colorVariantPicker = this.element.querySelector(".SelectBox--Wrapper.circle-selector");
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.atcButtons = document.querySelectorAll(".product__atc-button");
    this.stickyAtcWrapper = document.querySelector(".pdp-sticky-product-atc");
    this.notifyButtons = document.querySelectorAll(
        ".product-module__product-atc-notify"
    );

    this.isMultipack = false;

    this.quantity = document.querySelector('.product-info__actions .quantity-variant');

    this.notifyStickyAddButton = document.querySelector(
        ".product-module__product-atc"
    );

    this.regularPrice = document.querySelector(
        "product-component .product-info__price--regular span"
    );
    this.compareAtPrice = document.querySelector(
        "product-component .product-info__price--compare"
    );

    this.regularPriceSticky = document.querySelector(".product-module__sticky-atc product-info__price--regular span");
    this.compareAtPriceSticky = document.querySelector(".product-module__sticky-atc .product-info__price--compare");

    this.onRefresh();
    this.bindEvents();
    this.initPackQuantity();
  }

  bindEvents() {
    var selectboxes = this.element.querySelectorAll("select, input");
    selectboxes.forEach((item) => {
      item.addEventListener("change", this.onVariantChange.bind(this));
    });

    this.delegateElement.on(
        "click",
        "[data-action=pick-size]",
        this.onPickSize.bind(this)
    );

    this.handleMultiselectAvailability()
  }

  initPackQuantity() {
    const preselected = this.element.querySelector(
        '.RevolutionSelectbox--Item[selected="selected"][data-action="pick-size"]'
    );
    if (!preselected || !this.quantity) return;
    const qty = preselected.getAttribute("data-value");
    if (qty) this.quantity.value = qty;
  }

  onPickSize(event, target) {
    event.preventDefault();

    const item = target.closest('[data-action="pick-size"]');
    if (!item) return;

    const dropdown = item.closest(".RevolutionSelectbox");

    const prevSelected = dropdown.querySelector('.RevolutionSelectbox--Item[selected="selected"]');
    prevSelected?.removeAttribute("selected");

    item.setAttribute("selected", "selected");

    const title = dropdown.querySelector(".RevolutionSelectbox--Title");
    if (title) title.innerHTML = item.innerHTML;

    const quantityInput = document.querySelector(".product-info__actions .quantity-variant");

    if (quantityInput) {
      quantityInput.value = item.getAttribute("data-value");
      quantityInput.dispatchEvent(new Event("change", { bubbles: true }));
    }

    const toggleBtn = dropdown.querySelector(".RevolutionSelectbox--Button");
    const content = dropdown.querySelector(".RevolutionSelectbox--Content");

    toggleBtn?.setAttribute("aria-expanded", "false");
    content?.setAttribute("aria-hidden", "true");
  }

  // Add inside class VariantSelects
  updateBIS(allSelected) {

    // show only when a variant is fully selected AND is out of stock
    if (!allSelected || !this.currentVariant) return;
    if (this.currentVariant.available) return;

    // Show the BIS for this specific variant id
    const selector = `.BIS_trigger[data-variant-id="${this.currentVariant.id}"]`;
    const trigger = document.querySelector(selector);

    if (trigger) {
      trigger.classList.add("is-visible")
      const wrap = trigger.closest('.bis-reset');
      if (wrap) wrap.style.display = 'block !important';
    }
  }


  handleMultiselectAvailability(){
    const multipackDropdown = this.element.querySelector('[data-multipack-select="true"]');
    if (multipackDropdown) {
      const allVariants = JSON.parse(this.querySelector('#variants').textContent);

      const uniqueSizes = [...new Set(allVariants.map(v => v.options[0]))];


      const getQty = str => parseInt(str.match(/\d+/)?.[0] ?? 0);

      const packs = allVariants.filter(
          v => getQty(v.options[1]) === 1 && v.inventory_quantity !== 0
      );

      const currentVariantData = allVariants.find(v => v.id === this.currentVariant.id);
      const inventoryQty = Number(currentVariantData?.inventory_quantity ?? 0);

      const items = multipackDropdown.querySelectorAll('.RevolutionSelectbox--Item');

      const titleButton = multipackDropdown.querySelector('.RevolutionSelectbox--Button .RevolutionSelectbox--Title');
      const SOLD_OUT_TEXT = (window.theme?.i18n?.sold_out || 'SOLD OUT').toUpperCase();

      let availableSuccessDiv = document.querySelector(".availability-success__wrapper");
      let availableErrorDiv = document.querySelector(".availability-error__wrapper");

      const getPackQty = (raw) => {
        const m = String(raw).match(/(\d+)\s*-\s*pack/i);
        return m ? parseInt(m[1], 10) : 1;
      };

      let selectedValue = null;

      const firstItem = items[0].getAttribute('data-value');
      const matchedVariant = allVariants.find(variant =>
          variant.options[0] === this.currentVariant.option1 && variant.options[1] === firstItem
      );


      if(packs.length > 0 && !selectedValue){
        availableSuccessDiv.setAttribute("aria-hidden", "false");
        availableErrorDiv.setAttribute("aria-hidden", "true");
      }
      else{
        availableSuccessDiv.setAttribute("aria-hidden", "true");
        availableErrorDiv.setAttribute("aria-hidden", "false");
      }


      uniqueSizes.forEach(size => {
        const matchedVariant = allVariants.find(variant =>
            variant.options[0] === size && variant.options[1] === firstItem
        );

        if(matchedVariant.inventory_quantity === 0 ){

          const element = document.querySelector(
              `.variant-dropdown .RevolutionSelectbox--Item[data-value="${size}"]`
          );

          const closestsDropdown = element.closest(".variant-dropdown")
          const title = closestsDropdown.querySelector(".RevolutionSelectbox--Title")
          const exisitingElem = element.querySelectorAll(".SelectboxLabelNormal--SoldOut");
          const addition = element.querySelectorAll(".addition");

          addition.forEach(el => {
            el.style.display = 'none';
          })



            exisitingElem.forEach((el) => {
              el.style.display = 'none';
            })


          let badge = document.createElement('span');
          badge.className = 'u-p4 SelectboxLabelNormal--Discount SelectboxLabelNormal--SoldOut';
          badge.textContent = SOLD_OUT_TEXT;
          element.appendChild(badge);


          if(title.innerText == size){
            title.appendChild(badge)
          }
        }
      })

      items.forEach((btn) => {
        const rawValue = btn.dataset.value || btn.textContent.trim();
        const packQty = getPackQty(rawValue);

        const exisitingElem = btn.querySelectorAll(".SelectboxLabelNormal--SoldOut");

        exisitingElem.forEach((el) => {
          el.style.display = 'none';
        })

        // determine sold out for this pack based on inventory
        const isSoldOut = Number.isFinite(inventoryQty) && packQty > inventoryQty;
        if (btn.hasAttribute('selected') || btn.getAttribute('aria-selected') === 'true') {
          selectedValue = { rawValue, packQty, isSoldOut };
        }

        // ensure we don’t duplicate badges
        let badge = btn.querySelector('.SelectboxLabelNormal--SoldOut');
        if ((!badge && isSoldOut) || matchedVariant.inventory_quantity === 0 || isSoldOut ) {
          badge = document.createElement('span');
          badge.className = 'u-p4 SelectboxLabelNormal--Discount SelectboxLabelNormal--SoldOut';
          badge.textContent = SOLD_OUT_TEXT;
          btn.appendChild(badge);
        }

        // toggle badge + disabled state
        if (isSoldOut || matchedVariant.inventory_quantity === 0) {
          if (badge) badge.textContent = SOLD_OUT_TEXT;
          btn.setAttribute('aria-disabled', 'true');
          btn.classList.add('is-disabled');

          // optional: prevent selection
          btn.addEventListener('click', (e) => e.preventDefault(), { once: true });
        } else {
          if (badge) badge.remove();
          btn.removeAttribute('aria-disabled');
          btn.classList.remove('is-disabled');
        }
      });

      if (titleButton) {

        const exisitingElem = titleButton.querySelectorAll(".SelectboxLabelNormal--SoldOut");

        exisitingElem.forEach((el) => {
          el.style.display = 'none';
        })
        // always remove first
        titleButton.querySelector('.SelectboxLabelNormal--SoldOut')?.remove();

        if(selectedValue){
          availableSuccessDiv.setAttribute("aria-hidden", "false");
          availableErrorDiv.setAttribute("aria-hidden", "true");
        }

        if (selectedValue?.isSoldOut || matchedVariant.inventory_quantity === 0) {
          const badge = document.createElement('span');
          badge.className = 'u-p4 SelectboxLabelNormal--Discount SelectboxLabelNormal--SoldOut';
          badge.textContent = SOLD_OUT_TEXT;
          titleButton.appendChild(badge);
          availableSuccessDiv.setAttribute("aria-hidden", "true");
          availableErrorDiv.setAttribute("aria-hidden", "false");
        }
      }
    }
  }
  getQuantityFromMultipackLabel() {

    const getPackQty = (str) => +(str.match(/\d+/)?.[0] ?? 1);
    const multipackOption = this.options[1];
    if (!multipackOption) return 1;

    const quantity = getPackQty(multipackOption.split('-')[0]);
    return parseInt(quantity, 10) || 1;
  }




  onRefresh() {
    this.selectFirstAvailableOnePack();
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton();

    this.updateAvailability();
    this.updateLowestPrice();

    if (this.colorVariantPicker) this.updateColorSelectorAvailability();
    if (this.stickyATC) this.updateStickyVariantInfo();
    if (this.regularPrice && this.compareAtPrice) this.updatePriceElements(this.regularPrice, this.compareAtPrice);
    if (this.stickyAtcWrapper) this.updatePriceElements(this.regularPriceSticky, this.compareAtPriceSticky);
  }

  /**
   * For multipack products: force the multipack selector to the "1-pack" value,
   * then sync every other selector to the first variant available at 1-pack.
   * A size with only multi-pack stock stays visible — we just don't pre-select
   * an unavailable 1-pack combo when a better 1-pack default exists.
   * Runs once on initial mount.
   */
  selectFirstAvailableOnePack() {
    const multipackSelect = this.element.querySelector('select[data-multipack="true"]');
    if (!multipackSelect) return;

    const onePackValue = this._findOnePackValue(multipackSelect);
    if (onePackValue == null) return;

    const variants = this.getVariantData();
    const multipackIdx = this._findMultipackIndex(variants, onePackValue);
    if (multipackIdx < 0) return;

    const pick = this._pickFirstAvailableForOnePack(variants, multipackIdx, onePackValue);
    if (!pick) return;

    this._applyVariantSelection(pick);
  }

  /** Extract the leading integer from a multipack option value (handles "1-pack",
   *  "1 pack", "1 förp", "1-pakke", "1 [Save 10%]"…). Returns NaN if no digit. */
  _getPackQty(raw) {
    const m = String(raw ?? "").match(/\d+/);
    return m ? parseInt(m[0], 10) : NaN;
  }

  /** Find the multipack `<option>` whose leading digit is 1; return its trimmed value. */
  _findOnePackValue(multipackSelect) {
    const onePackOption = Array.from(multipackSelect.options).find(
        (o) => this._getPackQty(o.value) === 1
    );
    return onePackOption ? String(onePackOption.value).trim() : null;
  }

  /** Find which option index (0/1/2) holds the multipack column by probing variants. */
  _findMultipackIndex(variants, onePackValue) {
    if (!variants || !variants.length) return -1;
    const probe = variants.find((v) =>
        v.options.some((o) => String(o).trim() === onePackValue)
    );
    if (!probe) return -1;
    return probe.options.findIndex((o) => String(o).trim() === onePackValue);
  }

  /** First variant that is `available` AND has options[multipackIdx] === 1-pack value. */
  _pickFirstAvailableForOnePack(variants, multipackIdx, onePackValue) {
    return variants.find(
        (v) =>
            v.available &&
            String(v.options[multipackIdx]).trim() === onePackValue
    );
  }

  /** Apply the chosen variant's options to every option block in the picker. */
  _applyVariantSelection(variant) {
    const blocks = this.element.querySelectorAll(
        ".VariantSelectors > .variant-dropdown, .VariantSelectors > .VariantSelect"
    );

    blocks.forEach((block, idx) => {
      const wanted = variant.options[idx];
      if (wanted == null) return;
      const wantedTrim = String(wanted).trim();

      const select = block.querySelector("select.selectboxInputs");
      if (select) {
        this._syncDropdown(block, select, wantedTrim);
      } else {
        this._syncRadioGroup(block, wantedTrim);
      }
    });
  }

  /** Sync a dropdown selector: native <select>.value + RevolutionSelectbox UI. */
  _syncDropdown(block, select, wantedTrim) {
    const match = Array.from(select.options).find(
        (o) => String(o.value).trim() === wantedTrim
    );
    if (!match || select.value === match.value) return;

    select.value = match.value;

    const dropdown = block.querySelector(".RevolutionSelectbox");
    if (!dropdown) return;

    dropdown
        .querySelector('.RevolutionSelectbox--Item[selected="selected"]')
        ?.removeAttribute("selected");

    const newItem = dropdown.querySelector(
        `.RevolutionSelectbox--Item[data-value="${CSS.escape(match.value)}"]`
    );
    if (!newItem) return;

    newItem.setAttribute("selected", "selected");
    const title = dropdown.querySelector(
        ".RevolutionSelectbox--Button .RevolutionSelectbox--Title"
    );
    if (title) title.innerHTML = newItem.innerHTML;
  }

  /** Sync a radio-style selector (box / color circle). */
  _syncRadioGroup(block, wantedTrim) {
    const radios = block.querySelectorAll(
        "input.inputSelectboxCheckbox[type='radio']"
    );
    radios.forEach((r) => {
      r.checked = String(r.value).trim() === wantedTrim;
    });
  }

  onVariantChange(e) {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton();
    this.updateAvailability();
    this.updateLowestPrice();

    if (this.colorVariantPicker) this.updateColorSelectorAvailability();
    if (this.stickyATC) this.updateStickyVariantInfo();
    if (this.regularPrice && this.compareAtPrice) this.updatePriceElements(this.regularPrice, this.compareAtPrice);
    if (this.stickyAtcWrapper) this.updatePriceElements(this.regularPriceSticky, this.compareAtPriceSticky);

    this.updateMedia();
    this.updateURL();
    this.updateVariantInput();
    this.renderProductInfo();
  }

  updateOptions() {
    this.options = Array.from(
        this.querySelectorAll("select, input:checked"),
        (select) => select.value
    );

    if(this.quantity && this.options){
      this.quantity.value = this.getQuantityFromMultipackLabel();
    }
  }

  updateStickyVariantInfo() {
    const optionNameEls = document.querySelectorAll(".product-module__sticky__option-name");
    const optionValueEls = document.querySelectorAll(".product-module__sticky__option-value");

    const currentVariant = this.updateMasterId(); // returns the selected variant object

    let productOptionNames = [];
    try {
      productOptionNames = JSON.parse(this.productOptions);
    } catch (error) {
      console.error("Error parsing product options:", error);
    }

    const selectedValues = currentVariant.options.map(value => value.trim());

    optionNameEls.forEach((nameEl, index) => {
      let name = nameEl.textContent.trim().replace(":", "");

      const matchIndex = productOptionNames.indexOf(name);
      if (matchIndex !== -1 && optionValueEls[index]) {
        const rawValue = selectedValues[matchIndex];

        // Split on `[`, and check if there's a discount
        const parts = rawValue.split("[");
        const mainValue = parts[0].trim();
        const discountValue = parts[1] ? parts[1].replace("]", "").trim() : null;

        // Construct the inner HTML
        let valueHtml = `<span class="u-p3">${mainValue}</span>`;
        if (discountValue) {
          valueHtml += ` <span class="u-p3 SelectboxLabelNormal--Discount">${discountValue}</span>`;
        }

        optionValueEls[index].innerHTML = valueHtml;
      }
    });
  }




  // CHECK COLOR VARIANT AVAILABILITY
  // CAN HAVE MULTIPLE CASES
  // 1. CASE -> THE SELECTS ARE ONE SELECTBOX AND ONE RADIO BUTTON (BLOCK SELECTOR)
  // 2. CASE -> THE SELECTS ARE TWO SELECTBOXES AND ZERO RADIO BUTTON (BLOCK SELECTOR)
  // 3. CASE -> THE SELECTS ARE ZERO SELECTBOXES AND TWO RADIO BUTTONS (BLOCK SELECTORS)

  updateColorSelectorAvailability() {
    // Fetch all variant data
    const allVariantData = this.getVariantData();
    // Fetch all selectboxes in the element
    const selectBoxContainer = this.element.querySelectorAll(".RevolutionSelectbox.dropdownSelector");

    const selectTheAvailableColors = (firstSelectedSelectorValue, secondSelectedSelectorValue) => {
      // Fetch all color swatches (displayed color options)
      const swatchContainers = document.querySelectorAll('.swatch-container');

      // Loop through each color swatch to check availability based on selected options
      swatchContainers.forEach(swatch => {
        const labelElement = swatch.closest('label');
        const colorName = labelElement.getAttribute('data-color');
        const optionIndex = labelElement.getAttribute('data-option-index');

        // Filter out options that aren't related to the color (size and multipack options)
        const parsedOptionIndex = parseInt(optionIndex) - 1;
        const [firstOption, secondOption, thirdOption] = [0, 1, 2].filter(index => index !== parsedOptionIndex);

        // Find matching variants based on the selected size and multipack options
        const matchingVariants = allVariantData.filter(variant =>
            variant.options[firstOption] === firstSelectedSelectorValue &&
            variant.options[secondOption] === secondSelectedSelectorValue
        );

        // Check if the matching variant includes the selected color and is available
        const variant = matchingVariants.find(variant => variant.options[parsedOptionIndex] === colorName);
        if (variant) {
          const notAvailableElement = swatch.querySelector('.not-available');
          notAvailableElement.style.display = variant.available ? 'none' : 'block';
        }
      });
    }


    // --- CASE 1: Multiple Selectboxes ---
    // Handle case when there are more than one select box (two selectboxes or more)
    if (selectBoxContainer.length > 1) {
      let firstSelectBoxId = null;
      let secondSelectBoxId = null;

      // Loop through select boxes to store their IDs
      selectBoxContainer.forEach((container, index) => {
        // Assign IDs to the first and second select box
        if (index === 0) {
          firstSelectBoxId = container.getAttribute("data-select-id");
        } else if (index === 1) {
          secondSelectBoxId = container.getAttribute("data-select-id");
        }
      });

      // Get selected values for the first and second select boxes
      const firstSelectedSelectBoxValue = this.element.querySelector(`select[id="${firstSelectBoxId}"]`)?.value;
      const secondSelectedSelectBoxValue = this.element.querySelector(`select[id="${secondSelectBoxId}"]`)?.value;

      if (firstSelectedSelectBoxValue && secondSelectedSelectBoxValue) selectTheAvailableColors(firstSelectedSelectBoxValue, secondSelectedSelectBoxValue);
    }

    // -------------------------------------------------------------------------------------//

    // --- CASE 2: One Selectbox (with radio buttons for other inputs) ORDER -> RADIO THEN SELECTBOX ---
    // Handle case when there is only one select box and the rest are radio buttons (e.g., size)
    if (selectBoxContainer.length === 1) {
      const selectBoxId = selectBoxContainer[0].getAttribute("data-select-id");

      // Get selected size (radio button) and multipack (select box)
      const selectedRadio = document.querySelector('.inputSelectboxCheckbox:checked')?.value;
      const selectedSelectbox = document.querySelector(`select[id="${selectBoxId}"]`)?.value;

      if (selectedRadio && selectedSelectbox) selectTheAvailableColors(selectedRadio, selectedSelectbox);
    }

    // -------------------------------------------------------------------------------------//

    // --- CASE 3: One Selectbox (with radio buttons for other inputs) ORDER -> SELECTBOX THEN RADIO ---
    // Handle case when there is only one select box and the rest are radio buttons (e.g., size)
    if (selectBoxContainer.length === 1) {
      const selectBoxId = selectBoxContainer[0].getAttribute("data-select-id");

      // Get selected size (radio button) and multipack (select box)
      const selectedRadio = document.querySelector('.inputSelectboxCheckbox:checked')?.value;
      const selectedSelectbox = document.querySelector(`select[id="${selectBoxId}"]`)?.value;

      if (selectedRadio && selectedSelectbox) selectTheAvailableColors(selectedSelectbox, selectedRadio);
    }

    // -------------------------------------------------------------------------------------//

    // --- CASE 4: No Selectbox (Only Radio Buttons) ---
    // Handle case when there are no select boxes, only radio buttons
    if (selectBoxContainer.length < 1) {
      const selectedRadioGroups = this.element.querySelectorAll(".SelectBox--Wrapper.box-selector");

      let firstSelectedRadioGroupId = null;
      let secondSelectedRadioGroupId = null;

      // Loop through radio groups to store their IDs
      selectedRadioGroups.forEach((radio, index) => {
        if (index === 0) {
          firstSelectedRadioGroupId = radio.getAttribute("data-radio-id");
        } else if (index === 1) {
          secondSelectedRadioGroupId = radio.getAttribute("data-radio-id");
        }
      });

      // Get the selected values from radio buttons based on their group IDs
      const firstSelectedRadio = this.element.querySelector(`.SelectBox--Wrapper.box-selector[data-radio-id="${firstSelectedRadioGroupId}"] .inputSelectboxCheckbox:checked`)?.value;
      const secondSelectedRadio = this.element.querySelector(`.SelectBox--Wrapper.box-selector[data-radio-id="${secondSelectedRadioGroupId}"] .inputSelectboxCheckbox:checked`)?.value;

      if (firstSelectedRadio && secondSelectedRadio) selectTheAvailableColors(firstSelectedRadio, secondSelectedRadio);
    }
  }


  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      this.options;
      return !variant.options
          .map((option, index) => {
            return this.options[index] === option;
          })
          .includes(false);
    });

    return this.currentVariant;
  }

  updateAvailability() {
    let availableSuccessDiv = document.querySelector(".availability-success__wrapper");
    let availableErrorDiv = document.querySelector(".availability-error__wrapper")

    if(!this.isMultipack)
    {
      this.currentVariant = this.updateMasterId();
    }



    if (this.currentVariant.available) {
      availableSuccessDiv.setAttribute("aria-hidden", "false");
      availableErrorDiv.setAttribute("aria-hidden", "true");
    } else {
      availableSuccessDiv.setAttribute("aria-hidden", "true");
      availableErrorDiv.setAttribute("aria-hidden", "false");
    }
  }

  updatePriceElements(regularPriceElement, compareAtPriceElement) {
    if (regularPriceElement) {
      this.regularPriceTag = this.currentVariant.price;
      regularPriceElement.innerHTML = Shopify.formatMoney(
          this.regularPriceTag,
          window.theme.moneyFormat
      );
    }

    if (compareAtPriceElement) {
      this.compareAtPriceTag = this.currentVariant.compare_at_price;
      if (this.compareAtPriceTag) {
        compareAtPriceElement.innerHTML = Shopify.formatMoney(
            this.compareAtPriceTag,
            window.theme.moneyFormat
        );
      } else {
        compareAtPriceElement.innerText = "";
      }
    } else if (this.currentVariant.compare_at_price && !compareAtPriceElement) {
      this.compareAtPriceTag = this.currentVariant.compare_at_price;
      const compareAtPriceDiv = document.createElement("span");
      compareAtPriceDiv.className = "u-s2 product-info__price--compare";
      compareAtPriceDiv.textContent = Shopify.formatMoney(
          this.compareAtPriceTag,
          window.theme.moneyFormat
      );

      if (this.pricesWrapper) {
        this.pricesWrapper.appendChild(compareAtPriceDiv);
        this.compareAtPrice = compareAtPriceDiv;
      }
    } else {
      if (compareAtPriceElement) compareAtPriceElement.innerText = "";
    }
  }

  updateLowestPrice() {
    let allMetaVariants = document.querySelectorAll(".lowest-price-meta");
    const lowestPriceInput = document.querySelectorAll(
        ".product-info__price--lowest span"
    );

    const lowestPriceDiv = document.querySelectorAll(
        ".product-info__price--lowest"
    );

    allMetaVariants.forEach((meta) => {
      if (meta.getAttribute("data-variant_id") == this.currentVariant.id) {
        let lowestPrice = meta.getAttribute("meta-data");

        lowestPriceInput.forEach((input) => {
          input.innerHTML = Shopify.formatMoney(
              lowestPrice * 100,
              window.theme.moneyFormat
          );
        });

        lowestPriceDiv.forEach((item) => {
          item.style.display = "flex";
        });

        if (lowestPrice == 0) {
          lowestPriceDiv.forEach((item) => {
            item.style.display = "none";
          });
        }
      }
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const newMedia = this.currentVariant.featured_media.id;
    if (!newMedia) return;
    this.element.dispatchEvent(
        new CustomEvent("variant:changed", {
          bubbles: true,
          detail: { new_image: newMedia },
        })
    );
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState(
        {},
        "",
        `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
        `#product-form-${this.productID}, #product-form-installment`
    );

    const multipackSelect = this.element.querySelector('select[data-multipack="true"]');
    let variantToAdd = this.currentVariant;

    const allVariants = this.getVariantData()

    if (multipackSelect) {
      const firstMultipackValue = multipackSelect?.options[0]?.value;
      const option1 = variantToAdd.option1;
      const matchedVariant = allVariants.find(variant =>
          variant.option1 === option1 && variant.option2 === firstMultipackValue
      );
      // 🔥 Get the value of the FIRST option in the multipack select
      if (matchedVariant) {
        variantToAdd = matchedVariant;
        this.currentVariant = matchedVariant;
        this.isMultipack = true;
        this.updateAvailability();
        this.updateURL();
        this.handleMultiselectAvailability();
      }
    }

    new CustomEvent('notify:change', {
      detail: {
        id: this.currentVariant.id,
        changed: true
      }
    });

    this.updateURL();
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      if (input) {
        input.value = variantToAdd.id;
        input.dispatchEvent(new Event("change", { bubbles: true }));
      }
    });
  }
  renderProductInfo() {
    fetch(
        `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
        .then((response) => response.text())
        .then((responseText) => {
          const id = ".ProductInfo--Prices";
          const html = new DOMParser().parseFromString(responseText, "text/html");
          const destinations = document.querySelectorAll(id);
          const source = html.querySelector(id);


          if (source && destinations) {
            destinations.forEach((destination) => {
              destination.innerHTML = source.innerHTML;
            });
          }

          this.toggleAddButton();
        });
  }



  toggleAddButton() {
    if(!this.isMultipack)
    {
      this.updateMasterId()
    }
    let hideButtons = document.querySelectorAll(".hideBtn");
    hideButtons.forEach(function (button) {
      button.classList.remove("hideBtn");
    });


    const addButton = document.querySelectorAll(".product__atc-button");
    if (!addButton) return;

    // Check if all the options have been selected before toggling the add/sold out buttons
    const allContents = this.element.querySelectorAll(".RevolutionSelectbox--Content");
    const allHaveSelected = Array.from(allContents).every((content) =>
        content.querySelector('.RevolutionSelectbox--Item[selected="selected"]')
    );

    const multipackDropdown = this.element.querySelector('[data-multipack-select="true"]');

    if(multipackDropdown){
      const titleButton = multipackDropdown.querySelector('.RevolutionSelectbox--Button .RevolutionSelectbox--Title');
      const SOLD_OUT_TEXT = (window.theme?.i18n?.sold_out || 'SOLD OUT').toUpperCase();


      if(this.isMultipack && titleButton.innerText.toLowerCase().includes(SOLD_OUT_TEXT.toLowerCase())){
        this.showNotifyMeButton(false);
        return;
      }
    }


    if (!allHaveSelected) {
      this.showNotifyMeButton(this.currentVariant.available);
      return;
    }

    if (this.currentVariant.available == false) {
      addButton.forEach((button) => {
        button.classList.add("hideBtn");
      });
    } else {
      addButton.forEach((button) => {
        button.dataset.action = 'add-to-cart';
        if (button.classList.contains('product-module__product-atc--sticky')) {
          button.dataset.action = 'click-atc';
        }

        button.classList.remove("hideBtn");
        const addToCartTxt = button.querySelectorAll('.product__atc-button .ButtonText');
        addToCartTxt.forEach(txt => {
          txt.textContent = window.variantStrings.addToCart.toUpperCase();
        });
      });
    }

    // Get price as plain text and update button style
    let priceText = Shopify.formatMoney(this.currentVariant.price, window.theme.moneyFormat);
    const quantity = this.getQuantityFromMultipackLabel();
    const totalPrice = this.currentVariant.price * quantity;
    let totalPriceText = Shopify.formatMoney(totalPrice, window.theme.moneyFormat);



    addButton.forEach((button) => {
      const addToCartText = button.querySelector('.ButtonText');
      if (addToCartText) {
        addToCartText.textContent = window.variantStrings.addToCart.toUpperCase() + " - " + totalPriceText;
      }
    });

    this.showNotifyMeButton(this.currentVariant.available);
    this.updateBIS(true);
  }

  showNotifyMeButton(available) {
    if (!this.notifyButtons) return;

    if (available) {
      this.notifyButtons.forEach((btn) => (btn.style.display = "none"));
      this.atcButtons.forEach((btn) => (btn.style.display = "block"));

    } else {
      this.notifyButtons.forEach((btn) => (btn.style.display = "flex"));
      this.atcButtons.forEach((btn) => (btn.style.display = "none"));
    }
  }

  getVariantData() {
    this.variantData =
        this.variantData ||
        JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }


}
customElements.define("variant-selects", VariantSelects);


class NotifyMe extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    this.pageOverlayElement = document.querySelector(".pageOverlayPDP");
    this.allNotifications = this.element.querySelectorAll(
        ".product-module__notify-action"
    );
    this.emailContainer = this.element.querySelector(
        "#product-module__notify-me-input"
    );
    this.subtitle = this.element.querySelector(".product-module__notify-text");
    this.productId = document.querySelector(
        'form[data-product-form] [name="id"]'
    ).dataset.productId;

    this.variantId = document.querySelector(
        '[name="notify_variant"]'
    ).dataset.id;

    this.bindEvents();
  }

  bindEvents() {
    this.onClickOutsideListener = this.closeNotifyMe.bind(this);

    this.delegateBody.on(
        "click",
        '[data-action="notify-open"]',
        this.openNotifyMe.bind(this)
    );
    this.delegateBody.on(
        "click",
        '[data-action="subscribe"]',
        this.handleSubscribe.bind(this)
    );
    this.delegateBody.on(
        "click",
        '[data-action="notify-close-success"]',
        this.closeNotifyMeSuccess.bind(this)
    );
    this.delegateBody.on("notify:change", this.updateVariantId.bind(this));
    this.delegateElement.on(
        "click",
        '[data-action="notify-close"]',
        this.closeNotifyMe.bind(this)
    );
  }

  updateVariantId(e) {
    this.variantId = e.detail.id;
  }

  handleSubscribe() {
    const email = this.element.querySelector('[name="notify_email"]').value;

    if (email !== "" && email.includes("@")) {
      const offsetMinutes = new Date().getTimezoneOffset();

      const callbackName = `_BIS_JSONP_${Date.now()}`;
      const params = new URLSearchParams({
        "callback": callbackName,
        "shop": Shopify.shop,
        "variant[variant_no]": this.variantId,
        "notification[channel]": "email",
        "notification[product_no]": this.productId,
        "notification[shop_locale_id]": "127912",
        "notification[quantity_required]": "1",
        "notification[accepts_marketing]": "false",
        "notification[customer_utc_offset]": offsetMinutes.toString(),
        "notification[email]": email
      });

      // Define the JSONP callback
      window[callbackName] = (data) => {
        if (data.status === "OK") {
          this.showNotification("success");
        } else {
          const emailError = data.errors?.email?.[0];
          const baseError = data.errors?.base?.[0];
          const message = emailError || baseError || "Something went wrong. Please try again.";

          if (emailError) {
            this.showNotification("email-error", message);
          } else {
            this.showNotification("error", message);
          }
        }

        delete window[callbackName];
        script.remove();
      };

      // Inject script to submit the request
      const script = document.createElement("script");
      script.src = `https://app.backinstock.org/notifications/create.json?${params.toString()}`;
      document.body.appendChild(script);
    } else {
      this.showNotification("email-error");
    }
  }


  clearNotifications() {
    this.allNotifications.forEach((el) =>
        el.setAttribute("aria-hidden", "true")
    );
  }

  showNotification(type, message = "") {
    this.clearNotifications();

    let activeNotification;

    switch (type) {
      case "success":
        activeNotification = this.element.querySelector(
            ".product-module__notify-action--success"
        );
        let activeBtn = this.element.querySelector(
            ".product-module__notify-button--success"
        );
        let subsBtn = this.element.querySelector(
            ".product-module__notify-button--subscribe"
        );
        subsBtn.style.display = "none";
        activeBtn.setAttribute("aria-hidden", "false");
        activeNotification.setAttribute("aria-hidden", "false");
        this.emailContainer.value = '';
        this.emailContainer.style.display = "none";
        this.subtitle.style.display = "none";
        break;

      case "email-error":
        activeNotification = this.element.querySelector(
            ".product-module__notify-action--email-error"
        );
        if (activeNotification && message) {
          activeNotification.textContent = message;
        }
        break;

      default:
        activeNotification = this.element.querySelector(
            ".product-module__notify-action--error"
        );
        if (activeNotification && message) {
          activeNotification.textContent = message;
        }
        break;
    }

    activeNotification.setAttribute("aria-hidden", "false");
  }


  openNotifyMe(e) {
    e.preventDefault();
    this.element.setAttribute("aria-hidden", "false");
    trapFocus(this.element);

    this.pageOverlayElement.classList.add("is-visible");

    bodyScrollLock.disableBodyScroll(this.element, bodyScrollLockOptions);

    this.pageOverlayElement.addEventListener(
        "click",
        this.onClickOutsideListener
    );
  }

  closeNotifyMe(e) {
    this.element.setAttribute("aria-hidden", "true");

    this.pageOverlayElement.classList.remove("is-visible");
    this.pageOverlayElement.removeEventListener(
        "click",
        this.onClickOutsideListener
    );
    // Remove scrolllock and clear notifications after the popup disappears so there are no visible layout shifts
    this.element.addEventListener(
        "transitionend",
        () => {
          if (e.target.closest('[data-action="notify-close"]')) {
            setTimeout(() => {
              bodyScrollLock.enableBodyScroll(
                  this.element,
                  bodyScrollLockOptions
              );
              this.clearNotifications();
            }, 50);
          } else {
            bodyScrollLock.enableBodyScroll(this.element, bodyScrollLockOptions);
            this.clearNotifications();
          }
        },
        { once: true }
    );
  }

  closeNotifyMeSuccess(e) {
    this.element.setAttribute("aria-hidden", "true");

    this.pageOverlayElement.classList.remove("is-visible");

    this.pageOverlayElement.removeEventListener(
        "click",
        this.onClickOutsideListener
    );

    this.element.addEventListener(
        "transitionend",
        () => {
          let activeBtn = this.element.querySelector(
              ".product-module__notify-button--success"
          );
          let subsBtn = this.element.querySelector(
              ".product-module__notify-button--subscribe"
          );

          let activeNotification = this.element.querySelector(
              ".product-module__notify-action--success"
          );

          activeNotification.setAttribute("aria-hidden", "true");
          subsBtn.style.display = "block";
          activeBtn.setAttribute("aria-hidden", "true");
          this.emailContainer.style.display = "flex";
          this.emailContainer.value = '';
          this.subtitle.style.display = "block";

          if (e.target.closest('[data-action="notify-close"]')) {
            setTimeout(() => {
              bodyScrollLock.enableBodyScroll(
                  this.element,
                  bodyScrollLockOptions
              );
            }, 50);
          } else {
            bodyScrollLock.enableBodyScroll(this.element, bodyScrollLockOptions);
          }
        },
        { once: true }
    );
  }
}

customElements.define("notify-me-popup", NotifyMe);

class sizeGuide extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);

    new Drawer(this.element.querySelector('.Drawer--wrapper'));
  }
}

customElements.define("size-guide", sizeGuide);

class SizeGuideTable extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    this.tableContent = this.element.querySelector(
        ".size-guide__table-content"
    );
    this.scrollbar = this.element.querySelector(".custom-scrollbar");
    this.scrollbarThumb = this.element.querySelector(".custom-scrollbar-thumb");

    this.tableFonts();

    this.scrollBarUpdate();
    this.bindEvents();
  }

  tableFonts() {
    const table = this.element.querySelector(".size-guide__table-content");
    const rows = table.querySelectorAll("tr");

    rows.forEach((row) => {
      row.classList.add("table-row");

      const cells = row.querySelectorAll("td");

      cells.forEach((cell, index) => {
        cell.classList.add("table__item");
        if (index === 0) {
          cell.classList.add("u-s3");
          cell.classList.add("rte");
        } else {
          cell.classList.add("rte");
        }
      });
    });
  }


  scrollBarUpdate() {

    this.scrollBarUpdateThumb();

    window.addEventListener("resize", () => this.scrollBarUpdateThumb());
  }

  bindEvents() {
    let isDragging = false;
    let startX, startScrollLeft;
    const slider = this.element.querySelector(".size-guide__table-content");

    const startDragging = (e) => {
      isDragging = true;
      startX = e.type === "touchstart" ? e.touches[0].pageX : e.pageX;
      startScrollLeft = slider.scrollLeft;
    };

    const stopDragging = () => {
      isDragging = false;
    };

    const move = (e) => {
      e.preventDefault();
      if (!isDragging) {
        return;
      }
      const currentX = e.type === "touchmove" ? e.touches[0].pageX : e.pageX;
      const scroll = currentX - startX;
      slider.scrollLeft = startScrollLeft - scroll;

      this.syncScroll();
    };

    document.body.addEventListener('click', (event) => {
      if (event.target.matches('[data-action="tab-switch"]')) {
        this.scrollBarUpdateThumb();
      }
    });
    slider.addEventListener("mousedown", startDragging, false);
    slider.addEventListener("touchstart", startDragging, false);

    slider.addEventListener("mouseup", stopDragging, false);
    slider.addEventListener("touchend", stopDragging, false);

    slider.addEventListener("mousemove", move, false);
    slider.addEventListener("touchmove", move, false);

    this.tableContent.addEventListener(
        "scroll",
        () => this.syncScroll(),
        false
    );
  }

  scrollBarUpdateThumb() {
    const contentWidth = this.tableContent.scrollWidth;
    const containerWidth = this.tableContent.clientWidth;
    const scrollRatio = containerWidth / contentWidth;

    this.scrollbarThumb.style.width = `${scrollRatio * 100}%`;

    if (contentWidth <= containerWidth) {
      this.scrollbar.style.display = 'none';
    } else {
      this.scrollbar.style.display = 'block';
    }
  }

  syncScroll() {
    const contentWidth = this.tableContent.scrollWidth;
    const containerWidth = this.tableContent.clientWidth;
    const scrollRatio = containerWidth / contentWidth;
    const scrollLeft = this.tableContent.scrollLeft;
    this.scrollbarThumb.style.transform = `translateX(${scrollLeft * scrollRatio
    }px)`;
  }
}
customElements.define("size-guide-table", SizeGuideTable);

class SearchBar extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.searchInputElement = this.element.querySelector('[name="q"]');
    this.breakpoint = new Responsive().getCurrentBreakpoint();

    this.searchResultsElement = this.element.querySelector(".search-wrapper");
    this.searchOverlayElement = document.querySelector(".quickSearchOverlay");
    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    this.initialSearchLayout = this.searchResultsElement.cloneNode(true);
    this.clearSearchButton = this.element.querySelector('.searchInput--clear');

    this.headerTransparent = false;
    document.documentElement.style.setProperty(
        "--search-header-height",
        `${this.searchInputElement.offsetHeight + 48}px`
    );

    this.bindEvents();
  }

  bindEvents() {
    this._onInputListener = this.debounce(this.onInput.bind(this), 450);

    this.delegateBody.on(
        "click",
        '[data-action="open-search"]',
        this.openSearch.bind(this)
    );
    this.delegateElement.on(
        "click",
        '[data-action="clear-input"]',
        this.resetSearch.bind(this)
    );

    this.delegateBody.on(
        "click",
        '[data-action="close-search"]',
        this.closeSearch.bind(this)
    );

    this.delegateElement.on(
        "close:search",
        this.closeSearch.bind(this)
    );

    this.searchInputElement.addEventListener("input", this._onInputListener);

    this.delegateElement.on(
        "click",
        '[data-action="search-string"]',
        this.onInput.bind(this)
    );

    this.delegateElement.on(
        "keypress",
        '[data-action="search-string"]',
        this.onInput.bind(this)
    );

    this.delegateBody.on(
        "keydown",
        this.onEsc.bind(this)
    );

    this.searchInputElement.addEventListener("focus", () => {
      const searchVisible = this.searchResultsElement.getAttribute("aria-hidden") === "false";

      if (!responsive.matchesBreakpoint("lap_and_up") && !searchVisible && !this.isOpen) {
        this.openSearch(new Event("focus"));
        const drawer = document.querySelector("main-menu-dropdown .Drawer--Wrapper");
        if (drawer) drawer.style.opacity = 0;
      }
    });

    this.transitionEndHandler = this.onTransitionEnd.bind(this);
  }

  debounce(fn, delay) {
    var _this0 = this;

    var timer = null;

    return function () {
      for (
          var _len = arguments.length, args = Array(_len), _key = 0;
          _key < _len;
          _key++
      ) {
        args[_key] = arguments[_key];
      }

      clearTimeout(timer);

      timer = setTimeout(function () {
        fn.apply(_this0, args);
      }, delay);
    };
  }

  onEsc(e) {
    if (e.key === 'Escape') {
      this.closeSearch(e);
    }
  }

  openSearch(event) {
    event.preventDefault();

    const _this = this;
    // Check if search is already open, close it if true
    if (this.isOpen) {
      this.closeSearch();
      return;
    }

    this.element.dispatchEvent(
        new CustomEvent("menu:close", { bubbles: true })
    );


    // Check if search element exists
    if (!this.element) {
      console.error('Search element not found');
      return;
    }
    this.searchResultsElement.setAttribute("aria-hidden", "true");

    this.searchOverlayElement.classList.add("is-visible");

    document.querySelector('[data-toggle-id="Drawer"]').setAttribute('aria-expanded', true);

    // Show search element and page overlay
    const search = document.querySelector("#quickSearch");
    if (search) {
      search.setAttribute("aria-hidden", false);
    }

    // Disable scrolling on body
    bodyScrollLock.disableBodyScroll(
        this.element.querySelector('[data-scrollable]'),
        bodyScrollLockOptions
    );

    // Focus on search input element after delay
    setTimeout(() => {
      if (_this.searchInputElement) {

        if (responsive.matchesBreakpoint("lap_and_up")) {
          _this.searchInputElement.focus();
        }

      }
    }, 200);

    this.searchResultsElement.setAttribute("aria-hidden", false);
    this.searchResultsElement.offsetHeight;
    requestAnimationFrame(() => {
      this.searchResultsElement.setAttribute("aria-expanded", true);
    });

    if (document.querySelector('.Header--Transparent')) {
      setTimeout(() => {
        const header = document.body.querySelector("#header");
        if (header) {
          header.classList.remove("Header--Transparent");
        }
      }, 15);
      this.headerTransparent = true;
    }


    // Set isOpen to true
    this.isOpen = true;

    // Add event listener to page overlay to close search
    if (this.searchOverlayElement) {
      this.closeListener = this.closeSearch.bind(this);
      this.searchOverlayElement.addEventListener("click", this.closeListener);
    }

  }

  closeSearch() {
    event.preventDefault();

    if (!this.isOpen) {
      return;
    }
    document.querySelector('main-menu-dropdown .Drawer--Wrapper').style.opacity = 1;
    this.element.setAttribute('aria-hidden', true);

    document.body.classList.remove('scrollLock');
    this.searchResultsElement.setAttribute("aria-expanded", false);
    this.searchResultsElement.addEventListener("transitionend", this.transitionEndHandler);

    this.searchOverlayElement.classList.remove("is-visible");


    this.isOpen = false;
  }

  onTransitionEnd(event) {
    if (event.propertyName === "opacity") {
      this.searchResultsElement.setAttribute("aria-hidden", true);
      this.searchResultsElement.removeEventListener("transitionend", this.transitionEndHandler);
      this.resetSearch();
      if (!document.body.classList.contains('scrollLock')) {
        bodyScrollLock.enableBodyScroll(this.element.querySelector('[data-scrollable]'), bodyScrollLockOptions);
      }
    }
  }

  async onInput(event) {
    this.allPredictiveSearchInstances = [];
    this.lastInputValue = event.target.value;
    this.searchResultsElement = this.element.querySelector(".search-wrapper");


    if (!responsive.matchesBreakpoint("lap_and_up")) {
      this.searchResultsElement.setAttribute("aria-hidden", "false");
      this.clearSearchButton.setAttribute('aria-hidden', 'false');
    }
    if (event.target.getAttribute("data-value") && this.lastInputValue === 0) {
      this.lastInputValue = event.target.getAttribute("data-value");
      const el = this.element.querySelector(".searchInput");

      el.setAttribute("value", this.lastInputValue);
      el.value = this.lastInputValue;


    } else {
      if (this.lastInputValue === "") {
        // this.initialSearchLayout.style.opacity = 0;
        this.resetSearch();
        return;
      }
    }

    try {
      const response = await fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(this.lastInputValue)}&resources[limit_scope]=each&section_id=search-predictive`);

      if (!response.ok) {
        var error = new Error(response.status);
        throw error;
      }

      const text = await response.text();
      const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-search-predictive').innerHTML;

      // Save bandwidth keeping the cache in all instances synced
      this.allPredictiveSearchInstances.forEach((predictiveSearchInstance) => {
        predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
      });
      const div = document.createElement('div');
      div.innerHTML = resultsMarkup;

      const suggestedQueries = div.querySelector('template');
      const currentSuggestedQueries = this.element.querySelector('.predictiveSearch--queries');
      const currentRecentQueris = this.element.querySelector('#predictiveSearch--recentSearches');


      this.searchResultsElement.innerHTML = resultsMarkup;

      if (!this.element.querySelector('.grid-item')) {
        const results = this.element.querySelector('.product-results');
        if (results) results.style.display = 'none';
      }

      if (suggestedQueries) {
        if (currentRecentQueris) {
          currentRecentQueris.remove();
        }

        if (currentSuggestedQueries) {
          currentSuggestedQueries.remove();
        }
        const node = suggestedQueries
            .content.firstElementChild.cloneNode(true);
        this.searchResultsElement.prepend(node);
      }

      if (window.theme.showRecentSearches) {
        this.recentSearches();
      }
    } catch (error) {
      if (error?.code === 20) {
        // Code 20 means the call was aborted
        return;
      }

      throw error;
    }
  }

  resetSearch() {
    this.searchResultsElement.innerHTML = this.initialSearchLayout.innerHTML;
    const currentSuggestedQueries = this.element.querySelector('.predictiveSearch--queries');
    if (currentSuggestedQueries) currentSuggestedQueries.remove();
    this.searchInputElement.value = "";
    this.searchInputElement.removeAttribute("value");
    this.clearSearchButton.setAttribute('aria-hidden', 'true');
  }

  recentSearches() {
    if (this.lastInputValue.length > 3) {
      var searchTerm = JSON.parse(localStorage.getItem("searchTerms") || "[]");
      if (!searchTerm.includes(this.lastInputValue)) {
        searchTerm.unshift(this.lastInputValue);
      }

      // Then, we save the search info into the local storage, by keeping only the 5 most recent
      try {
        localStorage.setItem(
            "searchTerms",
            JSON.stringify(searchTerm.slice(0, 5))
        );
      } catch (error) { }
    }
  }

}
customElements.define("search-bar", SearchBar);

class TermsAndConditions extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
  }
}

customElements.define("terms-and-conditions", TermsAndConditions);


class ContactSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.bindEvents();
    this.toggleButton();
  }

  bindEvents() {
    this.delegateElement.on(
        "change",
        "[data-state='required']",
        this.toggleButton.bind(this)
    );

  }


  toggleButton() {
    this.buttonState = true;

    var allRequiredInputs = this.element.querySelectorAll("[data-state='required']");
    allRequiredInputs.forEach((item) => {
      if ((item.type === "checkbox" && !item.checked) ||
          (item.type !== "checkbox" && item.value.trim() === "")) {
        this.buttonState = false;
      }
    });

    if (this.buttonState) {
      this.element.querySelector(".Contact-Btn")?.removeAttribute("disabled");
    } else {
      this.element.querySelector(".Contact-Btn")?.setAttribute("disabled", true);
    }

  }
}

customElements.define("contact-section", ContactSection);


class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector(
          'input[name="language_code"], input[name="country_code"]'
      ),
    };
    this.querySelectorAll("a").forEach((item) =>
        item.addEventListener("click", this.onItemClick.bind(this))
    );
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector("form");
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }
}

customElements.define("localization-form", LocalizationForm);
class faqSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);

  }

  connectedCallback() {
    this.searchInput = this.element.querySelector(".faq--search");
    this.searchBar = this.element.querySelector('.faq__search-bar--wrapper');
    this.termsBlocks = document.querySelectorAll(".faq__dropdown-container");
    this.noResultsElement = document.querySelector("#faq__results--none");
    this.firstTag = this.element.querySelector('.faq__tab--link');
    if (this.firstTag) {
      this.firstTag.classList.add("is-active");
    }
    this.bindEvents();
  }

  bindEvents() {
    this.onInputListener = debounce(this.handleSearch.bind(this), 350);

    this.delegateElement.on("click", '[data-action="handle-tab-click"]', this.handleTabClick.bind(this));
    this.delegateElement.on("click", '[data-action="clear-search"]', this.clearSearch.bind(this));

    this.delegateElement.on(
        "keyup",
        '[data-action="search-string"]',
        this.onInputListener
    );

    /*const isMobile = responsive.matchesBreakpoint("pocket");
    if (!isMobile) scrollListener.addScrollListener(this, stickyLinksTopPadding.bind(this));*/
  }

  handleSearch() {
    const searchTerm = this.searchInput.value.toLowerCase().trim();
    const clearBtn = this.element.querySelector(
        ".supportFaq--mobileClearBtn"
    );
    const searchPlaceholderButton = this.element.querySelector(".supportFaq--searchBtn");
    if (searchPlaceholderButton) searchPlaceholderButton.style.display = this.searchInput.value ? "none" : "flex";
    if (clearBtn) clearBtn.style.display = this.searchInput.value ? "flex" : "none";

    // Reset visibility if search input is empty
    if (searchTerm === "") {
      this.termsBlocks.forEach((block) => {
        block.classList.remove("is-hidden");
        const questions = block.querySelectorAll(".faq__content");
        questions.forEach((content) => content.classList.remove("is-hidden"));
      });
      this.noResultsElement.classList.add("is-hidden");
      return;
    }

    let hasMatch = false;

    this.termsBlocks.forEach((block) => {
      const title = block.querySelector('.faq__block--heading').textContent.toLowerCase();
      const questions = block.querySelectorAll(".faq__content");
      let blockMatch = false;

      if (title.includes(searchTerm)) {
        // If the heading matches, display all content in this block
        block.classList.remove("is-hidden");
        questions.forEach((content) => content.classList.remove("is-hidden"));
        blockMatch = true;
      } else {
        // If only `faq__block-content` matches
        questions.forEach((questionWrapper) => {
          const questionText = questionWrapper.textContent.toLowerCase();
          if (questionText.includes(searchTerm)) {
            questionWrapper.classList.remove("is-hidden");
            blockMatch = true;
          } else {
            questionWrapper.classList.add("is-hidden");
          }
        });

        // Show or hide the block based on matching content
        if (blockMatch) {
          block.classList.remove("is-hidden");
        } else {
          block.classList.add("is-hidden");
        }
      }

      if (blockMatch) hasMatch = true;
    });

    // Display 'no results' message if nothing matched
    if (searchTerm === "" || !hasMatch) {
      // this.termsBlocks.forEach((block) => {
      //   block.classList.remove("is-hidden");
      //   block.querySelectorAll(".faq__content").forEach((content) =>
      //     content.classList.remove("is-hidden")
      //   );
      // });
      this.noResultsElement.classList.toggle("is-hidden", searchTerm === "" || hasMatch);
    } else {
      this.noResultsElement.classList.add("is-hidden");
    }
  }

  clearSearch() {
    const clearBtn = this.element.querySelector(".supportFaq--mobileClearBtn");
    const inputValue = this.element.querySelector(".faq--search.mobile");

    // Reset search input
    if (inputValue) inputValue.value = "";

    // Hide elements that should be hidden initially
    if (clearBtn) clearBtn.style.display = "none";

    // Reset FAQ term sections
    this.termsBlocks.forEach((block) => {
      block.classList.remove("is-hidden");
      const questions = block.querySelectorAll(".faq__content");
      questions.forEach((content) => content.classList.remove("is-hidden"));
    });
    this.noResultsElement.classList.add("is-hidden");
    inputValue.focus();
  }

  handleTabClick(event, target) {
    event.preventDefault();

    const targetId = target.getAttribute('href').substring(1);
    const newUrl = `${window.location.pathname}#${targetId}`;
    history.pushState(null, null, newUrl);

    const otherTabs = this.element.querySelectorAll(".faq__tab--link");
    if (!target.classList.contains("is-active")) {
      otherTabs.forEach(tab => {
        tab.classList.remove("is-active");
      });

      target.classList.add("is-active");
    }


    const targetElement = this.element.querySelector(`#${targetId}`);

    if (targetElement) {
      this.scrollToSection(targetElement);
    }
  }

  scrollToSection(targetElement) {
    const headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height-fixed')) || 0;
    let offset = headerHeight + 16;
    if (responsive.matchesBreakpoint('pocket') && this.searchBar) {
      offset = offset + this.searchBar.offsetHeight;
    }
    const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY - offset;

    window.scrollTo({
      top: targetPosition,
      behavior: 'smooth'
    });
  }
}

customElements.define("faq-section", faqSection);

class FAQCarousel extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.carouselElement = this.element.querySelector(".faq__swiper");
    this.carousel = new RevolutionSwiper(this.carouselElement);
  }
}
customElements.define("faq-carousel", FAQCarousel);

class USPSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.carouselElement = this.element.querySelector(".usp__content--wrapper");
    if (this.carouselElement && this.carouselElement.dataset.swiper === "true" && responsive.matchesBreakpoint('pocket')) {
      this.carousel = new RevolutionSwiper(this.carouselElement);
    }
    if (this.carouselElement && responsive.matchesBreakpoint('desktop'))
      this.carousel = new RevolutionSwiper(this.carouselElement);
  }
}
customElements.define("section-usp", USPSection);

class CartNote extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.textarea = this.element.querySelector("textarea");
    this.button = this.element.querySelector(".CartNote--Submit");
    this.noteSucess = this.element.querySelector(".cartNote--Success");
    this.bindEvents();
  }
  bindEvents() {
    this.delegateElement.on(
        "click",
        "[data-action='update-note']",
        this.updateNote.bind(this)
    );

    this.delegateElement.on(
        "click",
        "[data-action='edit-note']",
        this.editNote.bind(this)
    );
  }
  editNote() {
    this.textarea.removeAttribute("disabled");
    this.button.innerText = window.cartStrings.enter_note;
    this.button.setAttribute("data-action", "update-note");
    this.textarea.focus();
    this.noteSucess.style.visibility = "hidden";
    this.noteSucess.style.opacity = "0";
  }

  updateNote() {
    var _this = this;
    this.value = this.textarea.value;

    fetch(window.routes.localeRootUrl + "/cart/update.js", {
      body: JSON.stringify({ note: this.value }),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    }).then(function (response) {
      if (response.ok) {
        if (_this.value == "") {
          return;
        }
        _this.textarea.setAttribute("disabled", "disabled");
        _this.button.innerText = window.cartStrings.note_change;
        _this.button.setAttribute("data-action", "edit-note");
        _this.noteSucess.style.visibility = "visible";
        _this.noteSucess.style.opacity = "1";
      }
    });
  }
}

customElements.define("cart-note", CartNote);

class TermsCarousel extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.carouselElement = this.element.querySelector(".tc__swiper");
    this.carousel = new RevolutionSwiper(this.carouselElement);
  }
}
customElements.define("terms-carousel", TermsCarousel);


class NewsletterPopup extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.options = JSON.parse(this.element.getAttribute("data-section-settings"));

    //Handle showing of the small newsletter when the big one is submitted
    this.url = new URL(window.location.href);
    this.isPosted = this.url.searchParams.get('customer_posted') === 'true' && this.url.hash === '#popupForm';

    if (this.isPosted) {
      localStorage.setItem("newsletter-posted", "true");
    }

    // Get banner elements
    this.bannerLarge = this.querySelector('.large-newsletter-popup_wrapper');
    this.wavesLarge = this.querySelector('.newsletter-popup--waves-large');
    this.bannerSmall = this.querySelector('.small-newsletter-popup_wrapper');
    this.wavesSmall = this.querySelector('.newsletter-popup--waves-small');

    // Initialize state
    this.isSmallBanner = localStorage.getItem('small-popup-show') === "true";
    if (this.isSmallBanner) {
      this.morphToSmall();
    }

    // Handle initialization
    if (this.options.edit_mode) {
      this.options.delay = 0;
      this.openNewsletter();
    } else {
      this.handleOpenOptions();
    }

    // Bind methods to preserve 'this' context
    this.bindEvents();
    this.scrollListener = this.scrollListener.bind(this);
    this.transitionEndHandler = this.onTransitionEnd.bind(this);
    this.closeNewsletterHandler = this.closeNewsletter.bind(this);
    this.escKeyHandler = this.onEscKey.bind(this);
    this.newsletterScrollHandler = this.checkNewsletterVisibility.bind(this);
  }

  bindEvents() {
    // Signup button click handler
    this.delegateBody.on(
        "click",
        '[data-action="open-signup"]',
        this.clickOpen.bind(this)
    );
  }

  clickOpen(e) {
    // Don't process if clicking on close button
    if (e.target.closest('[data-action="close-modal"]')) return;

    this.shouldReopenBig = true;
    this.options.delay = 0;
    this.closeNewsletter();
  }

  morphToBig() {
    if (this.bannerLarge) {
      this.bannerLarge.style.display = "";
    }
    this.wavesLarge.style.display = "";
    this.bannerSmall.style.display = "none";
    this.wavesSmall.style.display = "none";

    this.element.classList.remove('newsletter-popup--small');

    setTimeout(() => {
      this.openNewsletter();
    }, 200);
  }

  morphToSmall() {

    const isPosted = localStorage.getItem("newsletter-posted");

    if (localStorage.getItem('popup-seen') === 'true' &&
        localStorage.getItem('small-popup-show') === 'true' &&
        this.isSmallBanner && !isPosted) {

      if (this.bannerLarge) {
        this.bannerLarge.style.display = "none";
      }
      this.wavesLarge.style.display = "none";
      this.bannerSmall.style.display = "flex";
      this.wavesSmall.style.display = "block";

      this.element.classList.add('newsletter-popup--small');

      setTimeout(() => {
        this.openNewsletter();
      }, 200);
    }
  }

  handleOpenOptions() {
    const hasSeenPopup = localStorage.getItem("popup-seen") === "true";
    const showSmallPopup = localStorage.getItem("small-popup-show") === "true";

    // Check conditions to determine if we should show the popup
    if (this.options.show_only_once && hasSeenPopup) return;
    if (this.options.not_show_subscribed && this.options.is_subscribed) return;
    if (hasSeenPopup && !showSmallPopup) return;

    // Setup scroll listener if needed
    if (this.options.scroll_amount > 0) {
      this.scrollListenerRef = scrollListener.addScrollListener(this, this.scrollListener);
    } else {
      this.openNewsletter();
    }
  }

  scrollListener() {
    const body = document.body;
    const html = document.documentElement;

    const docHeight = Math.max(
        body.scrollHeight,
        body.offsetHeight,
        html.clientHeight,
        html.scrollHeight,
        html.offsetHeight
    );

    const percScrolled = (window.scrollY / docHeight) * 100;

    if (percScrolled >= this.options.scroll_amount) {
      this.openNewsletter();
    }
  }

  openNewsletter() {
    // Don't show if form was successfully submitted
    if (sessionStorage.getItem('newsletter-success') === 'true' && !this.options.edit_mode) return;

    // Remove scroll listener if it exists
    if (this.scrollListenerRef) {
      this.scrollListenerRef.removeScrollListener();
    }

    this.element.style.visibility = 'visible';

    setTimeout(() => {
      this.element.style.display = "flex";

      requestAnimationFrame(() => {
        this.element.setAttribute("aria-hidden", "false");
      });

      // Handle page behavior for large popup
      if (!this.isSmallBanner) {
        this.pageOverlayElement.classList.add("is-visible");
        this.pageOverlayElement.addEventListener("click", this.closeNewsletterHandler);
        bodyScrollLock.disableBodyScroll(this.element, bodyScrollLockOptions);
        document.body.classList.add("scrollLock");
      }

      // Mark popup as seen
      localStorage.setItem("popup-seen", "true");

      // Add ESC key listener
      document.addEventListener("keydown", this.escKeyHandler);

      // Add close button listener
      this.delegateElement.on(
          "click",
          '[data-action="close-modal"]',
          this.closeNewsletterHandler
      );

      // Initialize visibility checker
      this.setupVisibilityChecker();
    }, 1000 * this.options.delay);
  }

  onEscKey(e) {
    if (e.key === 'Escape') {
      this.closeNewsletter(e);
    }
  }

  onTransitionEnd(event) {
    if (event.propertyName === "transform") {
      if (this.element.getAttribute("aria-hidden") === "true") {
        requestAnimationFrame(() => {
          this.element.style.display = "none"; // Only hide after the transition

          document.body.classList.remove("scrollLock");
          this.pageOverlayElement.classList.remove("is-visible");
          bodyScrollLock.enableBodyScroll(this.element);

          this.pageOverlayElement.removeEventListener("click", this.closeNewsletterHandler);
          this.delegateElement.off("click", '[data-action="close-modal"]', this.closeNewsletterHandler);
          document.removeEventListener("keydown", this.escKeyHandler);

          this.element.removeEventListener("transitionend", this.transitionEndHandler);

          if (this.isSmallBanner) {
            this.morphToSmall();
          } else if (this.shouldReopenBig) {
            this.morphToBig();
          }

          this.shouldReopenBig = false;
          this.shouldClose = false;
        });
      }
    }
  }

  closeNewsletter() {
    this.element.addEventListener("transitionend", this.transitionEndHandler);
    this.element.setAttribute("aria-hidden", "true");
    this.element.offsetHeight; // Force reflow

    if (!this.isSmallBanner) {
      this.isSmallBanner = true;
      localStorage.setItem('small-popup-show', 'true');
    } else {
      this.isSmallBanner = false;
      localStorage.setItem('small-popup-show', 'false');
      this.shouldClose = true;
    }

    if (this.scrollListenerRef) {
      this.scrollListenerRef.removeScrollListener();
    }

    if (this.visibilityScrollListenerRef) {
      this.visibilityScrollListenerRef.removeScrollListener();
    }
  }

  setupVisibilityChecker() {
    this.checkNewsletterVisibility();
    this.visibilityScrollListenerRef = scrollListener.addScrollListener(this, this.newsletterScrollHandler);
  }

  checkNewsletterVisibility() {
    const newsletter = document.querySelector('.newsletter');
    const footer = document.querySelector('footer');
    const popup = document.querySelector('.newsletter-popup');
    if (!popup) return;

    const getVisibleHeight = (el) => {
      if (!el) return 0;
      const rect = el.getBoundingClientRect();
      return Math.max(0, Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0));
    };

    const newsletterVisible = getVisibleHeight(newsletter);
    const footerVisible = getVisibleHeight(footer);

    // if (newsletterVisible > 0) {
    //   popup.classList.add('newsletter-popup--hidden');
    // } else {
    //   popup.classList.remove('newsletter-popup--hidden');
    // }
  }
}

customElements.define("newsletter-popup", NewsletterPopup);


class AccountHandler extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);


  }

  connectedCallback() {
    this.drawer = new Drawer(this.element.querySelector("#accountDrawer"), {
      onOpen: () => {
        const inputToFocus = this.element.querySelector("[aria-visible='true'] .input-placeholder--first");
        if (inputToFocus) {
          inputToFocus.setAttribute("readonly", "readonly");
          inputToFocus.focus();
          inputToFocus.removeAttribute("readonly");
        }
      }
    });

    this.bindEvents();
  }

  bindEvents() {
    this.delegateElement.on("click", '[data-action="toggle-tab"]', this.toggleTab.bind(this));
    this.delegateElement.on("click", '[data-action="submit-login"]', this.submitLogin.bind(this));
    this.delegateElement.on("click", '[data-action="submit-register"]', this.submitRegistration.bind(this));
    this.delegateElement.on("click", '[data-action="toggle-recovery"]', this.toggleRecovery.bind(this));
    this.delegateElement.on("click", '[data-action="submit-recovery"]', this.accountRecover.bind(this));
    this.delegateElement.on("keypress", '[data-action="submit-input-login"]', this.accountInputSubmit.bind(this));
    this.delegateElement.on("keypress", '[data-action="submit-input-reg"]', this.accountInputSubmitReg.bind(this));
    this.delegateElement.on("keypress", '[data-action="submit-input-forgot-pass"]', this.accountInputSubmitForgot.bind(this));
  }

  accountInputSubmit(e) {
    if (e.key === "Enter") this.submitLogin(e);
  }

  accountInputSubmitReg(e) {
    if (e.key === "Enter") this.submitRegistration(e);
  }

  accountInputSubmitForgot(e) {
    if (e.key === "Enter") {
      e.preventDefault();
      this.accountRecover(e);
    }
  }

  async accountRecover(event) {
    event.preventDefault();
    const recoverEndpoint = `${window.routes.localeRootUrl}/account/recover`;
    const requestBody = {
      email: this.element.querySelector("#RecoverEmail").value,
    };

    if (window.hcaptcha) {
      const captchaToken = await window.hcaptcha.execute(null, { async: true });
      requestBody["h-captcha-response"] = captchaToken.response;
    }

    const buttonText = event.target.closest('.drawer__account-content').querySelector('.drawer__submit-button .ButtonText');
    const loader = event.target.closest('.drawer__account-content').querySelector('.drawer__submit-button .itemLoader');

    buttonText.style.visibility = "hidden";
    loader.classList.add("is-visible");

    try {
      const response = await fetch(recoverEndpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestBody),
      });

      const responseText = await response.text();
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = responseText;
      const recoverError = this.element.querySelector("#recover .drawer__errors");
      const recoverSuccess = this.element.querySelector("#recover .account__form-success-msg");
      if (responseText.includes("account__recover-email-error")) {

        recoverSuccess.classList.remove("is-visible");
        recoverError.innerHTML = "";
        recoverError.innerHTML = tempDiv.querySelector("#account__recover-email-error").innerHTML;
        recoverError.classList.add("is-visible");
      } else if (responseText.includes("account__form-success-msg")) {

        recoverError.classList.remove("is-visible");
        recoverSuccess.innerHTML = "";
        recoverSuccess.innerHTML = tempDiv.querySelector("#account__form-success-msg").innerHTML;
        recoverSuccess.classList.add("is-visible");


      }

      buttonText.style.visibility = "visible";
      loader.classList.remove("is-visible");
    } catch (error) {
      console.error("An error occurred during the recovery request:", error);
    }
  }

  async submitRegistration(event) {
    event.preventDefault();
    const registrationEndpoint = `${window.routes.localeRootUrl}/account`;
    const requestBody = {
      customer: {
        first_name: this.element.querySelector("#RegisterForm-FirstName").value,
        last_name: this.element.querySelector("#RegisterForm-LastName").value,
        email: this.element.querySelector("#RegisterForm-email").value,
        password: this.element.querySelector("#RegisterForm-password").value,
      },
    };

    const buttonText = event.target.closest('.drawer__account-content').querySelector('.drawer__submit-button .ButtonText');
    const loader = event.target.closest('.drawer__account-content').querySelector('.drawer__submit-button .itemLoader');

    buttonText.style.visibility = "hidden";
    loader.classList.add("is-visible");


    const response = await fetch(registrationEndpoint, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestBody),
    });

    const responseText = await response.text();
    const registerEmailError = this.element.querySelector("#RegisterForm-email-error");
    const registerPasswordError = this.element.querySelector("#RegisterForm-password-error");

    if (responseText.indexOf("registerErrors") !== -1) {

      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = responseText;

      if (tempDiv.querySelector("#RegisterForm-email-error") !== -1) {
        registerEmailError.setAttribute("aria-hidden", "false");
        registerEmailError.innerHTML = "";
        registerEmailError.innerHTML = tempDiv.querySelector("#RegisterForm-email-error").innerHTML;
        this.element.querySelector("#RegisterForm-email").setAttribute("aria-invalid", "true");
      } else {
        this.element.querySelector("#RegisterForm-email").setAttribute("aria-invalid", "false");
        registerEmailError.setAttribute("aria-hidden", "true");
      }
      if (tempDiv.querySelector("#RegisterForm-password-error") !== -1) {
        registerPasswordError.setAttribute("aria-hidden", "false");
        registerPasswordError.style.display = "block";
        registerPasswordError.innerHTML = "";
        registerPasswordError.innerHTML = tempDiv.querySelector("#RegisterForm-password-error").innerHTML;
        this.element.querySelector("#RegisterForm-password").setAttribute("aria-invalid", "true");
      } else {
        registerPasswordError.setAttribute("aria-hidden", "true");
        this.element.querySelector("#RegisterForm-password").setAttribute("aria-invalid", "false");
      }
    } else {
      registerPasswordError.setAttribute("aria-hidden", "true");
      this.element.querySelector("#RegisterForm-email").setAttribute("aria-invalid", "false");
      this.element.querySelector("#RegisterForm-password").setAttribute("aria-invalid", "false");
      registerEmailError.setAttribute("aria-hidden", "true");
      location.href = window.routes.account_url;
    }

    buttonText.style.visibility = "visible";
    loader.classList.remove("is-visible");

  }

  async submitLogin(event) {
    event.preventDefault();
    const loginEndpoint = `${window.routes.localeRootUrl}/account/login`;
    const requestBody = {
      customer: {
        email: this.element.querySelector("#CustomerEmail").value,
        password: this.element.querySelector("#CustomerPassword").value,
      },
    };

    const buttonText = event.target.closest('.drawer__account-content').querySelector('.drawer__submit-button .ButtonText');
    const loader = event.target.closest('.drawer__account-content').querySelector('.drawer__submit-button .itemLoader');

    buttonText.style.visibility = "hidden";
    loader.classList.add("is-visible");

    try {
      const response = await fetch(loginEndpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestBody),
      });

      const responseText = await response.text();

      if (responseText.includes("loginError")) {
        const loginError = this.element.querySelector("#login .drawer__errors");
        loginError.innerHTML = "";
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = responseText;
        loginError.innerHTML =
            tempDiv.querySelector(".AlertError").innerHTML;
        loginError.classList.add("is-visible");
      } else {
        location.href = window.routes.account_url;
      }

      buttonText.style.visibility = "visible";
      loader.classList.remove("is-visible");
    } catch (error) {
      console.error("An error occurred during the login request:", error);
    }
  }

  toggleTab(event) {
    event.preventDefault();
    const id = event.target.dataset.id;
    const allTabs = this.element.querySelectorAll(".accountDrawer--Tab");
    const allContent = this.element.querySelectorAll(".drawer__account-content");

    allTabs.forEach((tab) => tab.setAttribute("aria-expanded", "false"));
    allContent.forEach((content) => content.setAttribute("aria-visible", "false"));

    event.target.setAttribute("aria-expanded", "true");
    const content = this.element.querySelector(`#${id}`);
    if (content) {
      content.setAttribute("aria-visible", "true");
    }
  }

  toggleRecovery(event) {
    event.preventDefault();
    const id = event.target.dataset.id;
    if (id === "recover") {
      this.element.querySelector("#recover").setAttribute("aria-visible", "true");
      this.element.querySelector("#login").setAttribute("aria-visible", "false");
      trapFocus(this.element.querySelector("#recover"));
    } else {
      this.element.querySelector("#recover").setAttribute("aria-visible", "false");
      this.element.querySelector("#login").setAttribute("aria-visible", "true");
      trapFocus(this.element.querySelector("#login"));
    }
  }
}

customElements.define("account-handler", AccountHandler);

let alreadyExits = false;
class LocalizationSelectors extends HTMLElement {
  constructor() {
    super();
    this.element = this;
  }

  connectedCallback() {
    new Popup(this.element, true);
    alreadyExits = true;
  }
}
customElements.define("localization-selectors", LocalizationSelectors);

class LocalizationModal extends HTMLElement {
  constructor() {
    super();
    this.element = this;
  }

  connectedCallback() {
    this.delegateBody = new Delegate(document.body);
    this.delegateElement = new Delegate(this.element);
    this.localizationOverlay = document.querySelector(".localizationOverlay");
    this.element.querySelectorAll('.RevolutionSelectbox').forEach(box => new RevolutionSelectbox(box));

    this.bindEvents();
  }

  bindEvents() {
    this.delegateBody.on("change:countrySelector", this.updateLanguageOptions.bind(this));
    this.delegateElement.on('keydown', '[data-action="select-language"]', this.selectLanguage.bind(this));
  }

  handleOpenOptions() {
    const localKey = localStorage.getItem("localization-popup-seen");

    if (localKey === "true") return;
    this.openLocalizationModal();
  }

  openLocalizationModal() {
    const modal = document.querySelector("#modal-country");

    modal.setAttribute("aria-hidden", false);
    this.localizationOverlay.classList.add("is-visible");

    bodyScrollLock.disableBodyScroll(modal, bodyScrollLockOptions);
    document.body.classList.add("scrollLock");

    this.localizationOverlay.addEventListener("click", () => {
      modal.setAttribute("aria-hidden", true);
      document.body.classList.remove("scrollLock");
      this.localizationOverlay.classList.remove("is-visible");
      bodyScrollLock.enableBodyScroll(modal, bodyScrollLockOptions);
    });

    localStorage.setItem("localization-popup-seen", true);
  }

  selectLanguage(e, target) {
    if (e.key === 'Enter') {
      target.previousElementSibling.checked = true;
    }
  }

  updateLanguageOptions(e) {
    const languagesJSON = e.detail.languages;
    const languages = JSON.parse(languagesJSON);

    const languageSelectbox = this.element.querySelector('.country-selector__dropdown--language .RevolutionSelectbox');
    const languageDropdown = languageSelectbox.querySelector('.RevolutionSelectbox--InnerContent');
    const languageInput = languageSelectbox.querySelector('input');

    const languageSelectboxClone = languageSelectbox.cloneNode(true);
    const selectboxCloneDropdown = languageSelectboxClone.querySelector('.RevolutionSelectbox--InnerContent');
    selectboxCloneDropdown.innerHTML = '';

    let selectedLanguage = null;
    languages.forEach((language) => {
      const selectboxItem = languageDropdown.firstElementChild.cloneNode();
      selectboxItem.dataset.value = language.iso;
      selectboxItem.dataset.name = language.name;
      selectboxItem.textContent = language.name;
      selectboxItem.removeAttribute('selected');

      if (e.detail.country && selectboxItem.dataset.value &&
          e.detail.country.toLowerCase() === selectboxItem.dataset.value.toLowerCase()) {
        languageInput.value = selectboxItem.dataset.value;
        selectboxItem.setAttribute('selected', 'selected');
        selectedLanguage = language;
      } else {
        selectedLanguage = null;
      }

      selectboxCloneDropdown.appendChild(selectboxItem);
    });

    languageSelectbox.parentElement.replaceChild(languageSelectboxClone, languageSelectbox);

    const newLanguageTitle = languageSelectboxClone.querySelector('.RevolutionSelectbox--Title');
    if (selectedLanguage) {
      newLanguageTitle.innerHTML = selectedLanguage.name;
    }

    new RevolutionSelectbox(languageSelectboxClone);
  }

}
customElements.define("localization-modal", LocalizationModal);



class RevolutionSelectboxV2 {
  constructor(element, bodyScrollable, absolutePositioning, parentIdentifier, identifier) {
    if (!element) return;
    this.element = element;
    this.bodyScrollable = bodyScrollable;
    this.absolutePositioning = absolutePositioning;
    this.identifier = identifier;

    this.isOpen = false;

    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    this.selectedValueSpan = this.element.querySelector(".option-selector__selected-option");
    this.dropdown = this.element.querySelector(".option-selector__content-dropdown");
    if (!this.dropdown) return;
    this.button = this.element.querySelector(".option-selector__button");
    this.selectorParent = this.element.closest(`${parentIdentifier}`);

    this.bindEvents();
    this.initSelectbox();
  }

  bindEvents() {
    this.onClickOutsideBinder = this.onClickOutside.bind(this);

    this.delegateElement.on("click", '[data-action="toggle-selectbox"]', this.toggleDropdown.bind(this));
    this.delegateElement.on("click", '[data-action="handle-select"]', this.handleSelect.bind(this));
    this.delegateBody.on("selectbox:close", this.closeDropdown.bind(this));
  }

  onClickOutside(e) {
    const withinBoundaries = e.composedPath().includes(this.element);
    if (!withinBoundaries) {
      this.closeDropdown(e);
    }
  }

  handleSelect(e, target) {
    e.preventDefault();

    this.selectedValueSpan.innerHTML = target.dataset.value;

    if (!this.selectedValueSpan.classList.contains('selected')) {
      this.selectedValueSpan.classList.add('selected');
    }
    this.dropdown.querySelector('.option-selector__option[selected="true"]').removeAttribute("selected");
    target.setAttribute("selected", "true");

    this.element.dispatchEvent(
        new CustomEvent("selectbox:change", {
          detail: {
            selectedValue: this.selectedValueSpan?.innerHTML || null,
            identifier: this.identifier || null,
          },
          bubbles: true
        })

    );

    this.closeDropdown();
  }

  initSelectbox() {
    if (this.absolutePositioning) {
      this.dropdown.classList.add('absolute');
    }

    this.animationOptions = {
      duration: 500,
      fill: "none",
      easing: "cubic-bezier(0.25, 1, 0.5, 1)"
    };
  }

  toggleDropdown(e) {
    e.preventDefault();
    if (this.isOpen) {
      this.closeDropdown(e);
    } else {
      this.openDropdown(e);
    }
  }

  checkElementBottomDistance() {
    if (this.element.id.includes("helper-recommendations")) {
      const distanceToBottom = window.innerHeight - this.button.getBoundingClientRect().bottom - 160;
      if (distanceToBottom < this.dropdown.offsetHeight) {
        this.dropdown.classList.remove('from-top');
        this.dropdown.classList.add('from-bottom');
      } else {
        this.dropdown.classList.remove('from-bottom');
        this.dropdown.classList.add('from-top');
      }
      if (this.dropdown.closest(".cart-drawer__rec-item")) {
        this.dropdown.closest(".cart-drawer__rec-item").style.zIndex = 3;
      }
    } else {
      this.dropdown.classList.add('from-top');
    }

    if (this.dropdown.closest(".cart-drawer__rec-item")) {
      this.dropdown.closest(".cart-drawer__rec-item").style.zIndex = 3;
    }

  }

  setAnimationSettings() {
    const originalStyles = {
      position: this.dropdown.style.position,
      visibility: this.dropdown.style.visibility,
      display: this.dropdown.style.display,
      pointerEvents: this.dropdown.style.pointerEvents,
      height: this.dropdown.style.height,
    };

    this.dropdown.style.position = "absolute";
    this.dropdown.style.visibility = "hidden";
    this.dropdown.style.display = "flex";
    this.dropdown.style.pointerEvents = "none";
    this.dropdown.style.height = "auto";

    const dropdownHeight = this.dropdown.offsetHeight;

    Object.keys(originalStyles).forEach((key) => {
      this.dropdown.style[key] = originalStyles[key];
    });

    this.expand = [
      { height: "0" },
      { height: dropdownHeight + "px" },
    ];

    this.retract = [
      { height: dropdownHeight + "px" },
      { height: "0" },
    ];
  }


  openDropdown(e) {
    e.preventDefault();

    if (this.isOpen) return;
    this.element.dispatchEvent(new CustomEvent('selectbox:close', { detail: this.bodyScrollable, bubbles: true }));

    this.delegateBody.on("click", "body", this.onClickOutsideBinder);
    if (this.bodyScrollable) this.onScroll = scrollListener.addScrollListener(this, this.closeDropdown.bind(this));

    this.dropdown.setAttribute("aria-hidden", false);
    if (this.absolutePositioning) {
      this.checkElementBottomDistance();
    } else {
      this.setAnimationSettings();
    }

    requestAnimationFrame(() => {
      this.dropdown.setAttribute("aria-expanded", "true")

      this.dropdown.style.width = this.button.getBoundingClientRect().width + 'px';
      if (!this.absolutePositioning) {
        this.animation = this.dropdown.animate(this.expand, this.animationOptions);
      }

      // If the body shouldn't be scrollable, disable body scroll
      if (!this.bodyScrollable) {
        const focus = this.element.querySelector('[data-scrollable]');
        bodyScrollLock.clearAllBodyScrollLocks();
        bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
      }
    });

    // If there are multiple dropdowns on the same level,
    if (this.selectorParent) {
      this.selectorParent.style.zIndex = '10';
    }

    if (this.selectorParent) {
      if (!this.absolutePositioning) {
        this.animation?.finished.then(() => {
          this.selectorParent.style.zIndex = '';
        });

        this.animation = null;
      } else {
        this.element.addEventListener("transitionend", (event) => {
          this.selectorParent.style.zIndex = '';
        }, { once: true });
      }
    }

    trapFocus(this.dropdown);
    this.isOpen = true;
  }

  closeDropdown() {

    if (!this.isOpen) return;
    this.delegateBody.off("click", "body", this.onClickOutsideBinder);
    if (this.bodyScrollable) this.onScroll?.removeScrollListener() && (this.onScroll = null);

    if (this.selectorParent) {
      this.selectorParent.style.zIndex = '';
    }

    this.dropdown.setAttribute("aria-expanded", "false")
    if (!this.absolutePositioning) {
      const animation = this.dropdown.animate(this.retract, this.animationOptions);

      animation.finished.then(() => {
        this.dropdown.setAttribute("aria-hidden", "true");
        this.isOpen = false;
      });
    } else {
      this.element.addEventListener("transitionend", (event) => {
        this.dropdown.setAttribute("aria-hidden", true);
        this.isOpen = false;
      }, { once: true });

      if (this.dropdown.closest(".cart-drawer__rec-item")) {
        this.dropdown.closest(".cart-drawer__rec-item").style.zIndex = 1;
      }

    }

    if (!this.bodyScrollable) {
      bodyScrollLock.clearAllBodyScrollLocks();
    }

    removeTrapFocus(this.mainDropdownContent);
  }
}

class ProductCard extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);

    this.quantityValue = document.querySelector(".product-card__form .quantity-product-card");
    new AddToCart(this.element);
  }

  connectedCallback() {
    this.variants = this.element.hasAttribute('data-has-variants');
    this.isDefault = this.element.hasAttribute('data-is-default');
    if (!this.variants) return;

    const variantSelectbox = this.element.querySelectorAll('.product-card__variant-options .option-selector');
    variantSelectbox.forEach(selector => new RevolutionSelectboxV2(selector, true, true, '.option-selector__wrapper', "variants"));

    this.bindEvents();
  }

  bindEvents() {
    this.delegateElement.on("selectbox:change", this.updateVariant.bind(this));
    this.delegateElement.on("click", '[data-action="open-menu"]', this.openMenu.bind(this));
    this.delegateElement.on("click", '[data-action="open-variants"]', this.openVariants.bind(this));
    this.delegateElement.on("click", '[data-action="pick-size"]', this.onPickSize.bind(this));
  }

  onPickSize(event, target) {
    event.preventDefault();
    event.stopPropagation();

    const item = target.closest('[data-action="pick-size"]');
    if (!item) return;

    const selector = item.closest(".option-selector");
    if (!selector) return;

    const prevSelected = selector.querySelector(
        '.option-selector__option[selected="true"]'
    );
    if (prevSelected) prevSelected.removeAttribute("selected");
    item.setAttribute("selected", "true");

    const title = selector.querySelector(".option-selector__selected-option");
    if (title) {
      title.innerHTML = item.innerHTML;
      title.classList.add("selected");
    }

    const quantityInput = this.element.querySelector(
        ".product-card__form .quantity-product-card"
    );
    if (quantityInput) {
      quantityInput.value = item.getAttribute("data-value");
      quantityInput.dispatchEvent(new Event("change", { bubbles: true }));
    }

    document.body.dispatchEvent(
        new CustomEvent("selectbox:close", { bubbles: true })
    );
  }

  updateVariant(e) {
    if (!this.variants) return;

    this.checkSelected();
  }

  openVariants(e) {
    e.preventDefault();

    const allPopups = document.querySelectorAll('.product-popup__content[aria-expanded="true"]');
    const currentPopup = this.element.querySelector('.product-popup__content');
    const productCard = this.element.querySelector('.product-card__link');

    allPopups.forEach(popup => {
      if (popup !== currentPopup) {
        const productCardOther = popup.closest('.product-card__link');
        if (productCardOther) {
          productCardOther.style.overflow = 'hidden';
        }

        popup.setAttribute('aria-expanded', 'false');

        popup.querySelectorAll('.option-selector__selected-option').forEach(option => {
          const placeholder = option.getAttribute('data-placeholder');
          option.classList.remove('selected');
          option.innerHTML = placeholder;
        });

        const addToCartButton = popup.querySelector('.product-card__atc-button');
        if (addToCartButton) {
          addToCartButton.setAttribute('data-check', 'false');
          addToCartButton.removeAttribute('disabled');
        }
      }
    });

    currentPopup.style.display = 'block';
    currentPopup.setAttribute('aria-expanded', 'true');

    setTimeout(() => {
      if (productCard) {
        productCard.style.overflow = 'visible';
      }
    }, 100);
  }

  checkSelected() {
    const selector = '.option-selector__selected-option:not(.pack-selector .option-selector__selected-option)';
    const options = (this.isDefault && responsive.matchesBreakpoint('lap_and_up'))
        ? this.element.querySelector('.product-popup__content').querySelectorAll(selector)
        : this.element.querySelectorAll(selector);

    const allChecked = Array.from(options).every(option =>
        option.classList.contains('selected')
    );

    if (allChecked) {
      this.updateMasterId();
    }
  }

  updateMasterId() {
    const options = (this.isDefault && responsive.matchesBreakpoint('lap_and_up'))
        ? this.updateOptionsDesktop()
        : this.updateOptions();

    if (this.variants) {
      const variantJson = this.element.querySelector('[type="application/json"]');
      if (variantJson) {
        this.variantData = JSON.parse(variantJson.textContent);
      }
    }

    this.currentVariant = this.variantData?.find(variant =>
        options.every(option => variant.options.includes(option))
    );

    if(this.currentVariant){

      const currentPopup = this.isDefault
          ? this.element.querySelector('.product-popup__content')
          : this.element.querySelector('.product-card__cart-wrapper-link');

      const isSecondOption = this.currentVariant.option2

      this.quantityValue = currentPopup.querySelector(".quantity-product-card")

      if(isSecondOption){
        const isMultipack = this.currentVariant.option2.toLowerCase().includes("-");


        const firstOptions = this.variantData.find(v => {
          const hasFirstOption = v.option1 === this.currentVariant.option1;
          const hasMultipack = v.option2 && v.option2.toLowerCase().includes("1");
          return hasFirstOption && hasMultipack;
        });


        if(isMultipack) {

          const getPackQty = (str) => +(str.match(/\d+/)?.[0] ?? 1);
          const number =  getPackQty(this.currentVariant.option2.split("-")[0]);

          if(this.element.parentElement.classList.contains("cart-drawer__rec-item")){
            this.element.parentElement.querySelector('[name="quantity"]').value = number;
          }

          if(this.quantityValue){
            this.quantityValue.value = number;
          }

          this.currentVariant = firstOptions;
        }
      }



      this.variantInput = currentPopup.querySelector('.product-card__form input[name="id"]');

      if (responsive.matchesBreakpoint('lap_and_up') && currentPopup && this.currentVariant) {
        const addToCartButton = currentPopup.querySelector('.product-card__atc-button');

        if (this.currentVariant.available) {
          this.variantInput.value = this.currentVariant.id;
          addToCartButton.removeAttribute('disabled');
          addToCartButton.setAttribute('data-check', 'true');
        } else {
          addToCartButton.setAttribute('disabled', 'true');
          addToCartButton.setAttribute('data-check', 'false');
        }
      }

      if(this.element.parentElement.classList.contains("cart-drawer__rec-item")){
        const addToCartButton = currentPopup.querySelector('.product-card__atc-button');

        if (this.currentVariant.available) {
          this.variantInput.value = this.currentVariant.id;
          addToCartButton.removeAttribute('disabled');
          addToCartButton.setAttribute('data-check', 'true');
        } else {
          addToCartButton.setAttribute('disabled', 'true');
          addToCartButton.setAttribute('data-check', 'false');
        }
      }
    }
  }

  updateOptions() {
    return Array.from(this.element.querySelectorAll('.product-card__variant-options .option-selector__selected-option:not(.pack-selector .option-selector__selected-option)')).map(option => option.textContent.trim());
  }

  updateOptionsDesktop() {
    const currentPopup = this.element.querySelector('.product-popup__content');
    return Array.from(currentPopup.querySelectorAll('.product-card__variant-options .option-selector__selected-option:not(.pack-selector .option-selector__selected-option)')).map(option => option.textContent.trim());
  }

  openMenu(event) {
    event.preventDefault();
    const targetElement = this.element;
    const cartContainer = document.body.querySelector("#cart-drawer");

    if (cartContainer) {
      const variantsContainerAll = cartContainer.querySelectorAll('.product-card__variant-options');

      variantsContainerAll.forEach((item) => {
        // Skip the one we're about to open
        if (targetElement.contains(item)) return;

        // Only apply transition logic to the currently visible one
        if (item.getAttribute('aria-hidden') === 'false') {
          item.setAttribute('aria-hidden', 'true');

          // Wait for transition to finish, then hide
          const onEnd = (e) => {
            if (e.propertyName === 'height' || e.propertyName === 'opacity') {
              item.style.display = 'none';
              item.removeEventListener('transitionend', onEnd);
            }
          };
          item.addEventListener('transitionend', onEnd);
        }

        // Reset UI state (placeholders and buttons)
        const btn = item.parentElement.querySelector('.product-card__atc-button');
        const placeholderContainer = item.querySelectorAll('.option-selector__selected-option');
        placeholderContainer.forEach((placeholder) => {
          const placeholderText = placeholder.getAttribute('data-placeholder');
          placeholder.classList.remove('selected');
          placeholder.innerHTML = placeholderText;
        });
        btn.setAttribute('data-action', 'open-menu');
        btn.setAttribute('data-check', 'false');
      });
    }

    // Open the current one
    const variantsContainer = this.element.querySelector('.product-card__variant-options');
    if (variantsContainer) {
      variantsContainer.style.display = 'flex';
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          variantsContainer.setAttribute('aria-hidden', 'false');
        });
      });
    }

    setTimeout(() => {
      const target = event.target;
      target.setAttribute('data-action', 'add-to-cart');
      target.setAttribute('data-check', 'false');
    }, 100);
  }

  renderContent(e) {
    this.variants = this.element.querySelector('.product-card__variant-options');
    this.variantInput = this.element.querySelector('.product-card__form input[name="id"]');

    if (this.variants) {
      const variantJson = this.element.querySelector('[type="application/json"]');
      if (variantJson) {
        this.variantData = JSON.parse(variantJson.textContent);
      }
    }

    this.currentVariant = this.variantInput.value;

    const variantSelectboxes = this.element.querySelectorAll('.product-card__variant-options .option-selector');
    variantSelectboxes.forEach(selector => {
      new RevolutionSelectboxV2(selector, true, true, '.option-selector__wrapper', 'variants');
    });
  }
}
customElements.define("product-card", ProductCard);


class AnimatedAnnouncementBar extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.closeButton = this.element.querySelector('.announcement-bar__close');
    this.announcementBar = document.querySelector(".announcement-bar");
    document.documentElement.style.setProperty("--announcement-height-fixed", this.element.clientHeight + "px");

    this.options = JSON.parse(this.element.getAttribute("data-section-settings"));
    this.annItemCount = Number(this.options.annItemCount);
    this.transitionSpeed = Number(this.options.transitionSpeed);

    this.animWrapper = this.element.querySelector('.announcement-bar__anim-wrapper');
    this.original = this.element.querySelector('.announcement-bar__duplicate-wrapper');
    this.firstLoad = true;

    this.updateVisibleHeight();

    if (sessionStorage.getItem("annBarHidden", true)) {
      this.element.classList.add("announcement-bar--hidden");
      document.documentElement.style.setProperty("--announcement-dynamic-height", `0px`);
    } else {
      this.hideListener = this.hide.bind(this);
    }

    this.bindEvents();
  }

  bindEvents() {
    window.addEventListener("scroll", this.updateVisibleHeight.bind(this));
    window.addEventListener("resize", this.updateVisibleHeight.bind(this));

    const debouncedFunc = debounce(this.handleBreakpointChange.bind(this), 100);
    responsive.addResizeListener(this, debouncedFunc);
    this.handleBreakpointChange();

    if (this.element.dataset.main == 'true') {
      scrollListener.addScrollListener(this, this.updateVisibleHeight.bind(this));
      responsive.addResizeListener(this, this.updateVisibleHeight.bind(this));
    }

    if (this.hideListener) {
      this.delegateElement.on(
          'click',
          '[data-action="ann-bar-close"]',
          this.hideListener
      );
    }
  }

  hide() {
    this.element.classList.add("announcement-bar--hidden");
    sessionStorage.setItem("annBarHidden", true);
    document.documentElement.style.setProperty("--announcement-dynamic-height", `0px`);
  }

  updateVisibleHeight() {
    const rect = this.element.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    // Calculate the visible height
    let visibleHeight = Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0);

    // Ensure the visibleHeight is never negative
    visibleHeight = Math.max(visibleHeight, 0);

    // Update the height of .announcement-bar with the visible height
    document.documentElement.style.setProperty("--announcement-dynamic-height", `${visibleHeight}px`);
  }


  handleBreakpointChange() {
    if (responsive.matchesBreakpoint("lap_and_up")) {
      this.mobile = false;
      this.animationEnabled = JSON.parse(this.options.enableAnimation);

      if (this.transitionSpeed && this.animationEnabled) {
        this.duplicateBlockWrappers();
      } else {
        Array.from(this.original.children).forEach((block, i) => block.style.display = 'flex');
        this.original.style.justifyContent = 'space-between';
      }
    } else {
      this.mobile = true;
      this.animationEnabled = JSON.parse(this.options.enableAnimation);
      if (this.transitionSpeed && this.annItemCount > 1 && this.animationEnabled) {
        this.duplicateBlockWrappers();
      } else {
        const blocks = this.original.querySelectorAll('.announcement-bar__block');
        blocks.forEach((block, i) => {
          block.style.display = i === 0 ? 'flex' : 'none';
        });
        this.original.style.justifyContent = 'center';
      }
    }
  }

  resetWrapper() {
    Array.from(this.animWrapper.children).forEach((child, i) => { if (i != 0) this.animWrapper.removeChild(this.animWrapper.lastChild) });
    this.originalNew = this.element.offsetWidth - (parseInt(getComputedStyle(this.element).paddingLeft) * 2);
  }

  duplicateBlockWrappers() {
    this.resetWrapper();
    const duplicate = this.original.cloneNode(true),
        spaceDiv = document.createElement('div');

    var originalWidth = originalWidth = this.original.offsetWidth;
    if (this.originalNew) originalWidth = this.originalNew;

    if (this.mobile) {
      const children = Array.from(this.original.children);
      const totalWidth = children.reduce((acc, child) => acc + child.offsetWidth, 0);

      duplicate.style.width = totalWidth + 'px';
      this.original.style.width = totalWidth + 'px';
      this.animWrapper.style.width = (2 * totalWidth) + 'px';

      this.spaceDivWidth = 0;
    }
    else {
      if (this.original.children.length >= 2) this.spaceDivWidth = this.getDistanceBetweenBlocks(this.original.children[0], this.original.children[1])
      else this.spaceDivWidth = 0;

      duplicate.style.width = originalWidth + 'px';
      this.original.style.width = originalWidth + 'px';
      this.animWrapper.style.width = (2 * originalWidth + this.spaceDivWidth) + "px";
    }

    spaceDiv.style.width = this.spaceDivWidth + 'px';
    this.animWrapper.style.position = "absolute";
    if (this.mobile && this.firstLoad) this.animWrapper.style.transform = `translateX(${this.spaceDivWidth / 2}px)`;

    this.element.style.height = this.animWrapper.offsetHeight + 'px';

    this.animWrapper.appendChild(spaceDiv);
    this.animWrapper.appendChild(duplicate);

    setTimeout(() => {
      this.startAnimating();
    }, 100);
  }

  startAnimating() {
    var translate;
    this.mobile && this.firstLoad ? translate = this.spaceDivWidth / 2 : translate = 0;
    this.firstLoad = false;

    this.animWrapper.animate(
        [
          { transform: `translateX(${translate}px)` },
          { transform: `translateX(calc(-50% - ${this.spaceDivWidth / 2}px))` }
        ],
        {
          duration: parseInt(this.transitionSpeed) * 1000,
          iterations: Infinity,
          fill: 'forwards',
          easing: 'linear'
        }
    );
  }

  getDistanceBetweenBlocks(blockOne, blockTwo) {
    return blockTwo.getBoundingClientRect().left - blockOne.getBoundingClientRect().right;
  }
}
customElements.define("announcement-bar", AnimatedAnnouncementBar);


class QuoteSlider extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.carouselElement = this.element.querySelector(".swiper");
    this.carousel = new RevolutionSwiper(this.carouselElement);
  }
}

customElements.define("quote-slider", QuoteSlider);


let contentCache = {};
let contentCacheUrl = {};
class CollectionSwiper extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.swiperElement = this.element.querySelector(".swiper");
    this.loadType = this.swiperElement.getAttribute("data-load");

    if (this.swiperElement) {
      new RevolutionSwiper(this.swiperElement);
    }

    this.bindEvents();
  }

  bindEvents() {
    window.addEventListener(
        "DOMContentLoaded", this.reloadWithoutRefresh.bind(this)
    );

    this.delegateElement.on(
        `click`,
        `.collection-link`,
        this.handleReloadClick.bind(this));
  }

  handleReloadClick(event) {
    event.preventDefault();
    const url = event.target.href;
    const currentSlide = event.target.closest(".swiper-slide");

    const allSlider = document.querySelectorAll(".swiper-slide");

    allSlider.forEach((slide) => {
      if (slide !== currentSlide) {
        slide.classList.remove("is-active");
      }
    });
    currentSlide.classList.add("is-active");
    this.updateContentWithoutReload(url);
  }

  updateContentWithoutReload(url) {
    // Show loader while switching collections
    const loader = document.querySelector(".spinningLoader.collection");
    if (loader) {
      loader.classList.add("is-visible");
    }

    const htmlContent = contentCache[url];

    if (htmlContent) {
      // Get the main collection grid element
      const collectionGridElement = document.querySelector(`main-collection-grid`);

      // Replace its content with the cached content
      collectionGridElement.innerHTML = htmlContent.innerHTML;

      // Update URL in browser
      history.pushState(null, null, url);


      // Now we need to re-initialize the collection grid
      if (this.loadType !== 'button') this.reinitializeCollectionGrid(collectionGridElement);

      // Hide loader after everything is done
      if (loader) {
        setTimeout(() => {
          loader.classList.remove("is-visible");
        }, 1000);
      }
    } else {
      // If not in cache, navigate to the URL
      window.location.href = url;
    }
  }

  reinitializeCollectionGrid(gridElement) {

    // Reset the collectionGrid instance properties
    // First, trigger a custom event that the collection grid can listen for
    const reinitEvent = new CustomEvent('collection:switched', {
      detail: { url: window.location.href }
    });
    gridElement.dispatchEvent(reinitEvent);

    // The current page should be reset to 1 when switching collections
    if (gridElement.gridElement) {
      gridElement.gridElement.setAttribute('data-current-page', '1');
    }

    // If the collection grid has its own initialize method, call it
    if (typeof gridElement.initialize === 'function') {
      gridElement.initialize();
    }

    // Reset any current page indicators
    const viewInfo = document.querySelector(".view-info");


    const searchResultsTemplate = document.querySelector(".template-search__results");
    const paginationSettings = document.querySelector(".main-search__pagination-settings");

    if (searchResultsTemplate && viewInfo && paginationSettings) {
      const perPage = parseInt(paginationSettings.getAttribute('data-per-page'));
      const totalProducts = parseInt(paginationSettings.dataset.all);
      viewInfo.innerHTML = `${window.languages.view_product} ${perPage} ${window.languages.of} ${totalProducts} ${window.languages.products}.`;
    }

    // Make sure the load more button is visible again
    const loadMoreContainer = document.querySelector(".infinite-scroll");
    if (loadMoreContainer) {
      loadMoreContainer.style.display = "block";
    }
  }

  reloadWithoutRefresh() {
    let filterLinks = this.element.querySelectorAll('.collection-link');
    let urlsToFetch = Array.from(filterLinks).map(link => link.href);

    const fetchAndCacheContent = async (url) => {
      try {
        const response = await fetch(url);

        if (response.ok) {
          const htmlContent = await response.text();
          contentCache[url] = new DOMParser()
              .parseFromString(htmlContent, "text/html")
              .querySelector("main-collection-grid");
        } else {
          console.error('Error fetching data. HTTP status:', response.status);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    // Fetch content for all pdpLinks when the page loads
    urlsToFetch.forEach((url) => {
      fetchAndCacheContent(url);
    });
  }
}

customElements.define("collection-swiper", CollectionSwiper);

// Create a global content cache if it doesn't exist
if (typeof window.contentCacheData === 'undefined') {
  window.contentCacheData = {};
}

// The issue is that handleClick always reads the current page from the URL, which never changes when you click "Load More" (unless you navigate). 
// So it always thinks you're on page 1, and always loads page 2. 
// The fix is to track the current page in the instance, and increment it on each click, not re-read from the URL.

class MainSearch extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    // Get current page from URL
    const urlParams = new URLSearchParams(window.location.search);
    this.currentPage = parseInt(urlParams.get('page') || '1', 10);
    this.totalPages = 1;
    this.isLoading = false;
    this.hasMore = true;

    this.searchTypes = [
      { id: "#mainGrid" }
    ];
  }

  connectedCallback() {
    this.filterBar = this.element.querySelector(".collection__header");
    this.loadType = this.element.dataset.load;

    new AddToCart(this.element);
    this.delegateElement = new Delegate(this.element);

    // Handle browser navigation
    window.addEventListener('popstate', (event) => {
      const urlParams = new URLSearchParams(window.location.search);
      const page = parseInt(urlParams.get('page') || '1', 10);

      this.currentPage = page;
      this.rebuildContent();
    });

    // Check if we need to prefetch all pages on initial load
    this.initialize();
    this.prefetchAllPages();
  }

  initialize() {
    if (this.loadType === "scroll") {
      this.bindObservers();
    } else {
      this.delegateElement.on("click", '.infinite-scroll', this.handleClick.bind(this));
    }
  }

  async prefetchAllPages() {
    // Get the view-info element to determine total products/pages
    const searchResultsTemplate = document.querySelector(".template-search__results");

    if (!searchResultsTemplate) return;
    this.totalPages = parseInt(searchResultsTemplate.dataset.pageCount || '1');

    // Don't fetch if we only have one page
    if (this.totalPages <= 1) return;

    const pagesToFetch = [];
    // Start from page 2 since page 1 is already loaded
    for (let i = 2; i <= this.totalPages; i++) {
      const pageUrl = this.getUrlForPage(i);
      pagesToFetch.push({ page: i, url: pageUrl });
    }

    // Fetch all pages in background
    pagesToFetch.forEach(pageData => {
      this.prefetchAndCachePage(pageData.url, pageData.page);
    });

    // If we're on a page > 1, rebuild the content
    if (this.currentPage > 1) {
      this.rebuildContent();
    }
  }

  getUrlForPage(pageNum) {
    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.delete("page");
    if (pageNum > 1) {
      currentUrl.searchParams.set("page", pageNum.toString());
    }
    return currentUrl.toString();
  }

  async prefetchAndCachePage(url, pageNum) {
    // Skip if already cached
    if (window.contentCacheData[url]) {
      return window.contentCacheData[url];
    }

    try {
      const response = await fetch(url);

      if (response.ok) {
        const text = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(text, 'text/html');

        // Extract and store the product grid items
        const gridItems = doc.getElementById('mainGrid');

        if (gridItems) {
          window.contentCacheData[url] = {
            gridItems: gridItems.innerHTML,
            buttonItem: doc.getElementById('infinite-scroll')
          };
          return window.contentCacheData[url];
        }
      }
    } catch (error) {
      console.error(`Error fetching page ${pageNum}:`, error);
    }

    return null;
  }

  async handleClick(e) {
    e.preventDefault();

    if (this.isLoading) return;
    this.isLoading = true;

    const loader = document.querySelector(".spinningLoader.collection");
    if (loader) {
      loader.classList.add("is-active");
    }

    // Instead of reading from URL, use the instance's currentPage
    const nextPage = this.currentPage + 1;
    const url = this.getUrlForPage(nextPage);

    await this.loadNextPage(url, nextPage);
  }

  bindObservers() {
    if (this.isLoading) return;

    const observerOptions = {
      root: null,
      rootMargin: "0px",
      threshold: 0.25,
    };

    // Get the container
    const container = document.getElementById('mainGrid');
    if (!container || container.children.length === 0) return;

    // Get the last item as the trigger point
    const target = container.children[container.children.length - 1];
    if (!target) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !this.isLoading && this.hasMore) {
          observer.unobserve(target);

          // Use the instance's currentPage, not the URL
          const nextPage = this.currentPage + 1;

          if (nextPage <= this.totalPages) {
            const url = this.getUrlForPage(nextPage);

            const loader = document.querySelector(".spinningLoader.collection");
            if (loader) {
              loader.classList.add("is-active");
            }

            this.loadNextPage(url, nextPage);
          }
        }
      });
    }, observerOptions);

    observer.observe(target);
  }

  async loadNextPage(url, pageNum) {
    this.isLoading = true;

    try {
      // Check if we have this page cached
      let pageData = window.contentCacheData[url];

      if (!pageData) {
        // If not cached, fetch it
        pageData = await this.prefetchAndCachePage(url, pageNum);
      }

      if (pageData) {
        // Append the items to the grid
        const mainGrid = document.getElementById('mainGrid');

        // Add new content
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = pageData.gridItems;

        // Extract and append only the direct children (product items)
        Array.from(tempDiv.children).forEach(item => {
          mainGrid.appendChild(item.cloneNode(true));
        });

        // Update UI elements
        this.updateUIAfterLoad(pageNum);

        // Update current page
        this.currentPage = pageNum;
      }
    } catch (error) {
      console.error(`Error loading page ${pageNum}:`, error);
    } finally {
      // Hide loader
      const loader = document.querySelector(".spinningLoader.collection");
      if (loader) {
        setTimeout(() => {
          loader.classList.remove("is-active");
        }, 500);
      }

      this.isLoading = false;

      // Re-bind observers for infinite scroll
      if (this.loadType === "scroll" && this.currentPage < this.totalPages) {
        setTimeout(() => {
          this.bindObservers();
        }, 100);
      }
    }
  }

  updateUIAfterLoad(pageNum) {
    // Update the view-info element
    const viewInfo = document.querySelector(".view-info");
    const searchResultsTemplate = document.querySelector(".template-search__results");
    if (searchResultsTemplate) {
      const allProducts = parseInt(searchResultsTemplate.dataset.all);
      const itemsPerPage = parseInt(searchResultsTemplate.dataset.items);
      const totalPages = parseInt(searchResultsTemplate.dataset.pageCount);

      // Calculate viewed products
      let viewedItems;
      if (pageNum >= totalPages) {
        viewedItems = allProducts;
        this.hasMore = false;
      } else {
        viewedItems = Math.min(itemsPerPage * pageNum, allProducts);
        this.hasMore = true;
      }

      if (viewInfo) viewInfo.innerHTML = `${window.languages.view_product} ${viewedItems} ${window.languages.of}  ${allProducts} ${window.languages.products}.`;
    }

    // Update or hide the infinite scroll button
    const button = document.getElementById("infinite-scroll");
    if (button) {
      if (pageNum >= this.totalPages) {
        // Hide button on last page
        button.style.display = "none";
        this.hasMore = false;
      } else {
        // Update button data
        button.dataset.page = (pageNum + 1).toString();

        // For click-based loading, make sure button is visible
        if (this.loadType !== "scroll") {
          button.style.display = "block";
        }
      }
    }
  }

  async rebuildContent() {
    // Only update this.currentPage from the URL on full navigation
    const mainGrid = document.getElementById('mainGrid');
    if (!mainGrid) return;

    const urlParams = new URLSearchParams(window.location.search);
    this.currentPage = parseInt(urlParams.get('page') || '1', 10);

    const loader = document.querySelector(".spinningLoader.collection");
    if (loader) {
      loader.classList.add("is-active");
    }

    try {
      // Get the original content (page 1)
      const originalContent = mainGrid.getAttribute('data-original-content') || mainGrid.innerHTML;

      // Store original content if not already stored
      if (!mainGrid.getAttribute('data-original-content')) {
        mainGrid.setAttribute('data-original-content', originalContent);
      }

      // Clear grid
      mainGrid.innerHTML = '';
      if (this.currentPage === 1) {
        mainGrid.innerHTML = originalContent;
      } else {
        // Start with original content
        mainGrid.innerHTML = originalContent;

        // Add content for pages 2 to current page
        for (let i = 2; i <= this.currentPage; i++) {
          const pageUrl = this.getUrlForPage(i);
          const pageData = window.contentCacheData[pageUrl];

          if (pageData) {
            // Create a temporary container to extract children
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = pageData.gridItems;

            // Extract and append only the direct children (product items)
            Array.from(tempDiv.children).forEach(item => {
              mainGrid.appendChild(item.cloneNode(true));
            });
          } else {
            // If page not cached yet, fetch it synchronously
            await this.prefetchAndCachePage(pageUrl, i);
            const newPageData = window.contentCacheData[pageUrl];

            if (newPageData) {
              // Create a temporary container
              const tempDiv = document.createElement('div');
              tempDiv.innerHTML = newPageData.gridItems;

              // Extract and append items
              Array.from(tempDiv.children).forEach(item => {
                mainGrid.appendChild(item.cloneNode(true));
              });
            }
          }
        }

        // Update UI elements
        this.updateUIAfterLoad(this.currentPage);
      }
    } catch (error) {
      console.error("Error rebuilding content:", error);
    } finally {
      // Hide loader
      if (loader) {
        setTimeout(() => {
          loader.classList.remove("is-active");
        }, 500);
      }

      // Re-bind observers for infinite scroll
      if (this.loadType === "scroll" && this.currentPage < this.totalPages) {
        setTimeout(() => {
          this.bindObservers();
        }, 100);
      }
    }
  }
}

customElements.define("search-component", MainSearch);